export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends {
    [key: string]: unknown;
}> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    Date: any;
    DateTime: any;
    Duration: any;
    EmailAddress: any;
    GraphQLDouble: any;
    GraphQLLong: any;
    JSON: any;
    JSONObject: any;
    Json: any;
    LocalDate: any;
    LocalDateTime: any;
    LocalTime: any;
    Long: any;
    NonEmptyString: any;
    NonNegativeFloat: any;
    NonNegativeInt: any;
    PhoneNumber: any;
    Time: any;
    Timestamp: any;
    URL: any;
    USCurrency: any;
    Void: any;
    ZipCode: any;
    _FieldSet: any;
};
/*
 * -------------------------------------------------------
 * THIS FILE WAS AUTOMATICALLY GENERATED (DO NOT MODIFY)
 * -------------------------------------------------------
 */
/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ABAD = {
    __typename?: "ABAD";
    body: Scalars["String"];
    buttonText: Scalars["String"];
    header: Scalars["String"];
    version: Maybe<Scalars["Int"]>;
};
export type ActivateBlendLoanOutput = {
    __typename?: "ActivateBlendLoanOutput";
    blend_activation_url: Maybe<Scalars["String"]>;
    success: Maybe<Scalars["Boolean"]>;
};
export type AdditionalHomesDetail = {
    __typename?: "AdditionalHomesDetail";
    alertTextError: Scalars["String"];
    alertTextInfo: Scalars["String"];
    body: Scalars["String"];
    buttonTextAddProperty: Scalars["String"];
    buttonTextContinue: Scalars["String"];
    buttonTextRemoveProperty: Scalars["String"];
    heading: Scalars["String"];
    title: Scalars["String"];
};
/** Street location */
export type Address = {
    __typename?: "Address";
    city: Maybe<Scalars["String"]>;
    community: Maybe<Scalars["String"]>;
    directionalPrefix: Maybe<Scalars["String"]>;
    directionalSuffix: Maybe<Scalars["String"]>;
    houseFractionNumber: Maybe<Scalars["String"]>;
    houseNumber: Maybe<Scalars["String"]>;
    neighborhood: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    /** formatted house and unit number on street */
    streetAddress: Maybe<Scalars["String"]>;
    streetSuffix: Maybe<Scalars["String"]>;
    subdivision: Maybe<Scalars["String"]>;
    unitNumber: Maybe<Scalars["String"]>;
    unitPrefix: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type AffordabilityEstimate = {
    __typename?: "AffordabilityEstimate";
    /** The flag that lets clients know whether or not to display the Monthly Cost Calculator for that property */
    showMonthlyCostCalculator: Maybe<Scalars["Boolean"]>;
    /** The flag that lets clients know whether or not to display the Mortgage Chip for that property */
    showMortgageChip: Maybe<Scalars["Boolean"]>;
    /** This flag is set to true if the user has the Personalized Payment MVP, does not apply to iOS */
    showPencilIconForPPMVP: Maybe<Scalars["Boolean"]>;
    /** The total estimated payment per month = propertyTax + homeownersInsurance + principalAndInterest+ hoaFees */
    totalMonthlyCost: Maybe<Scalars["Float"]>;
};
export type AffordabilityEstimateBreakdown = {
    __typename?: "AffordabilityEstimateBreakdown";
    /** The HOA fees portion of the estimated monthly payment */
    hoaFees: Maybe<Scalars["Float"]>;
    /** The homeowners Insurance portion of the estimated monthly payment */
    homeownersInsurance: Maybe<Scalars["Float"]>;
    /** The principal & Interest portion of the estimated monthly payment */
    principalAndInterest: Maybe<Scalars["Float"]>;
    /** The PMI portion of the estimated monthly payment */
    privateMortgageInterest: Maybe<Scalars["Float"]>;
    /** The property tax portion of the estimated monthly payment */
    propertyTax: Maybe<Scalars["Float"]>;
};
export type AffordabilityEstimateInputs = {
    __typename?: "AffordabilityEstimateInputs";
    /**
     * The downPayment amount used to get mortgage interest rates as well as
     * determining PMI if applicable. This will be from mortgage preferences
     * specified by the user or a default of 20% of the property price if no
     * preferencs are given
     */
    downPaymentAmount: Maybe<Scalars["Float"]>;
    /** The downPayment amount represented as percentage of the property price */
    downPaymentPercent: Maybe<Scalars["Float"]>;
    /** True if the user's financial profile was the source of parameters, false otherwise */
    fromFinancialProfile: Maybe<Scalars["Boolean"]>;
    /** Set to true if the downpayment used was in percentage of the price, false if the downpayment used is in dollar amount */
    isDownpaymentPreferencePercent: Maybe<Scalars["Boolean"]>;
};
export type AffordabilityStep = {
    __typename?: "AffordabilityStep";
    stepInformation: Scalars["String"];
};
export type AgentCare = {
    __typename?: "AgentCare";
    email: Maybe<Scalars["String"]>;
    phone: Maybe<Scalars["String"]>;
};
export type AgentCompensation = {
    __typename?: "AgentCompensation";
    /**
     * **Definition:** fixed amount of compensation. For TouringAgreements, this is expected to be 0
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    fixedAmount: Maybe<Scalars["Int"]>;
};
export type AgentParticipant = {
    __typename?: "AgentParticipant";
    /**
     * **Definition:** The confirmation status of the agent participant. This field is 'true' if the agent participant status is 'accepted'
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    isConfirmed: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** The pending status of the agent participant. This field is 'true' if the agent participant status is 'pending'
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    pending: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    zuid: Maybe<Scalars["Int"]>;
};
export type AgentProfile = {
    __typename?: "AgentProfile";
    /**
     * **Definition:** Agent office city
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    officeCity: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Agent office state
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    officeState: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Agent profile url
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    profileUrl: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The average rating of the agent
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    ratingAverage: Maybe<Scalars["Float"]>;
    /**
     * **Definition:** The number of rating the agent has
     * **Datasource:** User Data Service (UDS)
     *
     * **Team Slack:** #sea-agent-data-team
     */
    ratingCount: Maybe<Scalars["Int"]>;
};
export type AgentTourView = {
    __typename?: "AgentTourView";
};
export type AgentTourViewAlert = {
    __typename?: "AgentTourViewAlert";
    eventTime: Maybe<Scalars["String"]>;
};
export type AgentTourViewCTAAddToCalendar = {
    __typename?: "AgentTourViewCTAAddToCalendar";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTABookTour = {
    __typename?: "AgentTourViewCTABookTour";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTACallContact = {
    __typename?: "AgentTourViewCTACallContact";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTACancelTour = {
    __typename?: "AgentTourViewCTACancelTour";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTAEditTour = {
    __typename?: "AgentTourViewCTAEditTour";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTARespond = {
    __typename?: "AgentTourViewCTARespond";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTAShowingTimeBook = {
    __typename?: "AgentTourViewCTAShowingTimeBook";
    isPrimary: Maybe<Scalars["Boolean"]>;
};
export type AgentTourViewCTAs = {
    __typename?: "AgentTourViewCTAs";
};
export type AgentTourViewHeader = {
    __typename?: "AgentTourViewHeader";
};
export type AgentTourViewIcon = {
    __typename?: "AgentTourViewIcon";
};
export type AgentTourViewText = {
    __typename?: "AgentTourViewText";
};
export type AgentTourViewTourDetails = {
    __typename?: "AgentTourViewTourDetails";
};
export type AgentTourViewTourTime = {
    __typename?: "AgentTourViewTourTime";
};
/** Detail list of building amenities */
export type AmenityDetails = {
    __typename?: "AmenityDetails";
    buildingAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    fees: Maybe<Array<Maybe<Scalars["String"]>>>;
    hours: Maybe<Array<Maybe<Scalars["String"]>>>;
    isSmokeFree: Maybe<Scalars["Boolean"]>;
    leaseTerms: Maybe<Array<Maybe<Scalars["String"]>>>;
    petDetails: Maybe<Array<Maybe<Scalars["String"]>>>;
    pets: Maybe<Array<Maybe<Scalars["String"]>>>;
    unitFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
};
/** Summary list of high priority building ammenities */
export type AmenitySummary = {
    __typename?: "AmenitySummary";
    buildingDetails: Maybe<Array<Maybe<Scalars["String"]>>>;
    cooling: Maybe<Array<Maybe<Scalars["String"]>>>;
    heating: Maybe<Array<Maybe<Scalars["String"]>>>;
    laundry: Maybe<Array<Maybe<Scalars["String"]>>>;
    outdoor: Maybe<Array<Maybe<Scalars["String"]>>>;
    parking: Maybe<Array<Maybe<Scalars["String"]>>>;
    pets: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type AppointmentVisibility = {
    __typename?: "AppointmentVisibility";
    /**
     * **Definition:** A list of external auth providers for the account of the buyer zuid associated with the tourAppointment
     *
     * **Source:** Appointments API and Account Service
     *
     * **No Auth**
     *
     * **Example: ** ["Google", "Apple"]
     */
    externalAuthProviders: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * **Definition:** This field is true if the account of the buyer zuid associated with the tourAppointment has a password.
     *
     * **Source:** Appointments API and Account Service
     *
     * **No Auth**
     */
    hasPassword: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** This field is true if the zuid of the logged in account is the same as the buyer zuid associated with the tourAppointment, and false otherwise.
     * This field is also false if Beth is not logged in.
     *
     * **Source:** Auth Context and Appointments API
     *
     * **No Auth**
     * @deprecated Use viewerRole
     */
    isTourRequestSubmitter: Maybe<Scalars["Boolean"]>;
};
/** arm 5 rate object */
export type Arm5Bucket = {
    __typename?: "Arm5Bucket";
    lastUpdated: Maybe<Scalars["DateTime"]>;
    rate: Maybe<Scalars["Float"]>;
    rateSource: Maybe<Scalars["String"]>;
};
export type ArrayValue = {
    __typename?: "ArrayValue";
    array: Maybe<Array<Scalars["String"]>>;
};
/**
 * This type allows us to pass a key value pair of attribution entries to client
 * side. These attribution entries will be appended as url params to the internal
 * destination urls before routing.
 */
export type AttributionEntry = {
    __typename?: "AttributionEntry";
    key: Scalars["String"];
    value: Scalars["String"];
};
/** List of fields that will return values when they are needed */
export type AttributionInfo = {
    __typename?: "AttributionInfo";
    agentEmail: Maybe<Scalars["String"]>;
    agentLicenseNumber: Maybe<Scalars["String"]>;
    agentName: Maybe<Scalars["String"]>;
    agentPhoneNumber: Maybe<Scalars["String"]>;
    agentPhoneNumberWithExtension: Maybe<Scalars["String"]>;
    attributionTitle: Maybe<Scalars["String"]>;
    brokerName: Maybe<Scalars["String"]>;
    brokerPhoneNumber: Maybe<Scalars["String"]>;
    buyerAgentMemberStateLicense: Maybe<Scalars["String"]>;
    buyerAgentName: Maybe<Scalars["String"]>;
    buyerBrokerageName: Maybe<Scalars["String"]>;
    coAgentLicenseNumber: Maybe<Scalars["String"]>;
    coAgentName: Maybe<Scalars["String"]>;
    coAgentNumber: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString1: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString2: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString3: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString4: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString5: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString6: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString7: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString8: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString9: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString10: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString11: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString12: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString13: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString14: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString15: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString16: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString17: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString18: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString19: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString20: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoString21: Maybe<Scalars["String"]>;
    lastChecked: Maybe<Scalars["String"]>;
    lastUpdated: Maybe<Scalars["String"]>;
    listingAgentAttributionContact: Maybe<Scalars["String"]>;
    listingAgreement: Maybe<Scalars["String"]>;
    listingAttributionContact: Maybe<Scalars["String"]>;
    listingOfficeAttributionContact: Maybe<Scalars["String"]>;
    mlsDisclaimer: Maybe<Scalars["String"]>;
    mlsId: Maybe<Scalars["String"]>;
    mlsName: Maybe<Scalars["String"]>;
    providerLogo: Maybe<Scalars["String"]>;
    trueStatus: Maybe<Scalars["String"]>;
};
export type AuthOTP = {
    __typename?: "AuthOTP";
    isEnabled: Maybe<Scalars["Boolean"]>;
};
/** A plan that can be constructed on a new-construction lot. */
export type AvailablePlan = {
    __typename?: "AvailablePlan";
    /** Is this the primary plan for the lot? */
    isPrimaryPlan: Maybe<Scalars["Boolean"]>;
    zpid: Maybe<Scalars["Int"]>;
};
/** Field that is on used for a reference resolver on some queries, not to be queried directly */
export type BatchRules = {
    __typename?: "BatchRules";
    /** canCommingleComparables rule enabled */
    canCommingleComparables: Maybe<Scalars["Boolean"]>;
    /** category string */
    comminglingCategory: Maybe<Scalars["String"]>;
    /** isAdsRestricted rule enabled */
    isAdsRestricted: Maybe<Scalars["Boolean"]>;
};
export type BedRoomGroup = {
    __typename?: "BedRoomGroup";
    beds: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["String"]>;
};
/** Min and max price that defines a range */
export type BedsPriceRange = {
    __typename?: "BedsPriceRange";
    max: Maybe<Scalars["Int"]>;
    min: Maybe<Scalars["Int"]>;
};
/** Information about the bikeability of the area. */
export type BikeScoreResponse = {
    __typename?: "BikeScoreResponse";
    bikescore: Maybe<Scalars["Int"]>;
    description: Maybe<Scalars["String"]>;
};
export type BlendedRecommendation = {
    __typename?: "BlendedRecommendation";
    /** recommendation id. Depending on idType, this id can represent zpid or lotId */
    id: Maybe<Scalars["String"]>;
    /** Score for recommendation result, the higher the score reflect better recommendation */
    score: Maybe<Scalars["Float"]>;
    zpid: Maybe<Scalars["Int"]>;
};
export type BooleanValue = {
    __typename?: "BooleanValue";
    boolean: Scalars["Boolean"];
};
/** Breadcrumb link data for top header area */
export type Breadcrumb = {
    __typename?: "Breadcrumb";
    gaLabel: Maybe<Scalars["String"]>;
    path: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};
/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeAgentCrmAgentParticipant = {
    __typename?: "BridgeAgentCrmAgentParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
/** Deprecated, use BridgeAgentTeamLeadParticipant instead */
export type BridgeAgentCrmAgentTeamLeadParticipant = {
    __typename?: "BridgeAgentCrmAgentTeamLeadParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeAgentCrmContact = {
    __typename?: "BridgeAgentCrmContact";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeAgentParticipant = {
    __typename?: "BridgeAgentParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeAgentTeamLeadParticipant = {
    __typename?: "BridgeAgentTeamLeadParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeArrivalGoal = {
    __typename?: "BridgeArrivalGoal";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeBorrowerParticipant = {
    __typename?: "BridgeBorrowerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeBrokerParticipant = {
    __typename?: "BridgeBrokerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeBuy = {
    __typename?: "BridgeBuy";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    myAgentRelationshipId: Maybe<Scalars["String"]>;
    updateDt: Scalars["Time"];
};
/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeBuyerAgentParticipant = {
    __typename?: "BridgeBuyerAgentParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeBuyerAgentTeamLeadParticipant = {
    __typename?: "BridgeBuyerAgentTeamLeadParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeClosingBuy = {
    __typename?: "BridgeClosingBuy";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeClosingBuyerAgentParticipant = {
    __typename?: "BridgeClosingBuyerAgentParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
/** Deprecated, use BridgeShopperParticipant instead */
export type BridgeClosingBuyerParticipant = {
    __typename?: "BridgeClosingBuyerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeClosingEscrowAssistantParticipant = {
    __typename?: "BridgeClosingEscrowAssistantParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeClosingEscrowOfficerParticipant = {
    __typename?: "BridgeClosingEscrowOfficerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
/** Deprecated, use BridgeAgentParticipant instead */
export type BridgeClosingListingAgentParticipant = {
    __typename?: "BridgeClosingListingAgentParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeClosingSell = {
    __typename?: "BridgeClosingSell";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
/** Deprecated, use BridgeSellerParticipant instead */
export type BridgeClosingSellerParticipant = {
    __typename?: "BridgeClosingSellerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeComponentParticipation = {
    __typename?: "BridgeComponentParticipation";
    componentId: Scalars["ID"];
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeContainer = {
    __typename?: "BridgeContainer";
    moves: Array<BridgeMove>;
};
export type BridgeCustomerParticipant = {
    __typename?: "BridgeCustomerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeDepartureGoal = {
    __typename?: "BridgeDepartureGoal";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeFinance = {
    __typename?: "BridgeFinance";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
    zhlLid: Maybe<Scalars["String"]>;
    zhlLoan: Maybe<ZHLLoan>;
    zhlLoanNumber: Maybe<Scalars["String"]>;
    zhlSalesforceLeadId: Maybe<Scalars["String"]>;
};
export type BridgeFinanceGoal = {
    __typename?: "BridgeFinanceGoal";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeFirstTimeBuyers = {
    __typename?: "BridgeFirstTimeBuyers";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeHasBuyerAgent = {
    __typename?: "BridgeHasBuyerAgent";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeIsPreQualified = {
    __typename?: "BridgeIsPreQualified";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeLead = {
    __typename?: "BridgeLead";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    l2LeadId: Maybe<Scalars["String"]>;
    l3LeadId: Maybe<Scalars["String"]>;
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeLeadArrival = {
    __typename?: "BridgeLeadArrival";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    l2LeadId: Maybe<Scalars["String"]>;
    l3LeadId: Maybe<Scalars["String"]>;
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeLeadDeparture = {
    __typename?: "BridgeLeadDeparture";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    l2LeadId: Maybe<Scalars["String"]>;
    l3LeadId: Maybe<Scalars["String"]>;
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeLoanOfficerParticipant = {
    __typename?: "BridgeLoanOfficerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeLoanOfficerParticipantDetails = {
    branchNMLSID: Maybe<Scalars["Int"]>;
    email: Maybe<Scalars["String"]>;
    fullName: Maybe<Scalars["String"]>;
    nmlsID: Maybe<Scalars["Int"]>;
    officePhone: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type BridgeLoanProcessorParticipant = {
    __typename?: "BridgeLoanProcessorParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeMisoOffer = {
    __typename?: "BridgeMisoOffer";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    misoAccessTokenId: Maybe<Scalars["String"]>;
    misoId: Maybe<Scalars["String"]>;
    updateDt: Scalars["Time"];
};
export type BridgeMove = {
    __typename?: "BridgeMove";
    createDt: Scalars["Time"];
    /** Components are sorted according to the SortMethod before the limit is applied. The default sorting is described in sorting methods */
    finance: Array<BridgeFinance>;
    id: Scalars["ID"];
    updateDt: Scalars["Time"];
    version: Scalars["String"];
};
export type BridgeMoveComponent = {
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeMoveProfile = {
    __typename?: "BridgeMoveProfile";
    createDt: Scalars["Time"];
    moveId: Scalars["String"];
    updateDt: Scalars["Time"];
};
export enum BridgeParticipantReferenceType {
    UNSPECIFIED = "UNSPECIFIED",
    ZUID = "ZUID"
}
/** Deprecated, use BridgeCustomerParticipant instead */
export type BridgeProfileParticipant = {
    __typename?: "BridgeProfileParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeReadyToDiscussFinancing = {
    __typename?: "BridgeReadyToDiscussFinancing";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeSellerParticipant = {
    __typename?: "BridgeSellerParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeShopperParticipant = {
    __typename?: "BridgeShopperParticipant";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type BridgeStartedTouringHomes = {
    __typename?: "BridgeStartedTouringHomes";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
/** Use limit on each field to limit the number of participants returned */
export type BridgeTeam = {
    __typename?: "BridgeTeam";
    moveId: Scalars["String"];
};
export type BridgeTimeline = {
    __typename?: "BridgeTimeline";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeTourAppointment = {
    __typename?: "BridgeTourAppointment";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeWorkingWithLender = {
    __typename?: "BridgeWorkingWithLender";
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
};
export type BridgeZillowTransactionBuy = {
    __typename?: "BridgeZillowTransactionBuy";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeZillowTransactionSell = {
    __typename?: "BridgeZillowTransactionSell";
    createDt: Scalars["Time"];
    id: Scalars["ID"];
    linkedComponents: Array<Scalars["ID"]>;
    updateDt: Scalars["Time"];
};
export type BridgeZuidParticipant = {
    createDt: Scalars["Time"];
    updateDt: Scalars["Time"];
    zuid: Maybe<Scalars["String"]>;
};
export type Brokerage = {
    __typename?: "Brokerage";
    email: Maybe<Scalars["String"]>;
    escrowFlag: Maybe<Scalars["Boolean"]>;
    officeAddress: Maybe<Scalars["String"]>;
    officeCity: Maybe<Scalars["String"]>;
    officeName: Maybe<Scalars["String"]>;
    officeState: Maybe<Scalars["String"]>;
    officeZip: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["Int"]>;
};
/**
 * Provides building information based on:
 * - lot id
 * - latitude and longitude
 * - building key
 */
export type Building = {
    __typename?: "Building";
    /** Building specific ad targeting context parameters */
    adTargets: Maybe<Scalars["JSON"]>;
    /** Google Aerial View id */
    aerialViewVideoId: Maybe<Scalars["String"]>;
    /** Canonical URL for building page */
    bdpUrl: Maybe<Scalars["String"]>;
    /** IANA timezone string of this property (i.e. America/New_York) or null if it is unavailable */
    bestGuessTimezone: Maybe<Scalars["String"]>;
    /** A list of building area details */
    buildingAreas: Maybe<Array<Maybe<Scalars["String"]>>>;
    buildingName: Maybe<Scalars["String"]>;
    /** The URL used to load a native apps view of a BDP */
    buildingNativeAppsUrl: Maybe<Scalars["String"]>;
    buildingPhoneNumber: Maybe<Scalars["String"]>;
    /**
     * String representating the type of buildings, see https://bitbucket.zgtools.net/projects/SERVICES/repos/building-service/browse/src/main/java/com/zillow/bls/dto/BuildingType.java
     * for possible values
     */
    buildingType: Maybe<Scalars["String"]>;
    city: Maybe<Scalars["String"]>;
    /** List of common amenities in units */
    commonUnitAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of features related to, or available within, the community */
    communityFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    county: Maybe<Scalars["String"]>;
    /** User defined description of the building */
    description: Maybe<Scalars["String"]>;
    /** A list of features or description of the exterior of the property included in the sale/lease */
    exteriorFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of building extra features */
    extraFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** disclaimer for greystar buildings */
    floorPlanDisclaimer: Maybe<Scalars["String"]>;
    fullAddress: Maybe<Scalars["String"]>;
    /** Signed Google static map url */
    googleStaticMapSignedUrl: Maybe<Scalars["String"]>;
    /** Signed Google Street View image url */
    googleStreetViewImageSignedUrl: Maybe<Scalars["String"]>;
    /** Signed Google Street View metadata url */
    googleStreetViewMetadataSignedUrl: Maybe<Scalars["String"]>;
    /** Boolean flag for attribute data source, it will set to true if the attribute is inferred */
    hasInferredAttribute: Maybe<Scalars["Boolean"]>;
    /**
     * True if the property has a public video
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    hasPublicVideo: Maybe<Scalars["Boolean"]>;
    /** Boolean indicating whether or not there are room for rent */
    hasRoomForRent: Maybe<Scalars["Boolean"]>;
    /** The info used for the Engrain map */
    homeTypes: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of features or description of the interior of the property included in the sale/lease */
    interiorFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Boolean value indicating if the instant tours for the building can be cancelled with Zillow */
    isInstantTourCancellable: Maybe<Scalars["Boolean"]>;
    /** Boolean value indicating if the building has instant tour feature enabled */
    isInstantTourEnabled: Maybe<Scalars["Boolean"]>;
    /** Boolean indicating that the building participates in the Landlord Liaison Program */
    isLandlordLiaisonProgram: Maybe<Scalars["Boolean"]>;
    /** Boolean indicating whether or not there are income restrictions */
    isLowIncome: Maybe<Scalars["Boolean"]>;
    /** Indicates if the building properties are from paid multi family feed */
    isPaidMultiFamilyBrokerId: Maybe<Scalars["Boolean"]>;
    /** Indicates if the building properties are from paid single family feed */
    isPaidSingleFamilyBrokerId: Maybe<Scalars["Boolean"]>;
    /** Indicates if the building has met its monthly lead cap */
    isRentalsLeadCapMet: Maybe<Scalars["Boolean"]>;
    isSavedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    /** Boolean indicating that the building is only avialable to seniors */
    isSeniorHousing: Maybe<Scalars["Boolean"]>;
    /** Boolean indicating that the building is only available to students */
    isStudentHousing: Maybe<Scalars["Boolean"]>;
    /** Boolean value indicating if the building is a waitlist building */
    isWaitlisted: Maybe<Scalars["Boolean"]>;
    /** latitude of the building */
    latitude: Maybe<Scalars["Float"]>;
    /** Lease lengths available from this building */
    leaseLengths: Maybe<Scalars["String"]>;
    /** String value generated based on building posting information */
    listingFeatureType: Maybe<Scalars["String"]>;
    /** longitude of the building */
    longitude: Maybe<Scalars["Float"]>;
    /** Lot ID (unique ID) of the building */
    lotId: Maybe<Scalars["ID"]>;
    /** Rental marketing treatments */
    marketingTreatments: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Short descriptions of nearby amenities such as grocery stores and coffee shops */
    nearbyAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    neighborhood: Maybe<Scalars["String"]>;
    photoCount: Maybe<Scalars["Int"]>;
    /** Id for google ratings */
    placeId: Maybe<Scalars["String"]>;
    /** Describes a pool in terms of heated, gunite, above ground, etc */
    poolFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Disclaimer for rental cost and fees module */
    rentalCostAndFeesDisclaimer: Maybe<Scalars["String"]>;
    /** Boolean value to show notice from ALN Apartment Data in the footer area */
    showAlnNotice: Maybe<Scalars["Boolean"]>;
    /** Indicates whether we should show the text "Building" in the header */
    showBuildingLabel: Maybe<Scalars["Boolean"]>;
    state: Maybe<Scalars["String"]>;
    streetAddress: Maybe<Scalars["String"]>;
    /** VaLoan status info */
    vaLoanStatus: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
/** Provides all the building attributes of a building */
export type BuildingAttributes = {
    __typename?: "BuildingAttributes";
    administrativeFee: Maybe<Scalars["Float"]>;
    amenitiesNearby1: Maybe<Scalars["String"]>;
    amenitiesNearby2: Maybe<Scalars["String"]>;
    amenitiesNearby3: Maybe<Scalars["String"]>;
    amenitiesNearby4: Maybe<Scalars["String"]>;
    applicationFee: Maybe<Scalars["Float"]>;
    architect: Maybe<Scalars["String"]>;
    associationName: Maybe<Scalars["String"]>;
    buildingName: Maybe<Scalars["String"]>;
    busesNearbyDescription: Maybe<Scalars["String"]>;
    canDisplay: Maybe<Scalars["String"]>;
    city: Maybe<Scalars["String"]>;
    customAmenities: Maybe<Scalars["String"]>;
    customPropertyAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    customUnitAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    depositFeeMax: Maybe<Scalars["Float"]>;
    depositFeeMin: Maybe<Scalars["Float"]>;
    description: Maybe<Scalars["String"]>;
    hasAssistedLiving: Maybe<Scalars["Boolean"]>;
    hasBarbecue: Maybe<Scalars["Boolean"]>;
    hasBicycleStorage: Maybe<Scalars["Boolean"]>;
    hasCeilingFan: Maybe<Scalars["Boolean"]>;
    hasDisabledAccess: Maybe<Scalars["Boolean"]>;
    hasDryCleaningDropOff: Maybe<Scalars["Boolean"]>;
    hasElevator: Maybe<Scalars["Boolean"]>;
    hasFireplace: Maybe<Scalars["Boolean"]>;
    hasGuestSuite: Maybe<Scalars["Boolean"]>;
    hasHotTub: Maybe<Scalars["Boolean"]>;
    hasOnlineMaintenancePortal: Maybe<Scalars["Boolean"]>;
    hasOnlineRentPayment: Maybe<Scalars["Boolean"]>;
    hasOnsiteManagement: Maybe<Scalars["Boolean"]>;
    hasPackageService: Maybe<Scalars["Boolean"]>;
    hasPatioBalcony: Maybe<Scalars["Boolean"]>;
    hasPetPark: Maybe<Scalars["Boolean"]>;
    hasRoomForRent: Maybe<Scalars["Boolean"]>;
    hasSauna: Maybe<Scalars["Boolean"]>;
    hasSharedLaundry: Maybe<Scalars["Boolean"]>;
    hasSpanishSpeakingStaff: Maybe<Scalars["Boolean"]>;
    hasStorage: Maybe<Scalars["Boolean"]>;
    hasSwimmingPool: Maybe<Scalars["Boolean"]>;
    hasTwentyFourHourMaintenance: Maybe<Scalars["Boolean"]>;
    hasVRModel: Maybe<Scalars["Boolean"]>;
    hasValetTrash: Maybe<Scalars["Boolean"]>;
    hoursOfOperation: Maybe<Scalars["String"]>;
    isDisplayDescription: Maybe<Scalars["Boolean"]>;
    isFurnished: Maybe<Scalars["Boolean"]>;
    isLowIncome: Maybe<Scalars["Boolean"]>;
    isMilitaryHousing: Maybe<Scalars["Boolean"]>;
    isNewConstructionHousing: Maybe<Scalars["Boolean"]>;
    isOver55: Maybe<Scalars["Boolean"]>;
    isSeniorHousing: Maybe<Scalars["Boolean"]>;
    isSmokeFree: Maybe<Scalars["Boolean"]>;
    isStudentHousing: Maybe<Scalars["Boolean"]>;
    latitude: Maybe<Scalars["Float"]>;
    leaseLengths: Maybe<Scalars["String"]>;
    longitude: Maybe<Scalars["Float"]>;
    lotURL: Maybe<Scalars["String"]>;
    managerName: Maybe<Scalars["String"]>;
    parkingDescription: Maybe<Scalars["String"]>;
    parkingRentDescription: Maybe<Scalars["String"]>;
    petPolicyDescription: Maybe<Scalars["String"]>;
    postalCode: Maybe<Scalars["String"]>;
    railNearbyDescription: Maybe<Scalars["String"]>;
    rentalCostAndFeesDisclaimer: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    statusType: Maybe<Scalars["String"]>;
    storyCount: Maybe<Scalars["Int"]>;
    streetAddress1: Maybe<Scalars["String"]>;
    streetAddress2: Maybe<Scalars["String"]>;
    unitCount: Maybe<Scalars["Int"]>;
    xxternalDataSourceType: Maybe<Scalars["String"]>;
    yearBuilt: Maybe<Scalars["Int"]>;
    yearRemodeled: Maybe<Scalars["Int"]>;
};
export type BuildingAttributesMini = {
    __typename?: "BuildingAttributesMini";
    isLowIncome: Maybe<Scalars["Boolean"]>;
};
export type BuildingCard = {
    __typename?: "BuildingCard";
    bdpLink: Maybe<Scalars["String"]>;
    buildingAddress: Maybe<Scalars["String"]>;
    buildingName: Maybe<Scalars["String"]>;
    /** latitude of the building */
    latitude: Maybe<Scalars["Float"]>;
    /** longitude of the building */
    longitude: Maybe<Scalars["Float"]>;
    /** Lot ID (unique ID) of the building */
    lotId: Maybe<Scalars["ID"]>;
    maxPrice: Maybe<Scalars["Int"]>;
    minBaths: Maybe<Scalars["Float"]>;
    minBeds: Maybe<Scalars["Int"]>;
    minLivingArea: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
    photoCount: Maybe<Scalars["String"]>;
    providerListingId: Maybe<Scalars["String"]>;
    recentlyUpdated: Maybe<Scalars["Boolean"]>;
    showUpdateTime: Maybe<Scalars["Boolean"]>;
    updateTimeLabel: Maybe<Scalars["String"]>;
};
export type BuildingEngrainLevelsType = {
    __typename?: "BuildingEngrainLevelsType";
    floorId: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
};
export type BuildingEngrainType = {
    __typename?: "BuildingEngrainType";
    availableBedroomOptions: Maybe<Array<Maybe<Scalars["String"]>>>;
    mapId: Maybe<Scalars["String"]>;
};
export type BuildingEngrainUnitsType = {
    __typename?: "BuildingEngrainUnitsType";
    bedroomType: Maybe<Scalars["String"]>;
    engrainId: Maybe<Scalars["String"]>;
    zpid: Maybe<Scalars["String"]>;
};
export type BuildingHomeInsights = {
    __typename?: "BuildingHomeInsights";
};
/** A small set of fields from building type */
export type BuildingMini = {
    __typename?: "BuildingMini";
    /** Cannonical URL for building page */
    bdpUrl: Maybe<Scalars["String"]>;
    buildingName: Maybe<Scalars["String"]>;
    streetAddress: Maybe<Scalars["String"]>;
};
export type BuildingPermit = {
    __typename?: "BuildingPermit";
    /** City issued building permit number. */
    permitNumber: Maybe<Scalars["String"]>;
};
export type BuildingPermitDetail = {
    __typename?: "BuildingPermitDetail";
    /** The business name of the contractor */
    contractor: Maybe<Scalars["String"]>;
    /** Permit Date */
    date: Maybe<Scalars["String"]>;
    /** Details of the permit */
    description: Maybe<Scalars["String"]>;
    /** Status of the building permit */
    status: Maybe<Scalars["String"]>;
};
export type BuildingSeoTags = {
    __typename?: "BuildingSeoTags";
    description: Maybe<Scalars["String"]>;
    h1: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
/** The summary of the units for the building */
export type BuildingUnitsSummary = {
    __typename?: "BuildingUnitsSummary";
    availableUnitCount: Maybe<Scalars["Int"]>;
    /** A list of all the possible bed counts for active rental units in the building */
    bedOptions: Maybe<Array<Maybe<Scalars["Int"]>>>;
    maxPrice: Maybe<Scalars["Int"]>;
    maxSqft: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
    minSqft: Maybe<Scalars["Int"]>;
    unitCount: Maybe<Scalars["Int"]>;
};
export type BuildingVRFloor = {
    __typename?: "BuildingVRFloor";
    fkEntranceEntityId: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["Int"]>;
};
export type BuildingVRModel = {
    __typename?: "BuildingVRModel";
    associations: Maybe<Array<Maybe<Scalars["Int"]>>>;
    cdnHost: Maybe<Scalars["String"]>;
    revisionId: Maybe<Scalars["String"]>;
    viewerUrl: Maybe<Scalars["String"]>;
    vrModelGuid: Maybe<Scalars["String"]>;
};
export type BuildingVRPano = {
    __typename?: "BuildingVRPano";
    entityId: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type BuildingVRPanoStructure = {
    __typename?: "BuildingVRPanoStructure";
    startingFloorId: Maybe<Scalars["Int"]>;
};
export type BusinessConsultant = {
    __typename?: "BusinessConsultant";
    email: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    phone: Maybe<Scalars["String"]>;
    phoneExtension: Maybe<Scalars["String"]>;
    photoUrl: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type Buyer = {
    __typename?: "Buyer";
    email: Maybe<Scalars["String"]>;
    firstName: Maybe<Scalars["String"]>;
    lastName: Maybe<Scalars["String"]>;
    phone: Maybe<Scalars["String"]>;
};
export type BuyerAgencyAgreement = {
    __typename?: "BuyerAgencyAgreement";
    createdDate: Maybe<Scalars["DateTime"]>;
    zDocsId: Maybe<Scalars["String"]>;
};
export type BuyerParticipant = {
    __typename?: "BuyerParticipant";
    /**
     * **Definition:** The contact id for the buyer's tour request submission
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    contactId: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** The buyer's email
     *
     * **Source:** See "emailSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    email: Maybe<Scalars["String"]>;
    /**
     * **Definition:** A masked version of the buyer's email
     *
     * **Source:** See "emailSource" field
     *
     * **No Auth**
     *
     * **Example:** "b******z@zillow.com"
     */
    maskedEmail: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The buyer's full name
     *
     * **Source:** See "nameSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    name: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The buyer's phone
     *
     * **Source:** See "phoneSource" field
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    phone: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The zuid of the buyer participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-buyer-pii.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    zuid: Maybe<Scalars["Int"]>;
};
export type CancelTourContactAgentView = {
    __typename?: "CancelTourContactAgentView";
};
export type CancelTourRequestFormView = {
    __typename?: "CancelTourRequestFormView";
};
export type CancellationRequest = {
    __typename?: "CancellationRequest";
    /**
     * **Definition:** Cancellation reason text
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    cancellationReason: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Cancellation reason note
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    cancellationReasonNote: Maybe<Scalars["String"]>;
};
/** Cash offer related data */
export type CashOffer = {
    __typename?: "CashOffer";
    /** Show whether cash offer is available */
    isCashOfferAvailable: Maybe<Scalars["Boolean"]>;
    /** Show whether the current user is the owner of the cash offer on this property */
    isCurrentUserOfferOwner: Maybe<Scalars["Boolean"]>;
    /** Price of active cash offer, it will be suppressed when provided zuid is not matched within offer response */
    price: Maybe<Scalars["Int"]>;
};
export type CategoryGroupType = {
    __typename?: "CategoryGroupType";
    /** name of the category group */
    categoryGroupName: Maybe<Scalars["String"]>;
};
export type CategoryType = {
    __typename?: "CategoryType";
    /** name of the category */
    categoryName: Maybe<Scalars["String"]>;
};
export type ChipElementType = {
    __typename?: "ChipElementType";
    /** Description of chip element value */
    contentDescription: Maybe<Scalars["String"]>;
    elementType: Maybe<Scalars["String"]>;
    /** href to make this chip element link to */
    jsMessage: Maybe<Scalars["String"]>;
};
/** A collection of recommendations for a user */
export type Collection = {
    __typename?: "Collection";
    /** Subtitle of the collection to display in the UI */
    caption: Maybe<Scalars["String"]>;
    /** Name of the collection to display in the UI */
    name: Scalars["String"];
    /**
     * Subtitle of the collection to display in the UI
     * @deprecated Use caption instead
     */
    subtitle: Scalars["String"];
};
/** A link that should be displayed for the collection (typically to SRP) */
export type CollectionLink = {
    __typename?: "CollectionLink";
    /** The text that should be displayed to the user in the UI */
    displayText: Scalars["String"];
    /** The url to link to */
    url: Scalars["String"];
};
/** List of personalized collections for a user */
export type Collections = {
    __typename?: "Collections";
};
export type CombinedReview = {
    __typename?: "CombinedReview";
    created: Maybe<Scalars["String"]>;
    reviewerName: Maybe<Scalars["String"]>;
    reviewerType: Maybe<Scalars["String"]>;
};
export type CommuteDetailType = {
    __typename?: "CommuteDetailType";
    /** status of the commute details response for a given destination */
    status: Maybe<Scalars["String"]>;
};
export type CommuteDistanceType = {
    __typename?: "CommuteDistanceType";
    /**
     * String representation for the commute distance in either imperial or metric
     * units, as specified in the units param to the commute-details-provider service
     */
    text: Maybe<Scalars["String"]>;
    /** Distance in meters to the destination for the commute */
    value: Maybe<Scalars["Int"]>;
};
export type CommuteDurationType = {
    __typename?: "CommuteDurationType";
    /** String representation for the commute time */
    text: Maybe<Scalars["String"]>;
    /** Number of seconds for commute for the mode */
    value: Maybe<Scalars["Int"]>;
};
export type CommuteModeDetailType = {
    __typename?: "CommuteModeDetailType";
    /** Container of a geoJSON object that contains a commute route */
    route: Maybe<Scalars["String"]>;
    /** Response status for commute details for this mode of commute */
    status: Maybe<Scalars["String"]>;
};
/** Commute destination details and corresponding distances and times to commute */
export type CommuteResponseType = {
    __typename?: "CommuteResponseType";
    /** Formatted address of the commute destination */
    address: Maybe<Scalars["String"]>;
    /** Unique identifier for the destination as sent by Google Place Details API. */
    googlePlaceId: Maybe<Scalars["String"]>;
    label: Maybe<Scalars["String"]>;
    /** Latitude of the commute destination */
    latitude: Maybe<Scalars["Float"]>;
    /** ID of the destination as stored in user-commute-locations service */
    locationId: Maybe<Scalars["Int"]>;
    /** Longitude of the commute destination */
    longitude: Maybe<Scalars["Float"]>;
    /** Time of commute to destination. */
    timeOfCommuteDeparture: Maybe<Scalars["String"]>;
    /** UTC offset for the destination as sent by Google Place Details API. */
    utcOffset: Maybe<Scalars["Int"]>;
};
export type Comp = {
    __typename?: "Comp";
    rank: Maybe<Scalars["Int"]>;
    zpid: Maybe<Scalars["Int"]>;
};
export type Comparables = {
    __typename?: "Comparables";
    parcelId: Maybe<Scalars["Int"]>;
};
/** Nearby homes and buildings for nearby comparisons card carousel on building pages */
export type Comps = {
    __typename?: "Comps";
};
export type ContactFormInputTextField = {
    __typename?: "ContactFormInputTextField";
    clientSideValidationErrorMessage: Maybe<Scalars["String"]>;
    defaultSubmitValue: Maybe<Scalars["String"]>;
    inputName: Scalars["String"];
    isRequired: Scalars["Boolean"];
    isUserInputDisabled: Scalars["Boolean"];
    label: Scalars["String"];
    maxCharacters: Maybe<Scalars["Int"]>;
    numberOfLines: Scalars["Int"];
    placeholder: Maybe<Scalars["String"]>;
    validationRegex: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["String"]>;
};
/**
 * Contact information for contact form component. Using homeStatus to decide which
 * contact form component that we need to show on the page
 */
export type ContactInfo = {
    __typename?: "ContactInfo";
    contactType: Maybe<Scalars["String"]>;
    homeStatus: Maybe<Scalars["String"]>;
    isTrusted: Maybe<Scalars["Boolean"]>;
    providerListingID: Maybe<Scalars["String"]>;
    rentalApplicationsAcceptedType: Maybe<Scalars["String"]>;
};
export type CoreProfileData = {
    __typename?: "CoreProfileData";
    /**
     * Profile Photo URL from core-profile-data service
     * This replaces the old source from user-data service
     */
    profilePhotoUrl: Maybe<Scalars["String"]>;
};
export type CreditScoreUsed = {
    __typename?: "CreditScoreUsed";
    creditScoreMax: Maybe<Scalars["Int"]>;
    creditScoreMin: Maybe<Scalars["Int"]>;
};
export type CustomAmenities = {
    __typename?: "CustomAmenities";
    rawAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type DedicatedLoanOfficer = {
    __typename?: "DedicatedLoanOfficer";
    email: Scalars["String"];
    fullName: Scalars["String"];
    imageUrl: Maybe<Scalars["String"]>;
    phone: Scalars["String"];
    shareableKey: Maybe<Scalars["String"]>;
    shareableLoLinkUrl: Maybe<Scalars["String"]>;
};
export type DetailedParkingPolicy = {
    __typename?: "DetailedParkingPolicy";
    assigned: Maybe<Scalars["Boolean"]>;
    comment: Maybe<Scalars["String"]>;
    numberOfSpaces: Maybe<Scalars["Int"]>;
    parkingType: Maybe<Scalars["String"]>;
    spaceFee: Maybe<Scalars["Float"]>;
};
/** Detailed pet policy for a building */
export type DetailedPetPolicy = {
    __typename?: "DetailedPetPolicy";
    general: Maybe<Scalars["String"]>;
};
export type DisplayStrings = {
    __typename?: "DisplayStrings";
    bodyText: Maybe<Scalars["String"]>;
    iconUrl: Maybe<Scalars["String"]>;
    ineligibleReasonText: Maybe<Scalars["String"]>;
    learnMoreBodyText: Maybe<Scalars["String"]>;
    learnMoreTitle: Maybe<Scalars["String"]>;
};
export type DownPaymentAssistanceProgramListType = {
    __typename?: "DownPaymentAssistanceProgramListType";
    /** Maximum assistance offered in results */
    max_assistance: Maybe<Scalars["Int"]>;
    /** Number of results */
    result_count: Maybe<Scalars["Int"]>;
};
export type DownPaymentAssistanceProgramType = {
    __typename?: "DownPaymentAssistanceProgramType";
    /** Agency Id */
    agency_id: Maybe<Scalars["Int"]>;
    /** amount of assistance */
    assistance_amount: Maybe<Scalars["String"]>;
    /** Agency contact */
    contact_agency_url: Maybe<Scalars["String"]>;
    /** Id */
    id: Maybe<Scalars["Int"]>;
    /** max sales price */
    max_sales_price: Maybe<Scalars["String"]>;
    /** Name of program */
    name: Maybe<Scalars["String"]>;
    /** Program status */
    status: Maybe<Scalars["String"]>;
};
export type EntryActionLink = {
    __typename?: "EntryActionLink";
    leadType: Maybe<Scalars["String"]>;
    link: Maybe<Scalars["String"]>;
};
export type EstimateOfferData = {
    __typename?: "EstimateOfferData";
    estimateOfferExpGroup: Maybe<Scalars["String"]>;
    estimateOfferPrice: Maybe<Scalars["Int"]>;
};
/** This block contains the event meta date for OMP */
export type EventMetaData = {
    __typename?: "EventMetaData";
};
/** This block is used to create the exposure events for omp experiments. It will contain all necessary fields. */
export type ExposureBlock = {
    __typename?: "ExposureBlock";
    /** Assignment service used like abs, cauldron, etc. */
    assignmentServiceCd: Maybe<Scalars["String"]>;
    /** Decision id, e.g. 36sU6R_1649978282 */
    decisionToken: Maybe<Scalars["String"]>;
    /** Id of the page or experience */
    experienceId: Maybe<Scalars["String"]>;
    /** The key type used, e.g. guid */
    keyTypeCd: Maybe<Scalars["String"]>;
    /** The key sent to ABS to id the randomization unit */
    randomizationKey: Maybe<Scalars["String"]>;
    /** A list of OMP treatments that the user is exposed to */
    treatments: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type ExternalAuthAccountData = {
    __typename?: "ExternalAuthAccountData";
    /** The External Account ID */
    externalConnectID: Maybe<Scalars["ID"]>;
    /** The Type ID of external Account */
    externalType: Maybe<Scalars["String"]>;
    /** The canonical name of the external Account */
    externalTypeName: Maybe<Scalars["String"]>;
};
/** FSHDP tab internal route */
export type FSHDPRoute = {
    __typename?: "FSHDPRoute";
    zpid: Scalars["String"];
};
export type FactType = {
    __typename?: "FactType";
    factLabel: Maybe<Scalars["String"]>;
    factValue: Maybe<Scalars["String"]>;
};
/** A feedback option that should be display in the UI */
export type FeedbackOption = {
    __typename?: "FeedbackOption";
    /** The text that should be displayed to the user in the feedback option */
    displayText: Scalars["String"];
};
/** Includes all HOA and non-HOA fees info */
export type FeesAndDues = {
    __typename?: "FeesAndDues";
    /** Parsed fee string, includes currency and frequency */
    fee: Maybe<Scalars["String"]>;
    /** Name of Home Owner Association, only apply to HOA type */
    name: Maybe<Scalars["String"]>;
    /** Phone of Home Owner Association, only apply to HOA type */
    phone: Maybe<Scalars["String"]>;
    /** Type of fees, includes HOA and non-HOA types */
    type: Maybe<Scalars["String"]>;
};
/** fifteen year fixed rate object */
export type FifteenYearFixedBucket = {
    __typename?: "FifteenYearFixedBucket";
    lastUpdated: Maybe<Scalars["DateTime"]>;
    rate: Maybe<Scalars["Float"]>;
    rateSource: Maybe<Scalars["String"]>;
};
export type FinanceJourneyContext = {
    __typename?: "FinanceJourneyContext";
    zuid: Scalars["String"];
};
export type FinanceUpsellPage = {
    __typename?: "FinanceUpsellPage";
    confirmationMessage: Scalars["String"];
    title: Scalars["String"];
};
export type FinanceUpsellView = {
    __typename?: "FinanceUpsellView";
};
export type FinanceUpsell_Financing = {
    __typename?: "FinanceUpsell_Financing";
    finePrint: Scalars["String"];
    messageText: Scalars["String"];
    title: Scalars["String"];
};
export type FinanceUpsell_Property = {
    __typename?: "FinanceUpsell_Property";
    price: Maybe<Scalars["String"]>;
};
export type FinancingCheckbox = {
    __typename?: "FinancingCheckbox";
    isCheckedInitialState: Scalars["Boolean"];
    label: Scalars["String"];
    leadFieldName: Scalars["String"];
};
export type FlexAddress = {
    __typename?: "FlexAddress";
    city: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    street2: Maybe<Scalars["String"]>;
    zip: Maybe<Scalars["String"]>;
};
export type FlexBrokerCommissionDetails = {
    __typename?: "FlexBrokerCommissionDetails";
    commissionAddition: Maybe<Scalars["Float"]>;
    commissionAmount: Maybe<Scalars["Float"]>;
    commissionPercentage: Maybe<Scalars["Float"]>;
    commissionReduction: Maybe<Scalars["Float"]>;
};
export type FlexOtpForm = {
    __typename?: "FlexOtpForm";
    documentId: Maybe<Scalars["String"]>;
    downloadLink: Maybe<Scalars["String"]>;
    previewLink: Maybe<Scalars["String"]>;
};
export type FlexProperty = {
    __typename?: "FlexProperty";
    zpid: Maybe<Scalars["String"]>;
};
export type FlexTransaction = {
    __typename?: "FlexTransaction";
    carpOtpDocumentId: Maybe<Scalars["String"]>;
    destinationAccountNumber: Maybe<Scalars["String"]>;
    invoiceNumber: Maybe<Scalars["String"]>;
    isDocumentUploaded: Maybe<Scalars["Boolean"]>;
    isPaymentAuthorized: Maybe<Scalars["Boolean"]>;
    paymentAmount: Maybe<Scalars["Float"]>;
    paymentAuthorizedBy: Maybe<Scalars["String"]>;
    paymentAuthorizedTime: Maybe<Scalars["DateTime"]>;
    ztid: Scalars["ID"];
};
export type FlexTransactionCancellationReason = {
    __typename?: "FlexTransactionCancellationReason";
    id: Scalars["String"];
    otherText: Maybe<Scalars["String"]>;
    text: Scalars["String"];
};
export type FlexTxnAgent = {
    __typename?: "FlexTxnAgent";
    agentEmail: Maybe<Scalars["String"]>;
    agentZuid: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    teamLeadName: Maybe<Scalars["String"]>;
    teamLeadZuid: Maybe<Scalars["String"]>;
};
export type FlexTxnBroker = {
    __typename?: "FlexTxnBroker";
    billingAccountExists: Maybe<Scalars["Boolean"]>;
    brokerEmail: Maybe<Scalars["String"]>;
    brokerName: Maybe<Scalars["String"]>;
    brokerZuid: Maybe<Scalars["String"]>;
    brokerageName: Maybe<Scalars["String"]>;
};
export type FlexTxnClosingDetails = {
    __typename?: "FlexTxnClosingDetails";
    brokerGrossCommission: Maybe<Scalars["String"]>;
    /**  ISO 8601 (YYYY-MM-DD)  */
    closeDate: Maybe<Scalars["Date"]>;
    closingCompany: Maybe<Scalars["String"]>;
    flexVersion: Maybe<Scalars["String"]>;
    market: Maybe<Scalars["String"]>;
    propertySalesPrice: Maybe<Scalars["Float"]>;
    transactionCreatedDate: Maybe<Scalars["Date"]>;
    zgFee: Maybe<Scalars["Float"]>;
    zgFeePercentage: Maybe<Scalars["Float"]>;
};
export type FlexTxnConsumer = {
    __typename?: "FlexTxnConsumer";
    consumerId: Maybe<Scalars["ID"]>;
    name: Maybe<Scalars["String"]>;
};
export type FlexTxnContact = {
    __typename?: "FlexTxnContact";
    contactDate: Maybe<Scalars["String"]>;
    contactId: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};
export type FlexTxnContactOwner = {
    __typename?: "FlexTxnContactOwner";
    name: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export type FlexTxnMetadata = {
    __typename?: "FlexTxnMetadata";
    createBy: Maybe<Scalars["String"]>;
    createTime: Maybe<Scalars["DateTime"]>;
    eventType: Maybe<Scalars["String"]>;
    lastUpdateBy: Maybe<Scalars["String"]>;
    lastUpdateTime: Maybe<Scalars["String"]>;
    messageId: Maybe<Scalars["String"]>;
    messageTime: Maybe<Scalars["DateTime"]>;
    sourceSystem: Maybe<Scalars["String"]>;
    versionNumber: Maybe<Scalars["String"]>;
};
/** Floor map created from a 3D Home */
export type FloorMap = {
    __typename?: "FloorMap";
    cdnHost: Maybe<Scalars["String"]>;
    floorMapGuid: Maybe<Scalars["String"]>;
    vrModelGuid: Maybe<Scalars["String"]>;
};
/** Floor plan information for WOW BDP */
export type FloorPlan = {
    __typename?: "FloorPlan";
    amenityDetails: Maybe<Array<Maybe<Scalars["String"]>>>;
    availableFrom: Maybe<Scalars["String"]>;
    availableFromDateStr: Maybe<Scalars["String"]>;
    baths: Maybe<Scalars["Float"]>;
    beds: Maybe<Scalars["Int"]>;
    depositsAndFees: Maybe<Scalars["Float"]>;
    description: Maybe<Scalars["String"]>;
    hasApprovedThirdPartyVirtualTour: Maybe<Scalars["Boolean"]>;
    leaseTerm: Maybe<Scalars["String"]>;
    maloneId: Maybe<Scalars["String"]>;
    maxPrice: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
    name: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["Int"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
export type Floorplan = {
    __typename?: "Floorplan";
    baths: Maybe<Scalars["Float"]>;
    lightboxPhotoUrl: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["Int"]>;
    thumbnailPhotoUrl: Maybe<Scalars["String"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
export type FloorplanVideos = {
    __typename?: "FloorplanVideos";
    label: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};
export type ForSaleContactFormData = {
    __typename?: "ForSaleContactFormData";
    /** This field is provided as JSON, passed through from and documented in adsdisplay */
    data: Maybe<Scalars["JSON"]>;
    /** ZPID that contact form is rendered for */
    zpid: Maybe<Scalars["ID"]>;
};
/** Flags indicating the foreclosure-related stages the property has been in */
export type ForeclosureFlags = {
    __typename?: "ForeclosureFlags";
    /** Whether the property is any type of active foreclosure (bank-owned, foreclosed nfs, foreclosure, or preforeclosure) */
    isAnyForeclosure: Maybe<Scalars["Boolean"]>;
    /** Whether the property is bank-owned */
    isBankOwned: Maybe<Scalars["Boolean"]>;
    /** Whether the property is foreclosed and not for sale */
    isForeclosedNFS: Maybe<Scalars["Boolean"]>;
    /** Whether the property is a pre-foreclosure */
    isPreforeclosure: Maybe<Scalars["Boolean"]>;
    /**
     * Whether the property was in default
     * @deprecated Does not exist in PDC
     */
    wasDefault: Maybe<Scalars["Boolean"]>;
    /** Whether the property has been foreclosed on */
    wasForeclosed: Maybe<Scalars["Boolean"]>;
    /** Whether the property has undergone a non-retail auction */
    wasNonRetailAuction: Maybe<Scalars["Boolean"]>;
    /**
     * Whether the property was real estate owned
     * @deprecated Does not exist in PDC
     */
    wasREO: Maybe<Scalars["Boolean"]>;
};
export type ForeclosureMoreInfo = {
    __typename?: "ForeclosureMoreInfo";
    /** Assessor's parcel number, assigned to a property by the tax assessor */
    apn: Maybe<Scalars["String"]>;
    /**
     * The legal description of the property in foreclosure. Could contain the street
     * address, boundaries and/or other descriptors about the property
     */
    legalDescription: Maybe<Scalars["String"]>;
    /** The name of the subdivision, plat, or tract where the property is located */
    subdivision: Maybe<Scalars["String"]>;
    /** Address of the entity guiding the property through the foreclosure process */
    trusteeAddress: Maybe<Scalars["String"]>;
    /** Name of the entity guiding the property through the foreclosure process */
    trusteeName: Maybe<Scalars["String"]>;
    /** Phone number of the entity guiding the property through the foreclosure process */
    trusteePhone: Maybe<Scalars["String"]>;
};
export type ForeclosureMoreInfoDocument = {
    __typename?: "ForeclosureMoreInfoDocument";
    /** Filing date of the document */
    date: Maybe<Scalars["DateTime"]>;
    /** Name of the filed document */
    name: Maybe<Scalars["String"]>;
    /** Filing number of the document */
    number: Maybe<Scalars["String"]>;
};
export type FormQuestion = {
    inputName: Scalars["String"];
    questionIcon: Scalars["String"];
    questionText: Scalars["String"];
};
export type FormQuestionnaire = {
    __typename?: "FormQuestionnaire";
};
export type FormattedChip = {
    __typename?: "FormattedChip";
};
export type GoogleReview = {
    __typename?: "GoogleReview";
    authorName: Maybe<Scalars["String"]>;
    rating: Maybe<Scalars["Float"]>;
    text: Maybe<Scalars["String"]>;
    time: Maybe<Scalars["Int"]>;
    translated: Maybe<Scalars["Boolean"]>;
};
export type GoogleReviews = {
    __typename?: "GoogleReviews";
    rating: Maybe<Scalars["Float"]>;
    userRatingsTotal: Maybe<Scalars["Int"]>;
};
/** Housing Connector URL link and test. If mobile = true, then the link can also be shown to mobile users */
export type HCBuildingLink = {
    __typename?: "HCBuildingLink";
    mobile: Maybe<Scalars["Boolean"]>;
    path: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};
export type Highlight = {
    __typename?: "Highlight";
    /** Text submitted by agent. */
    content: Scalars["String"];
    /** Date of highlight submission. */
    date: Scalars["DateTime"];
    /** ID of the highlight. */
    id: Maybe<Scalars["Int"]>;
    /** Moderation status. */
    status: Scalars["String"];
};
export type HighlightAgent = {
    __typename?: "HighlightAgent";
    /** Name of the agent. */
    name: Scalars["String"];
    /** URL to a photo of the agent. */
    photoUrl: Scalars["String"];
    /** URL to the profile page of the agent. */
    profileUrl: Scalars["String"];
    /** Title of the agent. */
    title: Scalars["String"];
};
export type HomeCard = {
    __typename?: "HomeCard";
    bathrooms: Maybe<Scalars["Int"]>;
    bedrooms: Maybe<Scalars["Int"]>;
    currency: Maybe<Scalars["String"]>;
    displayIconType: Maybe<Scalars["String"]>;
    hdpUrl: Maybe<Scalars["String"]>;
    homeInfo: Maybe<Scalars["String"]>;
    livingArea: Maybe<Scalars["Int"]>;
    price: Maybe<Scalars["Int"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
export type HomeFactsComparisonData = {
    __typename?: "HomeFactsComparisonData";
};
export type HomeFactsComparisonDataItem = {
    __typename?: "HomeFactsComparisonDataItem";
    label: Maybe<Scalars["String"]>;
    publicValue: Maybe<Scalars["String"]>;
    zillowValue: Maybe<Scalars["String"]>;
};
export type HomeFactsType = {
    __typename?: "HomeFactsType";
};
export type HomeLoansDashboard = {
    __typename?: "HomeLoansDashboard";
    personalizedNextSteps: ZHLPersonalizedNextSteps;
};
/** HomeLoans tab internal route */
export type HomeLoansRoute = {
    __typename?: "HomeLoansRoute";
    guid: Scalars["String"];
    zpid: Scalars["String"];
    zuid: Maybe<Scalars["String"]>;
};
export type HomeOwnerValuation = {
    __typename?: "HomeOwnerValuation";
    zpid: Maybe<Scalars["Int"]>;
};
/** List of recommended homes for logged in and anonymous users */
export type HomeRecommendation = {
    __typename?: "HomeRecommendation";
    /** Sub title for Home Recommendation react component */
    displayLong: Maybe<Scalars["String"]>;
    /** Title for Home Recommendation react component */
    displayShort: Maybe<Scalars["String"]>;
};
export type HomeTourHighlights = {
    __typename?: "HomeTourHighlights";
};
export type HomeValuation = {
    __typename?: "HomeValuation";
    /**
     * Show whether cash offer is available
     * @deprecated Deprecated with ZO wind down
     */
    isCashOfferAvailable: Maybe<Scalars["Boolean"]>;
    zpid: Maybe<Scalars["Int"]>;
};
export type HomeValueDataPoint = {
    __typename?: "HomeValueDataPoint";
    x: Maybe<Scalars["Float"]>;
    y: Maybe<Scalars["Float"]>;
};
/** historical home value data */
export type HomeValueDataSeries = {
    __typename?: "HomeValueDataSeries";
    id: Maybe<Scalars["ID"]>;
    name: Maybe<Scalars["String"]>;
    regionType: Maybe<Scalars["String"]>;
};
export type HomeValueMetric = {
    __typename?: "HomeValueMetric";
    dataTypeId: Maybe<Scalars["String"]>;
    dateEnd: Maybe<Scalars["String"]>;
    metricTypeId: Maybe<Scalars["String"]>;
    /** Month over month change in percentage. */
    mom: Maybe<Scalars["Float"]>;
    /** Quarter over quarter change in percentage. */
    qoq: Maybe<Scalars["Float"]>;
    regionId: Maybe<Scalars["Int"]>;
    timePeriodTypeId: Maybe<Scalars["String"]>;
    /** Current value for this metric. */
    value: Maybe<Scalars["Float"]>;
    /** Year over year change in percentage. */
    yoy: Maybe<Scalars["Float"]>;
};
export type HomeValueMetricsByDataType = {
    __typename?: "HomeValueMetricsByDataType";
};
export type HomeValueMetricsDetails = {
    __typename?: "HomeValueMetricsDetails";
};
export type HomeValueParent = {
    __typename?: "HomeValueParent";
    docid: Maybe<Scalars["Int"]>;
    link: Maybe<Scalars["String"]>;
    shortName: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["Int"]>;
};
export type HomeValueRegion = {
    __typename?: "HomeValueRegion";
    docid: Maybe<Scalars["Int"]>;
    link: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    regionTypeName: Maybe<Scalars["String"]>;
    shortName: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["Int"]>;
    zindexSqFt: Maybe<Scalars["Int"]>;
};
/** One point in home values time series. */
export type HomeValueTimeSeriesPoint = {
    __typename?: "HomeValueTimeSeriesPoint";
    /** Number in dollar. */
    x: Maybe<Scalars["Float"]>;
    /** Epoch time. */
    y: Maybe<Scalars["Float"]>;
};
export type HomeValuesResponse = {
    __typename?: "HomeValuesResponse";
};
/** Housing Connector Info */
export type HousingConnector = {
    __typename?: "HousingConnector";
};
export type HousingDeveloper = {
    __typename?: "HousingDeveloper";
    description: Maybe<Scalars["String"]>;
};
/** Determines when to display Housing Voucher tips and Local Content in HDP and BDP */
export type HousingVoucher = {
    __typename?: "HousingVoucher";
    /** Determines if listing meets voucher payment standards */
    voucherModuleDisplayEligible: Maybe<Scalars["Boolean"]>;
};
export type IAgentTourViewCTA = {
    isPrimary: Maybe<Scalars["Boolean"]>;
};
/** Base interface that defines the IOS apps internal routes */
export type INativeIOSDestination = {};
/** IOS Component CTA Fields */
export type IOSComponentCTA = {
    __typename?: "IOSComponentCTA";
    /** CTA text for the button on the upsell */
    primaryCTAText: Maybe<Scalars["String"]>;
    /** CTA url for webview transitions to destination */
    primaryCTAUrl: Maybe<Scalars["String"]>;
};
/** IOS Upsell Card with no CTA text and and arrow for CTA */
export type IOSUpsellArrowCTACard = {
    __typename?: "IOSUpsellArrowCTACard";
    /** Body content for the upsell card  */
    bodyText: Maybe<Scalars["String"]>;
    /** Icon url that loads an icon asset from the DAM or s3 */
    iconUrl: Maybe<Scalars["String"]>;
    /** Title text for the upsell card */
    titleText: Maybe<Scalars["String"]>;
};
/** IOS Upsell Card Component Fields */
export type IOSUpsellCard = {
    __typename?: "IOSUpsellCard";
    /** Body content for the upsell card  */
    bodyText: Maybe<Scalars["String"]>;
    /** Icon url that loads an icon asset from the DAM or s3 */
    iconUrl: Maybe<Scalars["String"]>;
    /** Field for mls note text on the upsell card */
    mlsNoteText: Maybe<Scalars["String"]>;
    /** Title text for the upsell card */
    titleText: Maybe<Scalars["String"]>;
    /** Field for tool tip message in the upsell card */
    toolTipText: Maybe<Scalars["String"]>;
    /** Field for tool tip title in the upsell card */
    toolTipTitle: Maybe<Scalars["String"]>;
};
export type ITourView = {};
export type ITourViewModule = {};
export type ITourViewModuleButton = {};
export type ITourViewModuleTextAttribute = {
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
};
export type ITourViewToast = {
    duration: Scalars["Int"];
};
export type IncomeLimitsMini = {
    __typename?: "IncomeLimitsMini";
    maximumIncome: Maybe<Scalars["Int"]>;
    occupants: Maybe<Scalars["Int"]>;
};
export type IncomeLimitsType = {
    __typename?: "IncomeLimitsType";
    maximumIncome: Maybe<Scalars["Int"]>;
    occupants: Maybe<Scalars["Int"]>;
};
export type IncomeRestrictionsMini = {
    __typename?: "IncomeRestrictionsMini";
    buildingWideMaximumIncome: Maybe<Scalars["Int"]>;
    incomeRestricted: Maybe<Scalars["Boolean"]>;
};
export type IncomeRestrictionsType = {
    __typename?: "IncomeRestrictionsType";
    buildingWideMaximumIncome: Maybe<Scalars["Int"]>;
    incomeRestricted: Maybe<Scalars["Boolean"]>;
};
export type IndexRange = {
    __typename?: "IndexRange";
    length: Scalars["Int"];
    startIndex: Scalars["Int"];
};
export type InstantTourTypeDetails = {
    __typename?: "InstantTourTypeDetails";
    dateOnly: Maybe<Scalars["Boolean"]>;
    schedulingProvider: Maybe<Scalars["String"]>;
};
export type IntegerValue = {
    __typename?: "IntegerValue";
    integer: Scalars["Int"];
};
/** Object containing latitude(lat) and longitude(long) of the building */
export type LatLong = {
    __typename?: "LatLong";
    lat: Maybe<Scalars["Float"]>;
    long: Maybe<Scalars["Float"]>;
};
export type LaunchUrlCTAAction = {
    __typename?: "LaunchUrlCTAAction";
    url: Maybe<Scalars["String"]>;
};
export type LeaseDetails = {
    __typename?: "LeaseDetails";
    /** Description of lease */
    leaseDescription: Maybe<Scalars["String"]>;
    /** Term of lease */
    leaseTerm: Maybe<Scalars["String"]>;
};
export type ListedByAction = {
    __typename?: "ListedByAction";
    /** Webview url to open contact form */
    url: Scalars["String"];
};
export type ListedByElement = {
    __typename?: "ListedByElement";
    /** Element id in listedBy section */
    id: Scalars["String"];
    /** Element text to display in listedBy section */
    text: Scalars["String"];
};
export type ListedBySection = {
    __typename?: "ListedBySection";
    /** Section id in listedby module */
    id: Scalars["String"];
};
/** Account information on the lister of the property. Admin-only. */
export type ListingAccountType = {
    __typename?: "ListingAccountType";
    email: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["Int"]>;
};
/** Listing criteria for a rental property */
export type ListingCriteria = {
    __typename?: "ListingCriteria";
    /** Whether Irene/the listing feed has indicated that cats are allowed, null if unknown */
    areCatsAllowed: Maybe<Scalars["Boolean"]>;
    /** Whether Irene/the listing feed has indicated that dogs are allowed, null if unknown */
    areDogsAllowed: Maybe<Scalars["Boolean"]>;
    /** Credit score screening criteria */
    creditScore: Maybe<Scalars["String"]>;
    /** Whether creditScore criterion is mandatory */
    creditScoreMandatory: Maybe<Scalars["Boolean"]>;
    /** The ratio of income to rent */
    incomeToRent: Maybe<Scalars["String"]>;
    /** Whether incomeToRent criterion is mandatory */
    incomeToRentMandatory: Maybe<Scalars["Boolean"]>;
    /** Whether Irene has completed the post-flow in the listing creation process and set the listing criteria */
    isZrmScreeningCriteriaSet: Maybe<Scalars["Boolean"]>;
    /** Pet policy - number of cats allowed */
    petPolicyCatCount: Maybe<Scalars["String"]>;
    /** Whether petPolicyCatCount criterion is mandatory */
    petPolicyCatCountMandatory: Maybe<Scalars["Boolean"]>;
    /** Pet policy - number of dogs allowed */
    petPolicyDogCount: Maybe<Scalars["String"]>;
    /** Whether petPolicyDogCount criterion is mandatory */
    petPolicyDogCountMandatory: Maybe<Scalars["Boolean"]>;
    /** Pet policy - dog size information */
    petPolicyDogSize: Maybe<Scalars["String"]>;
    /** Whether petPolicyDogSize criterion is mandatory */
    petPolicyDogSizeMandatory: Maybe<Scalars["Boolean"]>;
    /** Pet policy - other pets allowed on property */
    petPolicyOtherPets: Maybe<Scalars["String"]>;
    /** Whether petPolicyOtherPets criterion is mandatory */
    petPolicyOtherPetsMandatory: Maybe<Scalars["Boolean"]>;
    /** Pet policy - pet deposit amount */
    petPolicyPetDeposit: Maybe<Scalars["String"]>;
    /** Whether petPolicyPetDeposit criterion is mandatory */
    petPolicyPetDepositMandatory: Maybe<Scalars["Boolean"]>;
    /** Pet policy - pet rent amount */
    petPolicyPetRent: Maybe<Scalars["String"]>;
    /** Whether petPolicyPetRent criterion is mandatory */
    petPolicyPetRentMandatory: Maybe<Scalars["Boolean"]>;
};
/**
 * The display option selected for home-details. Currently, only one option may be
 * selected. The legacy representation is an enum
 */
export type ListingDisplayOptions = {
    __typename?: "ListingDisplayOptions";
    /** Use the default home-details behavior */
    standard: Maybe<Scalars["Boolean"]>;
    /** Really send traffic to the listing owner. (e.g. replaces contact module with traffic-generating variant) */
    superTrafficOptimized: Maybe<Scalars["Boolean"]>;
    /** Auction listing behavior 1 */
    superTrafficOptimizedADC1: Maybe<Scalars["Boolean"]>;
    /** Auction listing behavior 2 */
    superTrafficOptimizedADC2: Maybe<Scalars["Boolean"]>;
    /** Auction listing behavior 3 */
    superTrafficOptimizedADC3: Maybe<Scalars["Boolean"]>;
    /**
     * Really send traffic to the listing owner with a different
     *                    set of anchor text. (e.g. replaces contact module with traffic-generating
     *                    variant)
     */
    superTrafficOptimizedB: Maybe<Scalars["Boolean"]>;
    /** Send traffic to the listing owner (e.g. prioritize external links over contact forms). */
    trafficOptimized: Maybe<Scalars["Boolean"]>;
};
/** Reputation data for a listing provider */
export type ListingOwnerReputation = {
    __typename?: "ListingOwnerReputation";
    /** Number of applications of the listing. */
    applicationCount: Maybe<Scalars["Int"]>;
    /** Number of contacts of the listing provider. */
    contactCount: Maybe<Scalars["Int"]>;
    /** Is listing owner id verified? */
    isLandlordIdVerified: Maybe<Scalars["Boolean"]>;
    /** Response rate the listing provider contact. */
    responseRate: Maybe<Scalars["Float"]>;
    /** Response time of the listing provider contact in milliseconds. */
    responseTimeMs: Maybe<Scalars["Int"]>;
};
export type ListingProvider = {
    __typename?: "ListingProvider";
    /** License number of the listing agent */
    agentLicenseNumber: Maybe<Scalars["String"]>;
    /** Name of the listing agent */
    agentName: Maybe<Scalars["String"]>;
    /** The content of the disclaimer message */
    disclaimerText: Maybe<Scalars["String"]>;
    /** Text of an enhanced description */
    enhancedDescriptionText: Maybe<Scalars["String"]>;
    /** URL of an enhanced video */
    enhancedVideoURL: Maybe<Scalars["String"]>;
    /** Whether the description text came from Zillow Rental Manager */
    isZRMSourceText: Maybe<Scalars["Boolean"]>;
    /** Phone number of the listing agent */
    phoneNumber: Maybe<Scalars["String"]>;
    /** Name of the group that posted the listing */
    postingGroupName: Maybe<Scalars["String"]>;
    /** Text to be used for the posting website link */
    postingWebsiteLinkText: Maybe<Scalars["String"]>;
    /** URL of the posting website */
    postingWebsiteURL: Maybe<Scalars["String"]>;
    /** If an enhanced listing should be displayed */
    showEnhancedListing: Maybe<Scalars["Boolean"]>;
    /** Whether logos should be shown */
    showLogos: Maybe<Scalars["Boolean"]>;
    /** Whether logos should be shown at mobile viewport sizes */
    showMobileLogos: Maybe<Scalars["Boolean"]>;
    /** Whether to show the backup message indicating there was no contact info for the listing agent */
    showNoContactInfoMessage: Maybe<Scalars["Boolean"]>;
    /** Text describing the source of the listing */
    sourceText: Maybe<Scalars["String"]>;
    /** Title for the module */
    title: Maybe<Scalars["String"]>;
};
export type ListingProviderLogo = {
    __typename?: "ListingProviderLogo";
    /** URL to which this logo should link */
    link: Maybe<Scalars["String"]>;
    /** URL of the logo image */
    src: Maybe<Scalars["String"]>;
};
export type ListingSubType = {
    __typename?: "ListingSubType";
    isFSBA: Maybe<Scalars["Boolean"]>;
    isFSBO: Maybe<Scalars["Boolean"]>;
};
export type ListingSubtype = {
    __typename?: "ListingSubtype";
    /** is this property for-sale by agent? */
    is_FSBA: Maybe<Scalars["Boolean"]>;
    /** is this property for-sale by owner? */
    is_FSBO: Maybe<Scalars["Boolean"]>;
    is_bankOwned: Maybe<Scalars["Boolean"]>;
    is_comingSoon: Maybe<Scalars["Boolean"]>;
    is_forAuction: Maybe<Scalars["Boolean"]>;
    is_foreclosure: Maybe<Scalars["Boolean"]>;
    is_newHome: Maybe<Scalars["Boolean"]>;
    is_openHouse: Maybe<Scalars["Boolean"]>;
    /** is sale of this property pending? */
    is_pending: Maybe<Scalars["Boolean"]>;
    is_roomForRent: Maybe<Scalars["Boolean"]>;
};
/**
 * The object in API response is same as V1 endpoint StandingOfferData.Based on
 * requirement we rename it to live offer in GDP schema
 */
export type LiveOfferData = {
    __typename?: "LiveOfferData";
    liveOfferGroup: Maybe<Scalars["String"]>;
    liveOfferPrice: Maybe<Scalars["Int"]>;
};
export type LivingQuarterType = {
    __typename?: "LivingQuarterType";
    areaTotal: Maybe<Scalars["Float"]>;
    areaTotalUnits: Maybe<Scalars["String"]>;
    features: Maybe<Scalars["String"]>;
    livingArea: Maybe<Scalars["Float"]>;
    livingAreaUnits: Maybe<Scalars["String"]>;
    livingQuarterType: Maybe<Scalars["String"]>;
};
export type LoanDetails = {
    __typename?: "LoanDetails";
    loanDetailsString: Maybe<Scalars["String"]>;
    rate: Maybe<Scalars["Float"]>;
    rateSource: Maybe<Scalars["String"]>;
};
export type LoanOfficer = {
    __typename?: "LoanOfficer";
    email: Scalars["String"];
    name: Scalars["String"];
    officePhone: Scalars["String"];
    title: Maybe<Scalars["String"]>;
};
/** Local voucher information to render on HDP and BDP */
export type LocalVoucherContent = {
    __typename?: "LocalVoucherContent";
    /** City to be rendered */
    city: Maybe<Scalars["String"]>;
    /** Incentive language to be rendered */
    incentiveLanguage: Maybe<Scalars["String"]>;
    /** Determines if city or state will be rendered */
    isLawLevelState: Maybe<Scalars["Boolean"]>;
    /** Public housing authority to be rendered */
    publicHousingAuthority: Maybe<Scalars["String"]>;
    /** Report abuse agency to be rendered */
    reportAbuseAgency: Maybe<Scalars["String"]>;
    /** Report abuse agency phone number to be rendered */
    reportAbusePhone: Maybe<Scalars["String"]>;
    /** State to be rendered */
    state: Maybe<Scalars["String"]>;
    /** Violation fine value to be rendered */
    violationFineValue: Maybe<Scalars["Int"]>;
};
/**
 * This type allows us to pass flags under extended_info_txt. The list of flags
 * here will be mapped into the dictionary on the client side.
 */
export type MapEntry = {
    __typename?: "MapEntry";
    key: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["String"]>;
};
export type MarketInsightsType = {
    __typename?: "MarketInsightsType";
    path: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};
/**
 * One treatment is a special UI design to be potentially displayed on a placement
 * of a page. Its display data has been defined in the CMS tool by marketers
 */
export type MessageTreatmentType = {
    __typename?: "MessageTreatmentType";
    /** The Constellation component's name which is used to render this treatment */
    component: Maybe<Scalars["String"]>;
    id: Scalars["Int"];
    lastModified: Scalars["String"];
    name: Scalars["String"];
    /** The Constellation component's props JSON serialized as String */
    renderingProps: Maybe<Scalars["JSON"]>;
};
export type MetaData = {
    __typename?: "MetaData";
};
export type MisoContactInfo = {
    __typename?: "MisoContactInfo";
    /**  Email address of Sebastian  */
    email: Scalars["String"];
    /**  Full name of Sebastian  */
    fullName: Scalars["String"];
    /**  Contact number of Sebastian  */
    phoneNumber: Scalars["String"];
};
/** Vendor-provided model home address */
export type ModelHomeAddress = {
    __typename?: "ModelHomeAddress";
    city: Scalars["String"];
    latitude: Maybe<Scalars["String"]>;
    longitude: Maybe<Scalars["String"]>;
    postalCode: Scalars["String"];
    state: Scalars["String"];
    street1: Scalars["String"];
    street2: Maybe<Scalars["String"]>;
};
export type ModelHomeInfo = {
    __typename?: "ModelHomeInfo";
    /** Distance from the actual property to the model home */
    distanceToModelHome: Maybe<Scalars["Int"]>;
    /** Whether tour is for a representative property or the actual property */
    hasModelHome: Maybe<Scalars["Boolean"]>;
    /** Plan name of the model home */
    planName: Maybe<Scalars["String"]>;
};
export type MonthlyCostCalculator = {
    __typename?: "MonthlyCostCalculator";
};
export type Mortgage = {
    __typename?: "Mortgage";
    eventDateTime: Maybe<Scalars["String"]>;
    isPreferredLoanOfficerDisabled: Maybe<Scalars["Boolean"]>;
    loanFileServiceId: Maybe<Scalars["String"]>;
};
export type MortgageCTA = {
    __typename?: "MortgageCTA";
    /** This is copy text/ label that will be shown on the mortgage CTA on the FSHDP Chip */
    ctaCopyText: Maybe<Scalars["String"]>;
    /** When the CTA is clicked, this is the URL with parameters that the user will be routed to */
    routingURL: Maybe<Scalars["String"]>;
};
export type MortgageCalculationAssumptionsSection = {
    __typename?: "MortgageCalculationAssumptionsSection";
    /** this will hold the title string for the assumptions section of the personalized payment output */
    title: Maybe<Scalars["String"]>;
};
export type MortgageCalculationBreakdownSection = {
    __typename?: "MortgageCalculationBreakdownSection";
    /** this will hold the title string for the breakdown section */
    title: Maybe<Scalars["String"]>;
};
export type MortgageChip = {
    __typename?: "MortgageChip";
    /** This is copy text/ label that will be shown on the FSHDP Chip */
    chipCopyText: Maybe<Scalars["String"]>;
    /** This value will indicate if or not the mortgage chip returned is the personalizable chip */
    isPersonalized: Maybe<Scalars["Boolean"]>;
    /** provides information on whether or not the client should display the mortgage CTA */
    showCTA: Maybe<Scalars["Boolean"]>;
    /** provides information on whether or not the client should display the dollar icon */
    showDollarIcon: Maybe<Scalars["Boolean"]>;
    /** this will be true if and only if the chip is personalizable and the inline tooltip should be shown */
    showInlineTooltip: Maybe<Scalars["Boolean"]>;
    /** provides information on whether or not the client should display the tooltip */
    showTooltip: Maybe<Scalars["Boolean"]>;
    /** provides information on whether or not the client should display the total monthly cost */
    showTotalMonthlyCost: Maybe<Scalars["Boolean"]>;
    /** The tooltip text that provides information on the mortgage CTA eg: disclaimer for mortgage rates */
    tooltipCopyText: Maybe<Scalars["String"]>;
};
export type MortgageCreditRangeSection = {
    __typename?: "MortgageCreditRangeSection";
    /** The label on the PP input screen for the credit score input UI */
    labelCopy: Maybe<Scalars["String"]>;
};
export type MortgageDownPaymentSection = {
    __typename?: "MortgageDownPaymentSection";
    amountCopy: Maybe<Scalars["String"]>;
    amountInCurrency: Maybe<Scalars["String"]>;
    currencyHelperText: Maybe<Scalars["String"]>;
    downpaymentCopy: Maybe<Scalars["String"]>;
    helperText: Maybe<Scalars["String"]>;
    inPercentage: Maybe<Scalars["String"]>;
    percentageCopy: Maybe<Scalars["String"]>;
    percentageHelperText: Maybe<Scalars["String"]>;
    usePercentage: Maybe<Scalars["Boolean"]>;
};
export type MortgageExperiment = {
    __typename?: "MortgageExperiment";
    /** true if this is an active experiment, false otherwise */
    isActiveExperiment: Maybe<Scalars["Boolean"]>;
    /** name of the assigned and applied treatment of the active AB trial, empty otherwise */
    treatmentName: Maybe<Scalars["String"]>;
    /** name of the active AB trial, empty otherwise */
    trialName: Maybe<Scalars["String"]>;
};
export type MortgageHero = {
    __typename?: "MortgageHero";
    /** This will hold the body text to display on the hero */
    bodyText: Maybe<Scalars["String"]>;
    /** This will hold the string that holds the total estimated payment calculated. eg: $12,500/month' */
    estMonthlyPayment: Maybe<Scalars["String"]>;
    /**
     * This will be set to true for the hub to show the tooltip next to the
     * 'Estimated payment' title. N/A for the hub at this point
     */
    showTitleTooltip: Maybe<Scalars["Boolean"]>;
    /** This will be the title within the hero, eg: 'Estimated payment' in the hub but would be different in the Spoke */
    title: Maybe<Scalars["String"]>;
};
export type MortgageHub = {
    __typename?: "MortgageHub";
};
export type MortgageLineItem = {
    __typename?: "MortgageLineItem";
    copy: Maybe<Scalars["String"]>;
    percentageOfTotal: Maybe<Scalars["Int"]>;
    showTooltip: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use tooltip instead */
    tooltipCopy: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["String"]>;
};
export type MortgageLink = {
    __typename?: "MortgageLink";
    /** The copy text that will be used in the UI but route to the link that the field below will hold */
    copy: Maybe<Scalars["String"]>;
    /**
     * the url to which the user should be routed, this field will also contain any
     * routing parameters that are applicable to the scenario and user
     */
    link: Maybe<Scalars["String"]>;
};
export type MortgagePersonalizedPaymentData = {
    __typename?: "MortgagePersonalizedPaymentData";
};
export type MortgagePersonalizedPaymentInputScreen = {
    __typename?: "MortgagePersonalizedPaymentInputScreen";
    footerPersonalization: Maybe<Scalars["String"]>;
    loginAndSaveActionButtonCopy: Maybe<Scalars["String"]>;
    privacyPolicyText: Maybe<Scalars["String"]>;
    saveActionButtonCopy: Maybe<Scalars["String"]>;
};
export type MortgagePersonalizedPaymentOutputScreen = {
    __typename?: "MortgagePersonalizedPaymentOutputScreen";
    /** The address to display on the output screen */
    address: Maybe<Scalars["String"]>;
    /** The title for the output screen */
    title: Maybe<Scalars["String"]>;
};
/** rent your money */
export type MortgageRates = {
    __typename?: "MortgageRates";
    /** @deprecated To be turned into an object */
    arm5Rate: Maybe<Scalars["Float"]>;
    /** @deprecated To be turned into an object */
    fifteenYearFixedRate: Maybe<Scalars["Float"]>;
    /** @deprecated To be turned into an object */
    thirtyYearFixedRate: Maybe<Scalars["Float"]>;
};
export type MortgageSpoke = {
    __typename?: "MortgageSpoke";
    /**  The address of the HDP property */
    address: Maybe<Scalars["String"]>;
    /** The body text to display for the spoke */
    bodyText: Maybe<Scalars["String"]>;
    /** The title for the spoke, currently expected to be 'Estimated payment' */
    title: Maybe<Scalars["String"]>;
};
export type MortgageTooltipInline = {
    __typename?: "MortgageTooltipInline";
    /** The informational tooltip text */
    bodyCopy: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type MortgageUICreditRanges = {
    __typename?: "MortgageUICreditRanges";
    /** Should hold the second highest credit score range, which is currently (660 - 719) */
    highRangeCopy: Maybe<Scalars["String"]>;
    /** Should hold the highest credit score range, which is currently (720-840) */
    highestRangeCopy: Maybe<Scalars["String"]>;
    /** Should hold the next lower credit score range, which is currently (580 - 619) */
    lowRangeCopy: Maybe<Scalars["String"]>;
    /** Should hold the lowest credit score range, which is currently (300 - 579) */
    lowestRangeCopy: Maybe<Scalars["String"]>;
    /** Should hold the middle credit score range, which is currently (620 - 659) */
    middleRangeCopy: Maybe<Scalars["String"]>;
};
/** rent your money */
export type MortgageZHLRates = {
    __typename?: "MortgageZHLRates";
};
export type MultiFactorAuthData = {
    __typename?: "MultiFactorAuthData";
    isEnabled: Scalars["Boolean"];
    phoneNumber: Maybe<Scalars["String"]>;
};
/** A set of image source sets */
export type MultiImageSourceType = {
    __typename?: "MultiImageSourceType";
};
/**
 * Zillow entities described here generally allow anonymous clients
 * to retrieve data pertaining to homes and localities.
 *
 * When the schema provides access to data about persons,
 * it must be reviewed for conformance to PII
 * (personally identifying information) disclosure policy.
 */
export type Mutation = {
    __typename?: "Mutation";
    _noop: Maybe<Scalars["String"]>;
    /**  accept the coShopping invitation from the inviter  */
    acceptCoShopper: Maybe<Scalars["Boolean"]>;
    /** Activate a previously created loan in Blend */
    activateBlendLoan: Maybe<ActivateBlendLoanOutput>;
    activateZHLDashboardUser: ZHLDashboardUserActivationResult;
    addQuestionnaire: Maybe<Scalars["Boolean"]>;
    /**  add a category to an existing saved home's category list  */
    addSavedHomeCategory: Maybe<Scalars["Boolean"]>;
    /** Add a self-reported visit for a given user to a specific ZPID */
    addVisitedHome: Maybe<Scalars["Boolean"]>;
    /**  apply a custom property tag text on a given property */
    applyCustomPropertyTag: Maybe<Scalars["Boolean"]>;
    /**  apply a property tag on a given property  */
    applyPropertyTag: Maybe<Scalars["Boolean"]>;
    /**
     * This mutation archives an existing task.
     * @deprecated Do not use this mutation in prod. Use the dev environment instead.
     */
    archiveTask: Maybe<Scalars["Boolean"]>;
    /**  trigger new offers creation for seller dashboard  */
    createOffers: Scalars["ID"];
    /**
     *  mutation to compute In/Out market value for sellside and buyside questionnaire submission
     * @deprecated cross-sell deprecation
     */
    decideMarketScopeForBuyAndSell: Maybe<Scalars["Boolean"]>;
    /**  decline the coShopping invitation from the inviter  */
    declineCoShopper: Maybe<Scalars["Boolean"]>;
    deleteCommuteDestination: Maybe<Scalars["String"]>;
    deleteCurrentIncome: Maybe<Scalars["Boolean"]>;
    deletePastJob: Maybe<Scalars["Boolean"]>;
    deletePastResidence: Maybe<Scalars["Boolean"]>;
    /**  delete the property tag */
    deletePropertyTag: Maybe<Scalars["Boolean"]>;
    deleteSavedSearch: Maybe<Scalars["Boolean"]>;
    /**  remove user note from the given property  */
    deleteUserNote: Maybe<Scalars["Boolean"]>;
    /** Dismiss the specified renter hub notifications */
    dismissNotifications: Maybe<Scalars["Boolean"]>;
    generateZHLDashboardUserActivationToken: ZHLDashboardGenerateActivationTokenResult;
    generateZHLDashboardUserActivationTokenForLead: ZHLDashboardGenerateActivationTokenResult;
    /**  hide a home (only support zpid now) for the signed in user */
    hideHome: Maybe<Scalars["Boolean"]>;
    /**  mutation to re-drive miso Questionnaire datalake payload  */
    redriveMisoDataLakeQuestionnaireData: Scalars["Boolean"];
    /**  remove all the saved homes for the signed in user */
    removeAllSavedHomes: Maybe<Scalars["Boolean"]>;
    /**  remove the applied property tag from the property  */
    removeAppliedPropertyTag: Maybe<Scalars["Boolean"]>;
    /**  remove the user's coShopper  */
    removeCoShopper: Maybe<Scalars["Boolean"]>;
    removeInvitation: Maybe<Scalars["Boolean"]>;
    /**  remove saved home for the signed in user */
    removeSavedHome: Maybe<Scalars["Boolean"]>;
    /**  remove a category from an existing saved home's category list  */
    removeSavedHomeCategory: Maybe<Scalars["Boolean"]>;
    /** Remove a self-reported visit for a given user to a specific ZPID */
    removeVisitedHome: Maybe<Scalars["Boolean"]>;
    /**  request agent connection for given offer misoId  */
    requestAgentConnection: Scalars["Boolean"];
    /**  request call from advisor for the given offer misoId  */
    requestCallFromAdvisor: Scalars["Boolean"];
    /**  request LTA connection for given offer misoId  */
    requestLTAAgentConnection: Scalars["Boolean"];
    /**
     *  request Automated Directed Lead (ADL) connection from Pearl
     * @deprecated Use requestAgentConnection
     */
    requestSellingOffersConnection: Scalars["Boolean"];
    /**
     *  request Live Transfer Agent (LTA) connection from Pearl
     * @deprecated Use requestLTAAgentConnection
     */
    requestSellingOffersLTAConnection: Scalars["Boolean"];
    saveHome: Maybe<Scalars["Boolean"]>;
    saveHomeV2: Maybe<Scalars["Boolean"]>;
    /**  save a home (zpid or building) for the signed in user, this is new mutation recommended for all new clients */
    saveOrUpdateHome: Maybe<Scalars["Boolean"]>;
    saveSuccessSurvey: Maybe<Scalars["Boolean"]>;
    /**  Mutation to submit miso ineligible response. This will be exposed in ZG-Graph but this is not used by FE now  */
    submitSellingOptionsIneligibleInfo: Maybe<Scalars["Boolean"]>;
    /**  Mutation to submit Sebastian responses for questionnaire. Deprecated mutation, use upsertMutation  */
    submitSellingOptionsQuestionnaireAnswers: Maybe<Scalars["Boolean"]>;
    /**  remove all hidden homes the user has for the signed in user */
    unhideAllHomes: Maybe<Scalars["Boolean"]>;
    /**  remove a hidden home (only support zpid now) for the signed in user */
    unhideHome: Maybe<Scalars["Boolean"]>;
    unsaveAllHomes: Maybe<Scalars["Boolean"]>;
    unsaveHome: Maybe<Scalars["Boolean"]>;
    unsaveHomeV2: Maybe<Scalars["Boolean"]>;
    updateFavoritesPageSort: Maybe<Scalars["Boolean"]>;
    /**  mark the list of properties as viewed for the user */
    updatePropertyView: Maybe<Scalars["Boolean"]>;
    updateSavedSearchFrequency: Maybe<Scalars["Boolean"]>;
    updateSavedSearchName: Maybe<Scalars["Boolean"]>;
    /**  CCPA purpose only, mutation to update Sebastian responses  */
    updateSellingOptionsQuestionnaireAnswers: Maybe<Scalars["Boolean"]>;
    /**  update user note on a given property  */
    updateUserNote: Maybe<Scalars["Boolean"]>;
    /**
     *  Mutation to submit or update Sebastian responses for buyside questionnaire. This mutation is exposed in ZG-Graph
     * @deprecated cross-sell deprecation
     */
    upsertBuySideQuestionnaireAnswers: Maybe<Scalars["Boolean"]>;
    /**
     *  upsert Buyside questionnaire responseId to miso case
     * @deprecated cross-sell deprecation
     */
    upsertBuysideData: Maybe<Scalars["Boolean"]>;
    /**  Mutation to submit or update Sebastian responses for questionnaire. This mutation is exposed in ZG-Graph  */
    upsertSellingOptionsQuestionnaireAnswers: Maybe<Scalars["Boolean"]>;
    withdrawApplication: Maybe<Scalars["Boolean"]>;
    /**
     * Sends a new message to an existing conversation
     * Will implicitly pass in authenticated user info
     */
    zibsSendMessage: Maybe<Scalars["Boolean"]>;
};
export type MyAgentReconnections = {
    __typename?: "MyAgentReconnections";
    supportingText: Scalars["String"];
    title: Scalars["String"];
};
/** This block is used to create the nba contextual block in the NBA NL events. */
export type NbaBlock = {
    __typename?: "NbaBlock";
    /** If no NBA mapping was selected, this field should be set to true */
    fallBackActionRankingUsedInd: Maybe<Scalars["Boolean"]>;
    /** A boolean to indicate if NBA is used in selection process */
    isNbaProcessed: Maybe<Scalars["Boolean"]>;
    /** Unique ID returned from the NBA Orchestration Service for a request */
    joiningUuid: Maybe<Scalars["String"]>;
    /** Location of the upsell */
    position: Maybe<Scalars["String"]>;
    /**
     * Indicates the “version” of this data. If an existing field changes meaning,
     * this number should be incremented. Note this is different than schema change
     */
    semanticVersionId: Maybe<Scalars["Int"]>;
    /**
     * A boolean indicator to show NBA service error. Set to True if the NBA
     * Orchestration Service is returning an error to the client. False otherwise.
     */
    serviceErrorInd: Maybe<Scalars["Boolean"]>;
    /** If there was a NBA service error, the error message is returned */
    serviceErrorTxt: Maybe<Scalars["String"]>;
    /** Unique id for a page */
    surfaceId: Maybe<Scalars["String"]>;
    /**
     * A boolean indicator that should be set to true if a call to a measurement
     * system was made to report this user being exposed.
     */
    userImpressionReportedInd: Maybe<Scalars["Boolean"]>;
};
/** A new construction home */
export type NcProperty = {
    __typename?: "NcProperty";
    /** The number of available plans for this NC lot */
    availablePlanCount: Maybe<Scalars["Int"]>;
    /** The ID of an object */
    id: Scalars["ID"];
    /** Cost of the lot or land associated with a posting on this property */
    lotPremium: Maybe<Scalars["Int"]>;
    /** zillow property id */
    zpid: Maybe<Scalars["Int"]>;
};
export type NearbyBuildingLink = {
    __typename?: "NearbyBuildingLink";
};
/** An object with an ID */
export type Node = {
    /** The id of the object. */
    id: Scalars["ID"];
};
export type NonConfirmationUpsellPage = {
    __typename?: "NonConfirmationUpsellPage";
    pageTransitionText: Scalars["String"];
    title: Scalars["String"];
};
export type NonConfirmation_ContactAgent = {
    __typename?: "NonConfirmation_ContactAgent";
    heading: Scalars["String"];
    subheading: Scalars["String"];
};
export type NonConfirmation_Financing = {
    __typename?: "NonConfirmation_Financing";
    affordabilityTitle: Scalars["String"];
    finePrint: Scalars["String"];
};
export type Offer = {
    __typename?: "Offer";
    offerRequestId: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["Int"]>;
    zuid: Maybe<Scalars["Int"]>;
};
export type OfferUpsellData = {
    __typename?: "OfferUpsellData";
};
/** This block is used to create the omp contextual block in the omp new lane events. */
export type OmpBlock = {
    __typename?: "OmpBlock";
    /** The placement's corresponding AB bucket that the user falls in */
    bucket: Maybe<Scalars["String"]>;
    /** User's decision context encoded zuid */
    decisionContextEncodedZuid: Maybe<Scalars["String"]>;
    /** User guid */
    decisionContextGuid: Maybe<Scalars["String"]>;
    /**
     * For certain placement, we will simulate a random coin flip to decide whether
     * to render the chosen treatment on UI, so that the user won't be overwhelmed by
     * messages on every page view
     */
    didPassThrottle: Maybe<Scalars["Boolean"]>;
    /** A unique event id for clickstream events for upsells to help track them in analytics */
    eventId: Maybe<Scalars["String"]>;
    /** A boolean to indicate if the user guid is in OMP global holdout bucket */
    isGlobalHoldout: Maybe<Scalars["Boolean"]>;
    /** A boolean to indicate whether the user guid is in OMP placement-level holdout bucket */
    isPlacementHoldout: Maybe<Scalars["Boolean"]>;
    /** Timestamp when the placement config data was last modified */
    lastModified: Maybe<Scalars["String"]>;
    /** Placement id */
    placementId: Maybe<Scalars["Int"]>;
    /** The placement where OMP displays the message */
    placementName: Maybe<Scalars["String"]>;
    /** A list of Baseline treatments that the user is eligible for */
    qualifiedTreatmentBaselineEvaluation: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of OMP Portfolio treatments that the user is eligible for */
    qualifiedTreatmentPortfolio: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of OMP Portfolio Test treatments that the user is eligible for */
    qualifiedTreatmentPortfolioTest: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** A list of Target Selection treatments that the user is eligible for */
    qualifiedTreatmentTargetSelection: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Selected treatment's experiment family */
    selectedTreatmentExperimentFamilyNm: Maybe<Scalars["String"]>;
    /** Selected treatment's experiment iteration */
    selectedTreatmentExperimentIterationTxt: Maybe<Scalars["String"]>;
    /** Selected treatment's id number */
    selectedTreatmentId: Maybe<Scalars["Int"]>;
    /** Selected treatment's last modified timestamp */
    selectedTreatmentLastModified: Maybe<Scalars["String"]>;
    /** Selected treatment's line of business */
    selectedTreatmentLobNm: Maybe<Scalars["String"]>;
    /** Selected treatment's location, e.g. top */
    selectedTreatmentLocationNm: Maybe<Scalars["String"]>;
    /** Selected treatment's name */
    selectedTreatmentName: Maybe<Scalars["String"]>;
    /** Selected treatment's placement, e.g. fshdp */
    selectedTreatmentPlacement: Maybe<Scalars["String"]>;
    /** Selected treatment's status */
    selectedTreatmentStatus: Maybe<Scalars["String"]>;
    /** Selected treatment's variation name */
    selectedTreatmentVariationNm: Maybe<Scalars["String"]>;
    /** A boolean to indicate whether the selected treatment (if any) should be displayed for the user */
    shouldDisplay: Maybe<Scalars["Boolean"]>;
    /** If the selected treatment is decided not to be displayed, this field will explain the reason of skipping displaying */
    skipDisplayReason: Maybe<Scalars["String"]>;
    /** The experiment phase that the user falls in */
    testPhase: Maybe<Scalars["String"]>;
};
export type OnMarketZestimate = {
    __typename?: "OnMarketZestimate";
    zestimate: Maybe<Scalars["Int"]>;
    zestimateHighPercent: Maybe<Scalars["String"]>;
    zestimateLowPercent: Maybe<Scalars["String"]>;
};
/** A collection of message display decisions for a given list of placements */
export type OnsiteMessageResultType = {
    __typename?: "OnsiteMessageResultType";
    /**
     * [Deprecated] a JSON String that contains all the context data used or to be
     * used to make the treatment selection decision (which will be logged and used
     * by data scientists)
     * @deprecated Deprecated to move field into [messages] to better support bulk requests for Onsite Message selection decisions
     */
    decisionContext: Scalars["JSON"];
    /**
     * [Deprecated] field for unique event id for the chosen treatment
     * @deprecated Deprecated to move field into [messages] to better support bulk requests for Onsite Message selection decisions
     */
    eventId: Scalars["String"];
};
export type OpenHouse = {
    __typename?: "OpenHouse";
    endTime: Maybe<Scalars["String"]>;
    openHouseMethod: Maybe<Scalars["String"]>;
    startTime: Maybe<Scalars["String"]>;
    virtualOpenHouseURL: Maybe<Scalars["String"]>;
};
export type OpportunityData = {
    __typename?: "OpportunityData";
    lastModifiedDate: Maybe<Scalars["String"]>;
};
/** Account information on the owner of the property. Admin-only. */
export type OwnerAccountType = {
    __typename?: "OwnerAccountType";
    email: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["Int"]>;
};
export type PAAgent = {
    __typename?: "PAAgent";
    betaGroups: Maybe<Array<Scalars["String"]>>;
    businessName: Maybe<Scalars["String"]>;
    dotloopLinked: Scalars["Boolean"];
    email: Maybe<Scalars["String"]>;
    encodedZillowUserId: Maybe<Scalars["String"]>;
    flexReason: Maybe<Scalars["String"]>;
    flexStatus: Maybe<Scalars["String"]>;
    hasFlex: Maybe<Scalars["Boolean"]>;
    hasMyAgent: Scalars["Boolean"];
    hasPA4: Scalars["Boolean"];
    hasPremierAgent: Scalars["Boolean"];
    hasTpro: Scalars["Boolean"];
    /** @deprecated Zillow offers is deprecated */
    hasZillowOffers: Scalars["Boolean"];
    isAgent: Maybe<Scalars["Boolean"]>;
    isAgentOrTeamLeadPaying: Maybe<Scalars["Boolean"]>;
    isBroker: Maybe<Scalars["Boolean"]>;
    isGrowthPartner: Maybe<Scalars["Boolean"]>;
    isPACEnabled: Scalars["Boolean"];
    isPaying: Maybe<Scalars["Boolean"]>;
    isTeamLead: Maybe<Scalars["Boolean"]>;
    isTeamMember: Maybe<Scalars["Boolean"]>;
    isTwilioEnabled: Scalars["Boolean"];
    /** @deprecated ZCS is deprecated, used by legacy apps */
    isZcsPartner: Maybe<Scalars["Boolean"]>;
    mailbox: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    phone: Maybe<Scalars["String"]>;
    photoUrl: Maybe<Scalars["String"]>;
    screenName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The name of the team the agent leads, or the public team they're a member of.
     * **Auth:** Public
     * **Source:** Profile Data Management via PA Graph
     */
    teamName: Maybe<Scalars["String"]>;
    twilioNumber: Maybe<Scalars["String"]>;
    usesEscrow: Scalars["Boolean"];
    website: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    zillowUserId: Scalars["Int"];
};
export type PAAgentZipCampaign = {
    regionId: Maybe<Scalars["Int"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type PAAgentZipCampaigns = {
    __typename?: "PAAgentZipCampaigns";
};
export type PAContact = {
    __typename?: "PAContact";
    /**
     * **Definition:** Contact Background
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    background: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Contact birthday
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    birthdayDate: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Contact company
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    company: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     * @deprecated Use id for ID type
     */
    contactId: Scalars["Int"];
    /**
     * **Definition:** Contact creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate: Scalars["DateTime"];
    /**
     * **Definition:** Contact display name, with fallback to email or phone
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Get contact email
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    email: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Encoded contact id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    encodedContactId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Contact first name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    firstName: Scalars["String"];
    /**
     * **Definition:** Deeplink from PA app to Follow Up Boss app.
     * **Datasource:** Webhook Subscription API
     *
     * **Team Slack:** #sirius-business
     */
    fubDeeplinkUrl: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Does contact have an agent?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasAgent: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Contact has mortgage lender?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasMortgageLender: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Contact requested pre-approval?
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    hasRequestedPreApproval: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Contact id
     *
     * **Team Slack:** #theclosers
     */
    id: Scalars["ID"];
    /**
     * **Definition:** Is contact billable. When contact in flex or ZO
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isBillable: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** If contact is in flex channel
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isFlex: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:**
     *
     * Determine if this Contact has MyAgent Relationship with assignee or the team lead
     *
     * Note: Currently only work with the logged in agent access token and not the agentZuid param/scoped token until we migrate fully migrate paContact query to pa-crm-subgraph
     *
     * **Team Slack:** #my-agent
     */
    isMyAgentLinked: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Contact job title
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    jobTitle: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Contact last modifiied date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastModifiedDateTime: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Contact last name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastName: Scalars["String"];
    /**
     * **Definition:** Miso Id
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    misoId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Total number of notes for this contact
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    noteTotal: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** Loan officer visibility disclaimer
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    notesViewDisclaimerText: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Percentage change in saves compared to similar previous period
     *
     * **Datasource:** BUA API
     *
     * **Team Slack:** #sirius-business
     */
    percentageSavedChange: Maybe<Scalars["Float"]>;
    /**
     * **Definition:** Percentage change in views compared to similar previous period
     *
     * **Datasource:** BUA API
     *
     * **Team Slack:** #sirius-business
     */
    percentageViewedChange: Maybe<Scalars["Float"]>;
    /**
     * **Definition:** Contact's polaris Id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    polarisId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Price point
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    pricePoint: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** Get contact source (eg. zillow, trulia, streeteasy, outbound email, outbound sms etc.
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    source: Scalars["String"];
    /**
     * **Definition:** Contact timeframe (values: 0, 1, 3, 6, justlooking)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Use PAContact.timeframeData instead
     */
    timeframe: Scalars["String"];
    /**
     * **Definition:** Determine if contact is interested in ZHL.
     * **Datasource:** Contacts Resource -> Contact table (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    wantsFinancingWithZHL: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Zillow Account Zuid associated with this contact
     *
     * **Team Slack:** #theclosers
     */
    zillowAccountZuid: Maybe<Scalars["String"]>;
};
export type PAContactActionInterval = {
    __typename?: "PAContactActionInterval";
    /**
     * **Definition:** Action interval ID
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    actionIntervalId: Scalars["ID"];
    /**
     * **Definition:** Display name for the action interval
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars["String"];
};
export type PAContactActivityEvents = {
    __typename?: "PAContactActivityEvents";
    /** Contact is online now when lastActivityDate is within 30 mins */
    isOnlineNow: Maybe<Scalars["Boolean"]>;
    /** Last activity date */
    lastActivityDate: Maybe<Scalars["DateTime"]>;
    /** @deprecated Email event is deprecated */
    openedEmailCount: Maybe<Scalars["Int"]>;
    /** Number of home saved */
    savedHomeCount: Maybe<Scalars["Int"]>;
    /** @deprecated Email event is deprecated */
    sentEmailCount: Maybe<Scalars["Int"]>;
    /** Number of home views */
    viewedHomeCount: Maybe<Scalars["Int"]>;
};
export type PAContactActivityPreferences = {
    __typename?: "PAContactActivityPreferences";
    bathrooms: Maybe<Scalars["String"]>;
    bedrooms: Maybe<Scalars["String"]>;
    hometype: Maybe<Array<Scalars["String"]>>;
    neighborhoods: Maybe<Array<Scalars["String"]>>;
    price: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["String"]>;
    zipcodes: Maybe<Array<Scalars["String"]>>;
};
export type PAContactActivitySummaries = {
    __typename?: "PAContactActivitySummaries";
};
export type PAContactAddress = {
    __typename?: "PAContactAddress";
    address: Maybe<Scalars["String"]>;
    address2: Maybe<Scalars["String"]>;
    city: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["Int"]>;
    stateCode: Maybe<Scalars["String"]>;
    zip: Maybe<Scalars["String"]>;
};
export type PAContactAssistStatus = {
    __typename?: "PAContactAssistStatus";
    /** Assist status detail */
    detail: Maybe<Scalars["String"]>;
    /** Contact assist status */
    status: Maybe<Scalars["Int"]>;
    /** Assist status summary */
    summary: Maybe<Scalars["String"]>;
    /** Assist status update date time */
    updateDateTime: Maybe<Scalars["DateTime"]>;
};
export type PAContactEmailEvent = {
    __typename?: "PAContactEmailEvent";
    brand: Maybe<Scalars["String"]>;
    campaignType: Maybe<Scalars["String"]>;
    eventDate: Maybe<Scalars["String"]>;
    sentTimestampUtc: Maybe<Scalars["DateTime"]>;
};
export type PAContactForwardHistory = {
    __typename?: "PAContactForwardHistory";
    /**
     * **Definition:** Contact creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    agentEmail: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Agent name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    agentName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Forward history event creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Forwarding rule id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    forwardingRuleID: Maybe<Scalars["ID"]>;
    /** @deprecated Use forwardingRuleID instead. */
    forwardingRuleId: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** Forward history id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    id: Maybe<Scalars["Int"]>;
};
export type PAContactHistoryEvent = {
    __typename?: "PAContactHistoryEvent";
    /**
     * Event copy
     *
     * eg: Transaction details added for
     */
    eventCopy: Maybe<Scalars["String"]>;
    /**
     * Event data
     *
     * eg: 555 1/2 28 3/4 Rd, Grand Junction, CO, 81501
     */
    eventData: Maybe<Scalars["String"]>;
    /** Event data time */
    eventDate: Maybe<Scalars["DateTime"]>;
    /**
     * Event icon url
     *
     * eg: http://static-resource.zg-ap-apps.com.s3.us-west-2.amazonaws.com/transactionIcon.png
     */
    eventIconUrl: Maybe<Scalars["String"]>;
    /**
     * Event source
     *
     * eg: Zillow, Follow up boss
     */
    eventSource: Maybe<Scalars["String"]>;
    /**
     * Event type
     *
     * (eg: contact.create, contact.delete, contactLender.create, contactForward.create,
     * contactLoop.create, contactNote.create, contactTransaction.create, contactNote.delete,
     * contactAssist.update, contact.update.status, contact.update.timeframe, contactTransaction.update,
     * agentContactLink.update)
     */
    eventType: Maybe<Scalars["String"]>;
};
export type PAContactHomeRecommendation = {
    __typename?: "PAContactHomeRecommendation";
    /**
     * **Definition:** Listing office
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    listingOffice: Maybe<Scalars["String"]>;
    /**
     * **Definition:** MLS ID
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    mlsId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** MLS Logo
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    mlsLogo: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Number of bathrooms
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    numBaths: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Number of beds
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    numBeds: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** Home price
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    price: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** zpid
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    propertyId: Scalars["ID"];
    /**
     * **Definition:** URL to the HDP
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    propertyUrl: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Website the HDP is from
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    source: Maybe<Scalars["String"]>;
    /**
     * **Definition:** House square feet
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    sqft: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** House status
     * **Datasource:** Collections api
     *
     * **Team Slack:** #sirius-business
     */
    status: Maybe<Scalars["String"]>;
};
export type PAContactHomeRecommendationCollection = {
    __typename?: "PAContactHomeRecommendationCollection";
    /**
     * **Definition:** Contact home recommendations collection name
     * **Datasource:** Collections Api
     *
     * **Team Slack:** #theclosers
     */
    collectionName: Maybe<Scalars["String"]>;
};
export type PAContactLoanStatus = {
    __typename?: "PAContactLoanStatus";
    /**
     * **Definition:** Loan status display name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Loan status type
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    type: Maybe<Scalars["String"]>;
};
/**
 * **Definition:** Contact Managed Tags
 *
 * **Team Slack:** #theclosers
 */
export type PAContactManagedTag = {
    __typename?: "PAContactManagedTag";
    /**
     * **Definition:** The long name of the tag, used for UI display
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    longName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Short name of the tag, used as a unique key
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    shortName: Scalars["ID"];
};
export type PAContactOnlineFrequencies = {
    __typename?: "PAContactOnlineFrequencies";
    day: Maybe<Scalars["String"]>;
    hour: Maybe<Scalars["Int"]>;
    saves: Maybe<Scalars["Int"]>;
    views: Maybe<Scalars["Int"]>;
};
export type PAContactPropertyEvent = {
    __typename?: "PAContactPropertyEvent";
    address: Maybe<Scalars["String"]>;
    baths: Maybe<Scalars["Int"]>;
    beds: Maybe<Scalars["Int"]>;
    brand: Maybe<Scalars["String"]>;
    brandPropertyID: Maybe<Scalars["ID"]>;
    /** @deprecated Use brandPropertyID instead */
    brandPropertyId: Maybe<Scalars["Int"]>;
    city: Maybe<Scalars["String"]>;
    eventDate: Maybe<Scalars["DateTime"]>;
    eventType: Maybe<Scalars["String"]>;
    imageUrl: Maybe<Scalars["String"]>;
    lastSavedDate: Maybe<Scalars["DateTime"]>;
    latitude: Maybe<Scalars["Float"]>;
    listingOffice: Maybe<Scalars["String"]>;
    longitude: Maybe<Scalars["Float"]>;
    mlsId: Maybe<Scalars["String"]>;
    propertyUrl: Maybe<Scalars["String"]>;
    source: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["Int"]>;
    stateCode: Maybe<Scalars["String"]>;
    status: Maybe<Scalars["String"]>;
    valuation: Maybe<Scalars["Int"]>;
    viewCount: Maybe<Scalars["Int"]>;
    zip: Maybe<Scalars["String"]>;
};
export type PAContactProspectType = {
    __typename?: "PAContactProspectType";
    /**
     * **Definition:** Prospect type display name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Maybe<Scalars["String"]>;
};
export type PAContactRelationship = {
    __typename?: "PAContactRelationship";
    /**
     * **Definition:** Relationship canceled date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    canceledAt: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Relationship creation date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    createdAt: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Relationship description
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    description: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Relationship expiration date
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    expiresAt: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Relationship header
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    header: Maybe<Scalars["String"]>;
    level: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** Relationship status
     * **Datasource:** My Agent API
     *
     * **Team Slack:** #sea-profile-team
     */
    status: Maybe<Scalars["String"]>;
};
export type PAContactSearchHistory = {
    __typename?: "PAContactSearchHistory";
    /**
     * **Definition:** Search locations
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    locations: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * **Definition:** property type (values: Single-Family Home, Condo Apartment, Multi-Family Home, Manufactured, Lots Land)
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    propertyTypes: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type PAContactSearchPreferences = {
    __typename?: "PAContactSearchPreferences";
    cities: Maybe<Array<Maybe<Scalars["String"]>>>;
    maxBathrooms: Maybe<Scalars["Float"]>;
    maxBedrooms: Maybe<Scalars["Int"]>;
    maxPrice: Maybe<Scalars["Int"]>;
    minBathrooms: Maybe<Scalars["Float"]>;
    minBedrooms: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
};
export type PAContactSocialInsight = {
    __typename?: "PAContactSocialInsight";
    facebookUrl: Maybe<Scalars["String"]>;
    linkedInUrl: Maybe<Scalars["String"]>;
    photoUrl: Maybe<Scalars["String"]>;
    twitterUrl: Maybe<Scalars["String"]>;
};
export type PAContactStatus = {
    __typename?: "PAContactStatus";
    id: Maybe<Scalars["ID"]>;
    label: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};
export type PAContactStatusChangeReason = {
    __typename?: "PAContactStatusChangeReason";
    /**
     * **Definition:** Text of the reason chosen for the status change
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars["String"];
    /**
     * **Definition:** The reason chosen to answer the question of why the status change was made
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    questionReasonId: Scalars["ID"];
};
export type PAContactStatusDuration = {
    __typename?: "PAContactStatusDuration";
    /**
     * **Definition:** Status last update date - default to creation date if there has not been a status update
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastUpdatedDate: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Minimum number of days before displaying duration in ui. Defaults to null if no threshold exists.
     * **Datasource:** Contact resources (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    statusThreshold: Maybe<Scalars["Int"]>;
};
export type PAContactTimeframe = {
    __typename?: "PAContactTimeframe";
    /**
     * **Definition:** Display name for timeframe
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    displayName: Scalars["String"];
    /**
     * **Definition:** Timeframe ID
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    timeframeId: Scalars["ID"];
};
export type PAContactZHLReferral = {
    __typename?: "PAContactZHLReferral";
    bodyText: Maybe<Scalars["String"]>;
    learnMoreBodyText: Maybe<Scalars["String"]>;
    learnMoreTitle: Maybe<Scalars["String"]>;
    updateDate: Maybe<Scalars["DateTime"]>;
};
export type PAContactZillow360 = {
    __typename?: "PAContactZillow360";
    bodyText: Maybe<Scalars["String"]>;
    learnMoreBodyText: Maybe<Scalars["String"]>;
    learnMoreTitle: Maybe<Scalars["String"]>;
    updateDate: Maybe<Scalars["DateTime"]>;
};
export type PAFlexAgentZipCampaign = {
    __typename?: "PAFlexAgentZipCampaign";
    regionId: Maybe<Scalars["Int"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type PAHomeRecAddress = {
    __typename?: "PAHomeRecAddress";
    city: Scalars["String"];
    stateCode: Scalars["String"];
    street: Scalars["String"];
    zip: Scalars["String"];
};
export type PAHomeRecImage = {
    __typename?: "PAHomeRecImage";
    imageUrl: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};
export type PALoop = {
    __typename?: "PALoop";
    id: Maybe<Scalars["Int"]>;
    loopUrl: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
};
export type PAMBPAgentZipCampaign = {
    __typename?: "PAMBPAgentZipCampaign";
    regionId: Maybe<Scalars["Int"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type PAMinMax = {
    __typename?: "PAMinMax";
    max: Maybe<Scalars["String"]>;
    min: Maybe<Scalars["String"]>;
};
export type PANote = {
    __typename?: "PANote";
    /**
     * **Definition:** Note creation date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    creationDate: Scalars["String"];
    /**
     * **Definition:** Is note mutable
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    isMutable: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Note last action (values: created, deleted, edited)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastAction: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Note author name
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    lastActionAuthorName: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    note: Scalars["String"];
    noteId: Scalars["ID"];
    /**
     * **Definition:** The platform that last updated the note
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    platformLastUpdatedOn: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Note update date
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    updateDate: Scalars["String"];
};
export type PAOTPForm = {
    __typename?: "PAOTPForm";
    billingPhoneNumber: Maybe<Scalars["String"]>;
    documentId: Maybe<Scalars["String"]>;
    downloadLink: Maybe<Scalars["String"]>;
    previewLink: Maybe<Scalars["String"]>;
};
export type PAPaginatedPropertyEvents = {
    __typename?: "PAPaginatedPropertyEvents";
    /** Cursor for next page */
    cursor: Maybe<Scalars["String"]>;
    /** Page size */
    pageSize: Maybe<Scalars["Int"]>;
    /** Total events count */
    total: Maybe<Scalars["Int"]>;
};
export type PAPhone = {
    __typename?: "PAPhone";
    number: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Phone id
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    phoneId: Maybe<Scalars["ID"]>;
    /**
     * **Definition:** Phone number string
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     * @deprecated Use PAPhone.number as value can be null
     */
    phoneNumber: Scalars["String"];
    /**
     * **Definition:** Phone type (values: Mobile, Home, Work)
     * **Datasource:** Contacts Resource (CRM DB)
     *
     * **Team Slack:** #theclosers
     */
    type: Scalars["String"];
};
export type PAPreferenceCounts = {
    __typename?: "PAPreferenceCounts";
    /** Label for the preference bucket */
    preference: Maybe<Scalars["String"]>;
    saved: Maybe<Scalars["Int"]>;
    viewed: Maybe<Scalars["Int"]>;
};
/**
 * **Definition:** CRM Property Snapshot
 *
 * **Team Slack:** #theclosers
 */
export type PAPropertySnapshot = {
    __typename?: "PAPropertySnapshot";
    address: Maybe<Scalars["String"]>;
    city: Maybe<Scalars["String"]>;
    imageUrl: Maybe<Scalars["String"]>;
    listingOffice: Maybe<Scalars["String"]>;
    mlsId: Maybe<Scalars["String"]>;
    numBaths: Maybe<Scalars["String"]>;
    numBeds: Maybe<Scalars["Int"]>;
    pid: Maybe<Scalars["ID"]>;
    /** @deprecated GQL doesn't support non 32-bits integer. Use pid instead */
    propertyId: Maybe<Scalars["Int"]>;
    propertySource: Maybe<Scalars["String"]>;
    propertyUrl: Maybe<Scalars["String"]>;
    stateCode: Maybe<Scalars["String"]>;
    valuation: Maybe<Scalars["Int"]>;
    zip: Maybe<Scalars["String"]>;
};
export type PARelationshipToken = {
    __typename?: "PARelationshipToken";
    createdAt: Maybe<Scalars["DateTime"]>;
    redeemedAt: Maybe<Scalars["DateTime"]>;
};
export type PATeam = {
    __typename?: "PATeam";
    name: Maybe<Scalars["String"]>;
    teamId: Scalars["String"];
};
export type PATeamMembership = {
    __typename?: "PATeamMembership";
    canExportContacts: Scalars["Boolean"];
    canReassignLeads: Scalars["Boolean"];
};
export type PATransaction = {
    __typename?: "PATransaction";
    closeDate: Maybe<Scalars["String"]>;
    closingCompany: Maybe<Scalars["String"]>;
    commissionAddition: Maybe<Scalars["Float"]>;
    commissionAmount: Maybe<Scalars["Float"]>;
    commissionPercentage: Maybe<Scalars["Float"]>;
    commissionReduction: Maybe<Scalars["Float"]>;
    creationDate: Maybe<Scalars["String"]>;
    legalName: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["Float"]>;
    representationType: Maybe<Scalars["String"]>;
    splitPercentage: Maybe<Scalars["Float"]>;
    transactionId: Scalars["Int"];
    updateDate: Maybe<Scalars["String"]>;
    zgFeeAmount: Maybe<Scalars["Float"]>;
    zgFeePercentage: Maybe<Scalars["Float"]>;
    zillowPropertyId: Maybe<Scalars["String"]>;
    ztid: Maybe<Scalars["String"]>;
};
export type PATransactionAddress = {
    __typename?: "PATransactionAddress";
    city: Maybe<Scalars["String"]>;
    stateCode: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    street2: Maybe<Scalars["String"]>;
    zipCode: Maybe<Scalars["String"]>;
};
export type PATransactionStatus = {
    __typename?: "PATransactionStatus";
    code: Scalars["Int"];
    label: Scalars["String"];
};
/** Pay Per Click URL link and test. If mobile = true, then the link can also be shown to mobile users */
export type PPCLink = {
    __typename?: "PPCLink";
    mobile: Maybe<Scalars["Boolean"]>;
    path: Maybe<Scalars["String"]>;
    text: Maybe<Scalars["String"]>;
};
export type PageViewCount = {
    __typename?: "PageViewCount";
    date: Maybe<Scalars["String"]>;
    view: Maybe<Scalars["Int"]>;
};
export type PersonalizedShoppingForUser = {
    __typename?: "PersonalizedShoppingForUser";
};
export type PetDetails = {
    __typename?: "PetDetails";
    /** Number of cats in household */
    catCount: Maybe<Scalars["String"]>;
    /** Number of dogs in household */
    dogCount: Maybe<Scalars["String"]>;
};
/** A single pet policy for a building */
export type PetPolicy = {
    __typename?: "PetPolicy";
    allowed: Maybe<Scalars["Boolean"]>;
    comment: Maybe<Scalars["String"]>;
    deposit: Maybe<Scalars["Float"]>;
    description: Maybe<Scalars["String"]>;
    feeRangeMax: Maybe<Scalars["Float"]>;
    feeRangeMin: Maybe<Scalars["Float"]>;
    maxNumberAllowed: Maybe<Scalars["Int"]>;
    maxWeightAllowed: Maybe<Scalars["Float"]>;
    monthlyFee: Maybe<Scalars["Float"]>;
    oneTimeFee: Maybe<Scalars["Float"]>;
    petCare: Maybe<Scalars["Boolean"]>;
    petSize: Maybe<Scalars["String"]>;
    petType: Maybe<Scalars["String"]>;
    restriction: Maybe<Scalars["String"]>;
};
/** An image */
export type Photo = {
    __typename?: "Photo";
    /** A caption for the image, only request when visible on page. call is expensive. */
    caption: Maybe<Scalars["String"]>;
    /** height in pixels */
    height: Maybe<Scalars["Int"]>;
    /** Raw metadata tags from PSL */
    metadataTags: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** String representing a photo id. Also included in the url. */
    photoKey: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
    /** width in pixels */
    width: Maybe<Scalars["Int"]>;
};
/**
 * Decision of which treatment to be displayed for this placement, the placement's
 * testing phase, and all other qualified treatments for the current user
 */
export type PlacementDecisionType = {
    __typename?: "PlacementDecisionType";
    /**
     * a JSON String that contains all the context data used or to be used to make
     * the treatment selection decision (which will be logged and used by data scientists)
     */
    decisionContext: Maybe<Scalars["JSON"]>;
    /** A unique event-id used to mark the web events for upsells that will help track them in the analytics side of things */
    eventId: Maybe<Scalars["String"]>;
    /** A boolean to indicate whether the user guid is in Onsite Messaging's global Hold out bucket */
    isGlobalHoldout: Scalars["Boolean"];
    /** A boolean to indicate whether the user guid is in Onsite Messaging's placement-level Hold out bucket */
    isPlacementHoldout: Scalars["Boolean"];
    lastModified: Scalars["String"];
    /**
     * For certain placement, we will simulate a random coin flip to decide whether
     * to render the chosen treatment on UI, so that the user won't be overwhelmed by
     * messages on every page view
     */
    passThrottle: Scalars["Boolean"];
    placementId: Scalars["Int"];
    placementName: Scalars["String"];
    /** A boolean to indicate whether the selected treatment (if any) should be displayed for the user */
    shouldDisplay: Scalars["Boolean"];
    /** If the selected treatment is decided not to be displayed, this field will explain the reason of skipping displaying */
    skipDisplayReason: Maybe<Scalars["String"]>;
};
export type PlanForSpec = {
    __typename?: "PlanForSpec";
};
/** PreQual page internal route */
export type PreQualRoute = {
    __typename?: "PreQualRoute";
    guid: Scalars["String"];
    zpid: Scalars["String"];
    zuid: Maybe<Scalars["String"]>;
};
/** Rental Premium Package info for a single zpid */
export type PremiumPackageInfo = {
    __typename?: "PremiumPackageInfo";
    /** CustomerId (HotpadsCustomerCode) for this listing */
    customerId: Maybe<Scalars["String"]>;
    /** PackageType purchased under this customerId */
    packageType: Maybe<Scalars["String"]>;
    /** PriorityScore for this listing */
    score: Maybe<Scalars["Float"]>;
};
export type PreviousAgentParticipant = {
    __typename?: "PreviousAgentParticipant";
    /**
     * **Definition:** The zuid of the agent participant
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    zuid: Maybe<Scalars["Int"]>;
};
/** Min and max price that defines a range */
export type PriceRange = {
    __typename?: "PriceRange";
    max: Maybe<Scalars["Int"]>;
    min: Maybe<Scalars["Int"]>;
};
/** A single item in a price history */
export type PriceRecord = {
    __typename?: "PriceRecord";
    /** The date of the event */
    date: Maybe<Scalars["String"]>;
    /** A description of the price change event */
    event: Maybe<Scalars["String"]>;
    /** External source type for the event */
    externalSourceType: Maybe<Scalars["String"]>;
    /** The posting id for this event */
    postingId: Maybe<Scalars["ID"]>;
    /** If true, the price reflects a monthly cost for rental */
    postingIsRental: Maybe<Scalars["Boolean"]>;
    /** The new price after the event */
    price: Maybe<Scalars["Float"]>;
    /** The change in price from the previous price */
    priceChangeRate: Maybe<Scalars["Float"]>;
    /** The new pricePerSquareFoot after the event */
    pricePerSquareFoot: Maybe<Scalars["Float"]>;
    /** If true, the source should link to the county data page */
    showCountyLink: Maybe<Scalars["Boolean"]>;
    /** Data source for the event */
    source: Maybe<Scalars["String"]>;
    /** When the price event occurred */
    time: Maybe<Scalars["DateTime"]>;
};
/** Attribution source for a price history event */
export type PriceRecordAttributeSource = {
    __typename?: "PriceRecordAttributeSource";
    infoString1: Maybe<Scalars["String"]>;
    infoString2: Maybe<Scalars["String"]>;
    infoString3: Maybe<Scalars["String"]>;
    /** Whether to expose infoString3 outside the row dropdown or keep it inside */
    infoString4: Maybe<Scalars["Boolean"]>;
};
export type PriceTaxAgentSummary = {
    __typename?: "PriceTaxAgentSummary";
    businessName: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    profileUrl: Maybe<Scalars["String"]>;
};
export type PrimaryImageType = {
    __typename?: "PrimaryImageType";
    imageId: Maybe<Scalars["Float"]>;
};
export type PrimaryPlan = {
    __typename?: "PrimaryPlan";
};
export type Profile = {
    __typename?: "Profile";
    /**
     * Vibe description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    character: Maybe<Scalars["String"]>;
    /**
     * Housing description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    housing: Maybe<Scalars["String"]>;
    /**
     * General introduction of the region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    intro: Maybe<Scalars["String"]>;
    /**
     * Services description of this region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    services: Maybe<Scalars["String"]>;
    /**
     * Transport description of the region.
     * @deprecated The upstream service is deco'd. Please remove usages or reach out to traffic-core.
     */
    transport: Maybe<Scalars["String"]>;
};
/**
 * A home.
 *
 * Indicators of the authenticated user's relation to the home are included,
 * but there is no PII returned in the response.
 */
export type Property = {
    __typename?: "Property";
    /** For a new construction property, the Lot #, Plan Name, or Spec street address, without the community name appended to it */
    abbreviatedAddress: Maybe<Scalars["String"]>;
    /** Blob of ad targeting context parameters */
    adTargets: Maybe<Scalars["JSON"]>;
    /** The email address of the agent associated with the listing */
    agentEmailAddress: Maybe<Scalars["String"]>;
    /** The annual home owners insurance of this property */
    annualHomeownersInsurance: Maybe<Scalars["Float"]>;
    /** number of bathrooms */
    bathrooms: Maybe<Scalars["Float"]>;
    /** number of bedrooms */
    bedrooms: Maybe<Scalars["Float"]>;
    /** Region ID for the borough */
    boroughId: Maybe<Scalars["Int"]>;
    /** The property's posting's broker ID */
    brokerId: Maybe<Scalars["Int"]>;
    brokerIdDimension: Maybe<Scalars["String"]>;
    /**
     * The property's posting's broker ID to be used for tracking metrics. Has
     * fallbacks if brokerId is missing based on the homeStatus.
     */
    brokerIdForTracking: Maybe<Scalars["String"]>;
    /** Name of brokerage */
    brokerageName: Maybe<Scalars["String"]>;
    /** The property's building/lot ID */
    buildingId: Maybe<Scalars["ID"]>;
    city: Maybe<Scalars["String"]>;
    /** Region ID for the city */
    cityId: Maybe<Scalars["Int"]>;
    /**
     * Date and time of when the property is coming to market (Used for Coming Soon properties)
     * @deprecated Use Property.comingSoonOnMarketDate to align with home info
     */
    comingSoonMarketDate: Maybe<Scalars["DateTime"]>;
    /** Date and time of when the property is coming to market (Used for Coming Soon properties) */
    comingSoonOnMarketDate: Maybe<Scalars["DateTime"]>;
    compType: Maybe<Scalars["String"]>;
    /**
     * The currency symbol of the country that the property belongs to.
     * @deprecated To be consistent with CurrencyType enum on homeInfo. Use currency instead.
     */
    countryCurrency: Maybe<Scalars["String"]>;
    /** string of the requested property county */
    county: Maybe<Scalars["String"]>;
    countyFIPS: Maybe<Scalars["String"]>;
    /** Region ID for the county */
    countyId: Maybe<Scalars["Int"]>;
    countyWebsiteUrl: Maybe<Scalars["String"]>;
    /** When the listing was posted */
    datePosted: Maybe<Scalars["DateTime"]>;
    /** When the listing was posted (as date string) */
    datePostedString: Maybe<Scalars["String"]>;
    /** When listing price changed */
    datePriceChanged: Maybe<Scalars["DateTime"]>;
    /** When the listing was last sold */
    dateSold: Maybe<Scalars["DateTime"]>;
    /** When the listing was last sold (as date string) */
    dateSoldString: Maybe<Scalars["String"]>;
    /**
     * The effective number of days this listing has been present if it has not been
     * refreshed by RentalsListingRanker, or the last refreshed date if it has been
     * refreshed by the rentalListingRanker. Returns 1 for less than 1 day.
     */
    daysOnZillow: Maybe<Scalars["Int"]>;
    description: Maybe<Scalars["String"]>;
    desktopWebHdpImageLink: Maybe<Scalars["String"]>;
    /** Down Payment Assistance authorization token timestamp */
    downPaymentAssistanceTimestamp: Maybe<Scalars["String"]>;
    /** A relative url to edit the property history, available to admins only */
    editPropertyHistorylink: Maybe<Scalars["String"]>;
    /** The URL of a broker logo to show up by the price */
    enhancedBrokerImageUrl: Maybe<Scalars["String"]>;
    /** Number of times this property has been saved */
    favoriteCount: Maybe<Scalars["Int"]>;
    featuredListingTypeDimension: Maybe<Scalars["String"]>;
    /**
     * Foreclosure estimate
     * @deprecated Not provided by PDC any longer.
     */
    festimate: Maybe<Scalars["Int"]>;
    /**
     * Finished basement area, in square feet
     * @deprecated Relies on POGO attributeBlob, which doesn't exist in PSL
     */
    finishedBasementSize: Maybe<Scalars["Float"]>;
    /**
     * Number of floors of the property
     * @deprecated Relies on POGO attributeBlob, which doesn't exist in PSL
     */
    floorCount: Maybe<Scalars["Float"]>;
    /** 1 yr forecast of zestimate value */
    forecast: Maybe<Scalars["String"]>;
    /** The bank that foreclosed the property */
    foreclosingBank: Maybe<Scalars["String"]>;
    /** The value of the foreclosed property at foreclosure */
    foreclosureAmount: Maybe<Scalars["Int"]>;
    /** City of the foreclosure auction */
    foreclosureAuctionCity: Maybe<Scalars["String"]>;
    /** The type of foreclosure auction */
    foreclosureAuctionDescription: Maybe<Scalars["String"]>;
    /** Date the foreclosure auction was filed */
    foreclosureAuctionFilingDate: Maybe<Scalars["String"]>;
    /** Location of the foreclosure auction */
    foreclosureAuctionLocation: Maybe<Scalars["String"]>;
    /** Time of the foreclosure auction */
    foreclosureAuctionTime: Maybe<Scalars["DateTime"]>;
    /** When the past due balance was reported */
    foreclosureBalanceReportingDate: Maybe<Scalars["DateTime"]>;
    /** When the foreclosure occurred */
    foreclosureDate: Maybe<Scalars["DateTime"]>;
    /** Description of foreclosure default */
    foreclosureDefaultDescription: Maybe<Scalars["String"]>;
    /** When the foreclosure default was filed */
    foreclosureDefaultFilingDate: Maybe<Scalars["DateTime"]>;
    /** Whether the state court is involved in foreclosures ("Judicial") or not ("Non-Judicial"), or "Unknown" */
    foreclosureJudicialType: Maybe<Scalars["String"]>;
    /** The amount loaned to assume the property during foreclosure */
    foreclosureLoanAmount: Maybe<Scalars["Int"]>;
    /** Date foreclosed loan was originally issued */
    foreclosureLoanDate: Maybe<Scalars["DateTime"]>;
    /** Originator of foreclosed loan */
    foreclosureLoanOriginator: Maybe<Scalars["String"]>;
    /** The amount the mortgage was past due */
    foreclosurePastDueBalance: Maybe<Scalars["Int"]>;
    /** The prior sale amount of the foreclosed property */
    foreclosurePriorSaleAmount: Maybe<Scalars["Int"]>;
    /** The prior sale date of the foreclosed property */
    foreclosurePriorSaleDate: Maybe<Scalars["DateTime"]>;
    /** The amount unpaid on the foreclosed loan */
    foreclosureUnpaidBalance: Maybe<Scalars["Int"]>;
    /** Signed Google static map url */
    googleStaticMapSignedUrl: Maybe<Scalars["String"]>;
    /** Signed Google Street View image url */
    googleStreetViewImageSignedUrl: Maybe<Scalars["String"]>;
    /** Signed Google Street View metadata url */
    googleStreetViewMetadataSignedUrl: Maybe<Scalars["String"]>;
    /** Indicates whether the property has an approved third party virtual tour url */
    hasApprovedThirdPartyVirtualTourUrl: Maybe<Scalars["Boolean"]>;
    /** Does the property have bad geographical coordinates */
    hasBadGeocode: Maybe<Scalars["Boolean"]>;
    /** Whether or not the listing has the owner's email address. */
    hasOwnerEmailAddress: Maybe<Scalars["Boolean"]>;
    /** Whether or not there's an active promotion for this property */
    hasPromotion: Maybe<Scalars["Boolean"]>;
    /**
     * True if the property has a public video
     * @deprecated Feature has been deprecated. Fields will be removed once clients remove their dependencies.
     */
    hasPublicVideo: Maybe<Scalars["Boolean"]>;
    hasVRModel: Maybe<Scalars["Boolean"]>;
    /** if home has verified owner, used instead of ownerAccount when possible */
    hasVerifiedClaimOwner: Maybe<Scalars["Boolean"]>;
    hdpTypeDimension: Maybe<Scalars["String"]>;
    /** url to this property's HDP */
    hdpUrl: Maybe<Scalars["String"]>;
    hiResImageLink: Maybe<Scalars["String"]>;
    /** Do we hide the Zestimate market analysis */
    hideZMA: Maybe<Scalars["Boolean"]>;
    /** Whether to hide zestimate */
    hideZestimate: Maybe<Scalars["Boolean"]>;
    /** hoa fees, in dollars */
    hoaFee: Maybe<Scalars["Int"]>;
    /** frequency of hoa fee value */
    hoaFeeFrequency: Maybe<Scalars["String"]>;
    homeDescriptionExcerpt: Maybe<Scalars["String"]>;
    /** TODO */
    homeStatusForHDP: Maybe<Scalars["String"]>;
    /**
     * A list of tags for a home. The tags come from AI team data.
     * @deprecated Home tags data is not available anymore.
     */
    homeTags: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** The ID of an object */
    id: Scalars["ID"];
    imageLink: Maybe<Scalars["String"]>;
    /** Url for the property's interactive floor plan */
    interactiveFloorPlanUrl: Maybe<Scalars["String"]>;
    /** The type of the latest Instant Offer related transaction */
    ioTransactionType: Maybe<Scalars["String"]>;
    /** Whether this property is a camo property (a duplicate of a foreclosure home whose location is the nearest intersection) */
    isCamo: Maybe<Scalars["Boolean"]>;
    /**
     * Does this property belong to Canada
     * @deprecated We are expecting country code to be included in pogo. Use country instead.
     */
    isCanadian: Maybe<Scalars["Boolean"]>;
    /**
     * True if a property is part of the Housing Connector project
     * @deprecated Use isHousingConnector instead
     */
    isCommunityPillar: Maybe<Scalars["Boolean"]>;
    /**
     * The owner told us which home is theirs, but they have not taken the steps to become a "Verified Owner".
     * For most situations, this is the best type of claim to require since it requires no additional input.
     * This type of claim helps us treat the user as the owner of the homes for view customization.
     * For example: confirmed claim owners are shown the Owner Dashboard instead of the public view of the HDP.
     * This type of claim does not allow the user to edit any data.
     */
    isConfirmedClaimedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    /**
     * True when the logged in user's account is the owner of the listing. False if
     * the user is not logged in or is not the owner of the listing.
     */
    isCurrentSignedInAgentResponsible: Maybe<Scalars["Boolean"]>;
    isCurrentSignedInUserVerifiedOwner: Maybe<Scalars["Boolean"]>;
    /** Is this a featured property */
    isFeatured: Maybe<Scalars["Boolean"]>;
    /** True if a property is part of the Housing Connector project */
    isHousingConnector: Maybe<Scalars["Boolean"]>;
    /** True if a property is exclusive to the Housing Connector program */
    isHousingConnectorExclusive: Maybe<Scalars["Boolean"]>;
    /**
     * True if this property is in an active ZO markets
     * @deprecated Deprecated with ZO wind down
     */
    isInZOActiveMarkets: Maybe<Scalars["Boolean"]>;
    /** True if a property has income restrictions */
    isIncomeRestricted: Maybe<Scalars["Boolean"]>;
    /**
     * True if this property is eligible for Zillow Offers (deprecated: return false always)
     * @deprecated Superseded by zoAvailability
     */
    isInstantOfferEnabled: Maybe<Scalars["Boolean"]>;
    /** is listing created by owner */
    isListedByOwner: Maybe<Scalars["Boolean"]>;
    isListingClaimedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    isListingOwnedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    /** Indicates whether the newly constructed property is featured in listings. */
    isNewConFeatured: Maybe<Scalars["Boolean"]>;
    /** is this property not owner occupied */
    isNonOwnerOccupied: Maybe<Scalars["Boolean"]>;
    isPaidMultiFamilyBrokerId: Maybe<Scalars["Boolean"]>;
    isPaidSingleFamilyBrokerId: Maybe<Scalars["Boolean"]>;
    /** Whether the property has undergone a non-retail auction */
    isPreforeclosureAuction: Maybe<Scalars["Boolean"]>;
    /** Is this a premier builder's listing */
    isPremierBuilder: Maybe<Scalars["Boolean"]>;
    /** true if the listing status has changed in the past 14 days */
    isRecentStatusChange: Maybe<Scalars["Boolean"]>;
    isRentalListingOffMarket: Maybe<Scalars["Boolean"]>;
    /** Indicates if the rentals lead cap for the lotId has been met (from Pogo) */
    isRentalsLeadCapMet: Maybe<Scalars["Boolean"]>;
    isSavedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    isSelectedAsComp: Maybe<Scalars["Boolean"]>;
    /**
     * true when an agent has chosen this listing to be Showcased HDP with Listing
     * Media Services photos and other enhanced media. Implies that media is ready
     * for consumption.
     */
    isShowcaseListing: Maybe<Scalars["Boolean"]>;
    isUndisclosedAddress: Maybe<Scalars["Boolean"]>;
    /** TODO */
    isUnmappable: Maybe<Scalars["Boolean"]>;
    /**
     * The owner had taken extra steps to verify their identity.
     * This type of claim allows the user to edit home facts, edit posting, upload photos, etc
     */
    isVerifiedClaimedByCurrentSignedInUser: Maybe<Scalars["Boolean"]>;
    /** Is this property owned by Zillow */
    isZillowOwned: Maybe<Scalars["Boolean"]>;
    keystoneHomeStatus: Maybe<Scalars["String"]>;
    /** Price at which the property was last sold */
    lastSoldPrice: Maybe<Scalars["Int"]>;
    /** Positive latitude is above the equator (N), and negative latitude is below the equator (S). */
    latitude: Maybe<Scalars["Float"]>;
    /** A url to view this property in the internal LFA tool */
    lfaViewPropertyPageUrl: Maybe<Scalars["String"]>;
    /** The lower price used for Value Range Pricing. The List Price must be greater than or equal to the ListPriceLow. */
    listPriceLow: Maybe<Scalars["Int"]>;
    /** zuid of the listing account */
    listingAccountUserId: Maybe<Scalars["String"]>;
    /** Source of listing data (e.g. Phoenix, Legacy) */
    listingDataSource: Maybe<Scalars["String"]>;
    listingFeedID: Maybe<Scalars["Int"]>;
    /** The IDs of the configurations of the listing owner on this property. Admin-only */
    listingOwnerConfigIDs: Maybe<Scalars["String"]>;
    /** Source of the listing. Admin-only */
    listingSource: Maybe<Scalars["String"]>;
    /** last date that the listing status was changed */
    listingStatusChangeDate: Maybe<Scalars["DateTime"]>;
    listingTypeDimension: Maybe<Scalars["String"]>;
    /**
     * Number of square feet in the property
     * @deprecated Use Property.livingAreaValue and Property.livingAreaUnits
     */
    livingArea: Maybe<Scalars["Int"]>;
    /** Living area unit of measurement (ex "Square Feet") */
    livingAreaUnits: Maybe<Scalars["String"]>;
    /** Living area unit of measurement short-name (ex "sqft") */
    livingAreaUnitsShort: Maybe<Scalars["String"]>;
    /** Living area numerical value */
    livingAreaValue: Maybe<Scalars["Float"]>;
    /**
     * Positive longitude is east of the prime meridian, while negative longitude is
     * west of the prime meridian (a north-south line that runs through a point in England).
     */
    longitude: Maybe<Scalars["Float"]>;
    /** Lot size unit of measurement (ex "Square Feet") */
    lotAreaUnits: Maybe<Scalars["String"]>;
    /** Lot size numerical value */
    lotAreaValue: Maybe<Scalars["Float"]>;
    /** Paid New Construction property friendly lot name, or null */
    lotName: Maybe<Scalars["String"]>;
    /** Paid New Construction property lot number, or null */
    lotNumber: Maybe<Scalars["String"]>;
    /** Cost of the lot or land associated with a posting on this property */
    lotPremium: Maybe<Scalars["Int"]>;
    /**
     * lot area, in square feet
     * @deprecated Use Property.lotAreaValue and Property.lotAreaUnits
     */
    lotSize: Maybe<Scalars["Int"]>;
    /** Malone property ID (from Pogo) */
    maloneId: Maybe<Scalars["String"]>;
    /** Human-readable floorplan or builder plan name */
    marketingName: Maybe<Scalars["String"]>;
    mediumImageLink: Maybe<Scalars["String"]>;
    mlsid: Maybe<Scalars["String"]>;
    /** monthly hoa fees, in dollars */
    monthlyHoaFee: Maybe<Scalars["Int"]>;
    /** A relative url to edit the home location on map, available to admins only */
    moveHomeMapLocationLink: Maybe<Scalars["String"]>;
    /** Date of construction completion */
    moveInCompletionDate: Maybe<Scalars["DateTime"]>;
    /** Is this home ready for move-in */
    moveInReady: Maybe<Scalars["Boolean"]>;
    /** Region ID for the neighborhood */
    neighborhoodId: Maybe<Scalars["Int"]>;
    /** Total number of units included in the income property, occupied or unoccupied */
    numberOfUnitsTotal: Maybe<Scalars["Float"]>;
    /** Open house hours for this property */
    openHouseHours: Maybe<Scalars["String"]>;
    ouid: Maybe<Scalars["String"]>;
    pageUrlFragment: Maybe<Scalars["String"]>;
    /** Number of page views this property has had */
    pageViewCount: Maybe<Scalars["Int"]>;
    parcelId: Maybe<Scalars["String"]>;
    photoCount: Maybe<Scalars["Int"]>;
    /** Paid New Construction property plan number, or null */
    planNumber: Maybe<Scalars["String"]>;
    /** The property's posting URL */
    postingUrl: Maybe<Scalars["String"]>;
    /**
     * Price in USD. Magical catchall field, includes various business logic about
     * home type for displaying right number. TODO SearchContext
     */
    price: Maybe<Scalars["Int"]>;
    /** A change in the listing price */
    priceChange: Maybe<Scalars["Int"]>;
    /** A change in the listing price */
    priceChangeAmount: Maybe<Scalars["Int"]>;
    /** When listing price changed */
    priceChangeDate: Maybe<Scalars["DateTime"]>;
    /** When listing price changed (as date string) */
    priceChangeDateString: Maybe<Scalars["String"]>;
    /** TODO */
    priceForHDP: Maybe<Scalars["Int"]>;
    /** TODO */
    priceReduction: Maybe<Scalars["String"]>;
    /** Description for this property's promotion */
    promotionDescription: Maybe<Scalars["String"]>;
    /** Headline for this property's promotion */
    promotionHeadline: Maybe<Scalars["String"]>;
    /** A relative url to view the logs for the property, available to admins only */
    propertyEventLogLink: Maybe<Scalars["String"]>;
    /** The annual property tax rate of this property */
    propertyTaxRate: Maybe<Scalars["Float"]>;
    /** Trace id indicating when the property was last updated in PDC, and what source it was updated by. */
    propertyTraceId: Maybe<Scalars["String"]>;
    propertyTypeDimension: Maybe<Scalars["String"]>;
    /** A relative url to update the property, available to admins only */
    propertyUpdatePageLink: Maybe<Scalars["String"]>;
    /** Community-level ID for new construction listings */
    providerListingID: Maybe<Scalars["String"]>;
    /** Specifies the type of the property. */
    pslHomeType: Maybe<Scalars["String"]>;
    /** Showcases the manner in which the property is represented in marketing. */
    pslMarketingRepresentation: Maybe<Scalars["String"]>;
    /** Current marketing status of the property. */
    pslMarketingStatus: Maybe<Scalars["String"]>;
    /** The category of the provider supplying the property's listing data. */
    pslProviderCategory: Maybe<Scalars["String"]>;
    /** Reflects the stage of public foreclosure for the property. */
    pslPublicForeclosureStage: Maybe<Scalars["String"]>;
    /** The home status data as received directly from the data provider. */
    pslRawHomeStatus: Maybe<Scalars["String"]>;
    /** The price data as received directly from the data provider. */
    rawPrice: Maybe<Scalars["Int"]>;
    /** The URL string representation of the city region */
    regionString: Maybe<Scalars["String"]>;
    /** zillow's estimate of property rental cost */
    rentZestimate: Maybe<Scalars["Int"]>;
    /** UTC date and time when the rental property is available */
    rentalDateAvailable: Maybe<Scalars["DateTime"]>;
    /** Rental specific marketing treatments used to determine front end display logicsear */
    rentalMarketingTreatments: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * Premium rental refresh date
     * @deprecated Use Property.rentalRefreshTime to align with home info
     */
    rentalRankingTime: Maybe<Scalars["DateTime"]>;
    /** Most recent date a unit in building was refreshed */
    rentalRefreshTime: Maybe<Scalars["DateTime"]>;
    /** high end of the restimate confidence interval */
    restimateHighPercent: Maybe<Scalars["String"]>;
    /** lower end of the restimate confidence interval */
    restimateLowPercent: Maybe<Scalars["String"]>;
    /** rent zestimate 30 days ago */
    restimateMinus30: Maybe<Scalars["String"]>;
    restimatePercentile: Maybe<Scalars["String"]>;
    /** All school ids assigned to a ZPID. First 3 ids are the closest elementary, middle, and high school, if available. */
    schoolIds: Maybe<Array<Maybe<Scalars["Int"]>>>;
    /** Number of seconds that the property has been on Zillow */
    secondsOnZillow: Maybe<Scalars["Int"]>;
    /** TODO */
    shouldHighlight: Maybe<Scalars["Boolean"]>;
    /** True if property contains a description which may be out of date */
    showDescriptionDisclaimer: Maybe<Scalars["Boolean"]>;
    /** Paid New Construction property spec number, or null */
    specNumber: Maybe<Scalars["String"]>;
    /** ssid */
    ssid: Maybe<Scalars["Int"]>;
    state: Maybe<Scalars["String"]>;
    /** The state-specific disclaimer meant to be included in the VOW module */
    stateDisclaimerToBeAppendedToVOWDisclaimer: Maybe<Scalars["String"]>;
    /** Region ID for the state */
    stateId: Maybe<Scalars["Int"]>;
    streetAddress: Maybe<Scalars["String"]>;
    /**
     * Signed url for a Google street view image. Returns the image url directly,
     * rather than a url which can be used to get an image url from
     * street-view-url-service
     */
    streetViewImageUrl: Maybe<Scalars["String"]>;
    /**
     * Signed Street-View-Url service url that a client can use to fetch Google
     * street view information with. Prefer streetViewImageUrl over this field
     */
    streetViewServiceUrl: Maybe<Scalars["String"]>;
    /**
     * SunScore is a value out of 100 that takes into account a buildings ability to utilize and save money using solar panals
     * @deprecated Replaced by solarPotential which contains all the data related to SunScore instead of single value
     */
    sunScore: Maybe<Scalars["Float"]>;
    /** tax paid for the most recent tax year */
    taxAssessedPaid: Maybe<Scalars["Float"]>;
    /** the property value in dollars, for tax purposes */
    taxAssessedValue: Maybe<Scalars["Int"]>;
    /** the most recent year for tax assessment */
    taxAssessedYear: Maybe<Scalars["Int"]>;
    /**
     * The effective amount of time this listing has been present. Returns the time
     * this listing has been on zillow in either minutes, hours, or days.
     */
    timeOnZillow: Maybe<Scalars["String"]>;
    /** IANA timezone string of this property (i.e. America/New_York) or null if lat/long is unavailable. */
    timeZone: Maybe<Scalars["String"]>;
    /** links to be rendered in the global top nav, returned as JSON */
    topNavJson: Maybe<Scalars["JSON"]>;
    /** links to be rendered in the global top nav, returned as markup */
    topNavMarkup: Maybe<Scalars["JSON"]>;
    /** Number of times the 3D Home for this property has been viewed */
    tourViewCount: Maybe<Scalars["Int"]>;
    /** TODO */
    tvCollectionImageLink: Maybe<Scalars["String"]>;
    /** TODO */
    tvHighResImageLink: Maybe<Scalars["String"]>;
    /** TODO */
    tvImageLink: Maybe<Scalars["String"]>;
    /** video id, return null if no video exists */
    videoId: Maybe<Scalars["String"]>;
    /** Url for the property's virtual tour */
    virtualTourUrl: Maybe<Scalars["String"]>;
    /** TODO */
    watchImageLink: Maybe<Scalars["String"]>;
    whatILove: Maybe<Scalars["String"]>;
    yearBuilt: Maybe<Scalars["Int"]>;
    /** zillow's estimate of property value */
    zestimate: Maybe<Scalars["Int"]>;
    /** high end of the zestimate confidence interval */
    zestimateHighPercent: Maybe<Scalars["String"]>;
    /** lower end of the zestimate confidence interval */
    zestimateLowPercent: Maybe<Scalars["String"]>;
    /** zestimate value 30 days ago */
    zestimateMinus30: Maybe<Scalars["String"]>;
    /** :shrug: */
    zestimatePercentile: Maybe<Scalars["String"]>;
    /** The 4-digit suffix to a base 5-digit zipcode */
    zipPlusFour: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
    /** Region ID for the zipcode */
    zipcodeId: Maybe<Scalars["Int"]>;
    /**
     * return ZO market name, or called as availability group entity (buybox) for given zpid
     * @deprecated Deprecated with ZO wind down
     */
    zoMarketName: Maybe<Scalars["String"]>;
    /**
     * Boolean to indicate if ZO Resale Start An Offer feature is enabled for the home
     * @deprecated ZO wind-down
     */
    zoResaleStartAnOfferEnabled: Maybe<Scalars["Boolean"]>;
    /** zillow property id */
    zpid: Maybe<Scalars["Int"]>;
};
export type PropertyContactFormRenderData = {
    __typename?: "PropertyContactFormRenderData";
    /** This field is provided as JSON, passed through from and documented in adsdisplay. */
    data: Maybe<Scalars["JSON"]>;
};
/** an item in the property details bag */
export type PropertyDetailItem = {
    __typename?: "PropertyDetailItem";
    facts: Maybe<Array<Maybe<Scalars["String"]>>>;
    title: Maybe<Scalars["String"]>;
};
export type PropertyLeadSubmitForm = {
    __typename?: "PropertyLeadSubmitForm";
    buttonText: Scalars["String"];
    disclosure: Maybe<Scalars["String"]>;
    /** @deprecated use inputFields instead */
    emailValidationRegex: Scalars["String"];
    heading: Maybe<Scalars["String"]>;
    headingIcon: Maybe<Scalars["String"]>;
    /** @deprecated use inputFields instead */
    messagePlaceholder: Scalars["String"];
    /** @deprecated use inputFields instead */
    phoneValidationRegex: Scalars["String"];
    subheading: Maybe<Scalars["String"]>;
    title: Scalars["String"];
};
export type PropertySpecialOffer = {
    __typename?: "PropertySpecialOffer";
    description: Maybe<Scalars["String"]>;
    endDate: Maybe<Scalars["String"]>;
    headline: Maybe<Scalars["String"]>;
    startDate: Maybe<Scalars["String"]>;
};
export type PropertyTag = {
    __typename?: "PropertyTag";
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    createdDateTime: Maybe<Scalars["DateTime"]>;
    /**  is public tag (not created by a user)  */
    isPublic: Scalars["Boolean"];
    /**  property tag identifier  */
    propertyTagId: Scalars["ID"];
    /**  The tag text added by the user  */
    tagText: Maybe<Scalars["String"]>;
};
export type PropertyTourAvailability = {
    __typename?: "PropertyTourAvailability";
    /** string representation of availability date. eg. "2022-02-09" */
    date: Maybe<Scalars["String"]>;
    /** string representation of propertyTourAvailability status, eg. "AVAILABLE", "HOLIDAY" */
    status: Maybe<Scalars["String"]>;
    /** list of strings representation of times available. eg. ["12:20:48"] */
    times: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type PropertyTourViews = {
    __typename?: "PropertyTourViews";
};
export type PropertyView = {
    __typename?: "PropertyView";
    /**  True if the user viewed the property, false otherwise   */
    isViewed: Maybe<Scalars["Boolean"]>;
};
export type ProviderInfo = {
    __typename?: "ProviderInfo";
    disclaimer: Maybe<Scalars["String"]>;
    ssid: Maybe<Scalars["String"]>;
};
export type ProviderInfoListType = {
    __typename?: "ProviderInfoListType";
    disclaimer: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    ssid: Maybe<Scalars["Int"]>;
};
export type ProviderLogo = {
    __typename?: "ProviderLogo";
    caption: Maybe<Scalars["String"]>;
    streetviewMetadataUrl: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};
export type QandA = {
    __typename?: "QandA";
    answer: Maybe<Scalars["String"]>;
    created: Maybe<Scalars["String"]>;
    creatorEmail: Maybe<Scalars["String"]>;
    lastUpdated: Maybe<Scalars["String"]>;
    question: Maybe<Scalars["String"]>;
    questionAnswerId: Maybe<Scalars["String"]>;
};
/** query */
export type Query = {
    __typename?: "Query";
    _noop: Maybe<Scalars["String"]>;
    bridgeContainer: Maybe<BridgeContainer>;
    /**
     * Look up a move by either moveId or by referenceId. If multiple inputs are specified, precedence is
     * given to MoveByIdInput then MoveByComponentRefIdInput
     */
    bridgeMoveById: Maybe<BridgeMove>;
    bridgeMoveByRefId: Maybe<BridgeMove>;
    currentZHLBorrower: Maybe<ZHLBorrower>;
    hasVerifiedIncomeAccount: Maybe<Scalars["Boolean"]>;
    homeLoansDashboard: HomeLoansDashboard;
    isIpAddressInTheUs: Maybe<Scalars["Boolean"]>;
    rentalApplicationsBrownoutWarning: Maybe<Scalars["String"]>;
    rentalApplicationsDocumentUploadToken: Maybe<Scalars["String"]>;
    /** Get the cached renter hub notification count for the navigation menu gleam */
    renterHubCachedNotificationCount: Maybe<Scalars["Int"]>;
    shouldDisplayInsuranceUpsell: Maybe<Scalars["Boolean"]>;
    /** Number of times the 3D Home for this vrmodel has been viewed */
    tourViewCountForVrModel: Maybe<Scalars["Int"]>;
    /** VaLoan status info */
    vaLoanStatus: Maybe<Scalars["String"]>;
    verifiedIncomeConnection: Maybe<Scalars["URL"]>;
    zhlBorrower: Maybe<ZHLBorrower>;
    zhlLoan: ZHLLoan;
    /** (experimental) Retrieve an ZHL LO by zuid or ZG email. NOTE: we may have to support get by ZHLUID or ZHL email in future. */
    zhlLoanOfficer: Maybe<ZHLLoanOfficer>;
    /** (experimental) Search ZHL LOs, currently only search by state is supported. TODO: pass no state should return all LOs paged */
    zhlLoanOfficers: Maybe<Array<ZHLLoanOfficer>>;
    zhlLoans: Maybe<Array<Maybe<ZHLLoan>>>;
    zhlMACExperience: Maybe<ZHLMACExperience>;
};
export type QuestionnaireAnswersExt = {
    __typename?: "QuestionnaireAnswersExt";
    /**  The questionnaire response Id  */
    responseId: Scalars["ID"];
    /**  The standard Zillow Property Id  */
    zpid: Scalars["Int"];
};
export type QuestionnaireAnswersJsonExt = {
    __typename?: "QuestionnaireAnswersJsonExt";
    /**  The questionnaire schema key ex:MISO_ATL  */
    schemaKey: Scalars["String"];
    /**  The questionnaire schema version  */
    schemaVersion: Scalars["String"];
};
export type QuestionsAnswersInfo = {
    __typename?: "QuestionsAnswersInfo";
};
export type RESOAssociations = {
    __typename?: "RESOAssociations";
    associationId: Maybe<Scalars["Int"]>;
    fee: Maybe<Scalars["Float"]>;
    feeFrequency: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    phone: Maybe<Scalars["String"]>;
};
/**
 * Facts and features, collected into names based on the Real Estate Standard
 * Organization (RESO) data dictionary
 * (https://ddwiki.reso.org/display/DDW17/RESO+Data+Dictionary+Wiki+v1.7)
 */
export type RESOFacts = {
    __typename?: "RESOFacts";
    aboveGradeFinishedArea: Maybe<Scalars["String"]>;
    accessibilityFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    additionalFeeInfo: Maybe<Scalars["String"]>;
    additionalParcelsDescription: Maybe<Scalars["String"]>;
    allowedPets: Maybe<Array<Maybe<Scalars["String"]>>>;
    appliances: Maybe<Array<Maybe<Scalars["String"]>>>;
    architecturalStyle: Maybe<Scalars["String"]>;
    associationAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    associationFee: Maybe<Scalars["String"]>;
    associationFee2: Maybe<Scalars["String"]>;
    associationFeeIncludes: Maybe<Array<Maybe<Scalars["String"]>>>;
    associationName: Maybe<Scalars["String"]>;
    associationName2: Maybe<Scalars["String"]>;
    associationPhone: Maybe<Scalars["String"]>;
    associationPhone2: Maybe<Scalars["String"]>;
    attic: Maybe<Scalars["String"]>;
    availabilityDate: Maybe<Scalars["DateTime"]>;
    basement: Maybe<Scalars["String"]>;
    basementYN: Maybe<Scalars["Boolean"]>;
    bathrooms: Maybe<Scalars["Int"]>;
    bathroomsFloat: Maybe<Scalars["Float"]>;
    bathroomsFull: Maybe<Scalars["Int"]>;
    bathroomsHalf: Maybe<Scalars["Int"]>;
    bathroomsOneQuarter: Maybe<Scalars["Int"]>;
    bathroomsPartial: Maybe<Scalars["Int"]>;
    bathroomsThreeQuarter: Maybe<Scalars["Int"]>;
    bedrooms: Maybe<Scalars["Int"]>;
    belowGradeFinishedArea: Maybe<Scalars["String"]>;
    bodyType: Maybe<Scalars["String"]>;
    builderModel: Maybe<Scalars["String"]>;
    builderName: Maybe<Scalars["String"]>;
    buildingArea: Maybe<Scalars["String"]>;
    buildingAreaSource: Maybe<Scalars["String"]>;
    buildingFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    buildingName: Maybe<Scalars["String"]>;
    buyerAgencyCompensation: Maybe<Scalars["String"]>;
    buyerAgencyCompensationType: Maybe<Scalars["String"]>;
    canRaiseHorses: Maybe<Scalars["Boolean"]>;
    carportParkingCapacity: Maybe<Scalars["Float"]>;
    /** @deprecated Source field type is double, not integer */
    carportSpaces: Maybe<Scalars["Int"]>;
    cityRegion: Maybe<Scalars["String"]>;
    commonWalls: Maybe<Scalars["String"]>;
    communityFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    compensationBasedOn: Maybe<Scalars["String"]>;
    constructionMaterials: Maybe<Array<Maybe<Scalars["String"]>>>;
    contingency: Maybe<Scalars["String"]>;
    cooling: Maybe<Array<Maybe<Scalars["String"]>>>;
    coveredParkingCapacity: Maybe<Scalars["Float"]>;
    /** @deprecated Source field type is double, not integer */
    coveredSpaces: Maybe<Scalars["Int"]>;
    cropsIncludedYN: Maybe<Scalars["Boolean"]>;
    cumulativeDaysOnMarket: Maybe<Scalars["String"]>;
    daysOnZillow: Maybe<Scalars["Int"]>;
    depositsAndFees: Maybe<Scalars["Int"]>;
    developmentStatus: Maybe<Scalars["String"]>;
    doorFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    electric: Maybe<Array<Maybe<Scalars["String"]>>>;
    elementarySchool: Maybe<Scalars["String"]>;
    elementarySchoolDistrict: Maybe<Scalars["String"]>;
    elevation: Maybe<Scalars["Int"]>;
    elevationUnits: Maybe<Scalars["String"]>;
    entryLevel: Maybe<Scalars["String"]>;
    entryLocation: Maybe<Scalars["String"]>;
    exclusions: Maybe<Array<Maybe<Scalars["String"]>>>;
    exteriorFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    fencing: Maybe<Scalars["String"]>;
    fireplaceFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    fireplaces: Maybe<Scalars["Int"]>;
    flooring: Maybe<Array<Maybe<Scalars["String"]>>>;
    foundationArea: Maybe<Scalars["Int"]>;
    foundationDetails: Maybe<Array<Maybe<Scalars["String"]>>>;
    frontageLength: Maybe<Scalars["String"]>;
    frontageType: Maybe<Scalars["String"]>;
    furnished: Maybe<Scalars["Boolean"]>;
    garageParkingCapacity: Maybe<Scalars["Float"]>;
    /** @deprecated Source field type is double, not integer */
    garageSpaces: Maybe<Scalars["Int"]>;
    gas: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenBuildingVerificationType: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenEnergyEfficient: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenEnergyGeneration: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenIndoorAirQuality: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenSustainability: Maybe<Array<Maybe<Scalars["String"]>>>;
    greenWaterConservation: Maybe<Array<Maybe<Scalars["String"]>>>;
    hasAdditionalParcels: Maybe<Scalars["Boolean"]>;
    hasAssociation: Maybe<Scalars["Boolean"]>;
    hasAttachedGarage: Maybe<Scalars["Boolean"]>;
    hasAttachedProperty: Maybe<Scalars["Boolean"]>;
    hasCarport: Maybe<Scalars["Boolean"]>;
    hasCooling: Maybe<Scalars["Boolean"]>;
    hasElectricOnProperty: Maybe<Scalars["Boolean"]>;
    hasFireplace: Maybe<Scalars["Boolean"]>;
    hasGarage: Maybe<Scalars["Boolean"]>;
    hasHeating: Maybe<Scalars["Boolean"]>;
    hasHomeWarranty: Maybe<Scalars["Boolean"]>;
    hasLandLease: Maybe<Scalars["Boolean"]>;
    hasOpenParking: Maybe<Scalars["Boolean"]>;
    hasPetsAllowed: Maybe<Scalars["Boolean"]>;
    hasPrivatePool: Maybe<Scalars["Boolean"]>;
    hasRentControl: Maybe<Scalars["Boolean"]>;
    hasSpa: Maybe<Scalars["Boolean"]>;
    hasView: Maybe<Scalars["Boolean"]>;
    hasWaterfrontView: Maybe<Scalars["Boolean"]>;
    heating: Maybe<Array<Maybe<Scalars["String"]>>>;
    highSchool: Maybe<Scalars["String"]>;
    highSchoolDistrict: Maybe<Scalars["String"]>;
    hoaFee: Maybe<Scalars["String"]>;
    hoaFeeTotal: Maybe<Scalars["String"]>;
    homeType: Maybe<Scalars["String"]>;
    horseAmenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    horseYN: Maybe<Scalars["Boolean"]>;
    inclusions: Maybe<Array<Maybe<Scalars["String"]>>>;
    incomeIncludes: Maybe<Array<Maybe<Scalars["String"]>>>;
    interiorFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    irrigationWaterRightsAcres: Maybe<Scalars["Int"]>;
    irrigationWaterRightsYN: Maybe<Scalars["Boolean"]>;
    isForRent: Maybe<Scalars["Boolean"]>;
    isNewConstruction: Maybe<Scalars["Boolean"]>;
    isSeniorCommunity: Maybe<Scalars["Boolean"]>;
    isSmokingAllowed: Maybe<Scalars["String"]>;
    landLeaseAmount: Maybe<Scalars["String"]>;
    landLeaseExpirationDate: Maybe<Scalars["DateTime"]>;
    laundryFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    leaseTerm: Maybe<Scalars["String"]>;
    levels: Maybe<Scalars["String"]>;
    listAOR: Maybe<Scalars["String"]>;
    listTeamName: Maybe<Scalars["String"]>;
    listingId: Maybe<Scalars["String"]>;
    listingTerms: Maybe<Scalars["String"]>;
    livingArea: Maybe<Scalars["String"]>;
    livingAreaRange: Maybe<Scalars["String"]>;
    livingAreaRangeUnits: Maybe<Scalars["String"]>;
    lotFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    lotSize: Maybe<Scalars["String"]>;
    lotSizeDimensions: Maybe<Scalars["String"]>;
    mainLevelBathrooms: Maybe<Scalars["Int"]>;
    mainLevelBedrooms: Maybe<Scalars["Int"]>;
    marketingType: Maybe<Scalars["String"]>;
    middleOrJuniorSchool: Maybe<Scalars["String"]>;
    middleOrJuniorSchoolDistrict: Maybe<Scalars["String"]>;
    municipality: Maybe<Scalars["String"]>;
    numberOfUnitsInCommunity: Maybe<Scalars["Int"]>;
    numberOfUnitsVacant: Maybe<Scalars["Int"]>;
    offerReview: Maybe<Scalars["String"]>;
    offerReviewDate: Maybe<Scalars["String"]>;
    onMarketDate: Maybe<Scalars["DateTime"]>;
    oneTimeFees: Maybe<Scalars["Int"]>;
    openParkingCapacity: Maybe<Scalars["Float"]>;
    /** @deprecated Source field type is double, not integer */
    openParkingSpaces: Maybe<Scalars["Int"]>;
    otherEquipment: Maybe<Array<Maybe<Scalars["String"]>>>;
    otherParking: Maybe<Array<Maybe<Scalars["String"]>>>;
    otherStructures: Maybe<Array<Maybe<Scalars["String"]>>>;
    ownership: Maybe<Scalars["String"]>;
    ownershipType: Maybe<Scalars["String"]>;
    parcelNumber: Maybe<Scalars["String"]>;
    parkName: Maybe<Scalars["String"]>;
    /** @deprecated Source field type is double, not integer */
    parking: Maybe<Scalars["Int"]>;
    parkingCapacity: Maybe<Scalars["Float"]>;
    parkingFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    patioAndPorchFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    petsAllowed: Maybe<Array<Maybe<Scalars["String"]>>>;
    petsMaxWeight: Maybe<Scalars["Int"]>;
    poolFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    pricePerSquareFoot: Maybe<Scalars["Int"]>;
    propertyCondition: Maybe<Scalars["String"]>;
    propertySubType: Maybe<Array<Maybe<Scalars["String"]>>>;
    publicRemarks: Maybe<Scalars["String"]>;
    roadSurfaceType: Maybe<Array<Maybe<Scalars["String"]>>>;
    roofType: Maybe<Scalars["String"]>;
    securityFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    sewer: Maybe<Array<Maybe<Scalars["String"]>>>;
    spaFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    specialListingConditions: Maybe<Scalars["String"]>;
    stories: Maybe<Scalars["Int"]>;
    storiesTotal: Maybe<Scalars["Int"]>;
    structureType: Maybe<Scalars["String"]>;
    subAgencyCompensation: Maybe<Scalars["String"]>;
    subAgencyCompensationType: Maybe<Scalars["String"]>;
    subdivisionName: Maybe<Scalars["String"]>;
    taxAnnualAmount: Maybe<Scalars["Int"]>;
    taxAssessedValue: Maybe<Scalars["Int"]>;
    tenantPays: Maybe<Array<Maybe<Scalars["String"]>>>;
    topography: Maybe<Scalars["String"]>;
    totalActualRent: Maybe<Scalars["Int"]>;
    transactionBrokerCompensation: Maybe<Scalars["String"]>;
    transactionBrokerCompensationType: Maybe<Scalars["String"]>;
    utilities: Maybe<Array<Maybe<Scalars["String"]>>>;
    vegetation: Maybe<Array<Maybe<Scalars["String"]>>>;
    view: Maybe<Array<Maybe<Scalars["String"]>>>;
    virtualTour: Maybe<Scalars["String"]>;
    virtualTourURLUnbranded: Maybe<Scalars["String"]>;
    waterBodyName: Maybe<Scalars["String"]>;
    waterSource: Maybe<Array<Maybe<Scalars["String"]>>>;
    waterSources: Maybe<Array<Maybe<Scalars["String"]>>>;
    waterView: Maybe<Scalars["String"]>;
    waterViewYN: Maybe<Scalars["Boolean"]>;
    waterfrontFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    windowFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    woodedArea: Maybe<Scalars["Int"]>;
    yearBuilt: Maybe<Scalars["Int"]>;
    yearBuiltEffective: Maybe<Scalars["Int"]>;
    zoning: Maybe<Scalars["String"]>;
    zoningDescription: Maybe<Scalars["String"]>;
};
export type RESOOtherFact = {
    __typename?: "RESOOtherFact";
    name: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["String"]>;
};
export type RESORoom = {
    __typename?: "RESORoom";
    area: Maybe<Scalars["String"]>;
    description: Maybe<Scalars["String"]>;
    dimensions: Maybe<Scalars["String"]>;
    features: Maybe<Array<Maybe<Scalars["String"]>>>;
    length: Maybe<Scalars["String"]>;
    level: Maybe<Scalars["String"]>;
    roomArea: Maybe<Scalars["String"]>;
    roomAreaSource: Maybe<Scalars["String"]>;
    roomAreaUnits: Maybe<Scalars["String"]>;
    roomDescription: Maybe<Scalars["String"]>;
    roomDimensions: Maybe<Scalars["String"]>;
    roomFeatures: Maybe<Array<Maybe<Scalars["String"]>>>;
    roomLength: Maybe<Scalars["String"]>;
    roomLengthWidthSource: Maybe<Scalars["String"]>;
    roomLengthWidthUnits: Maybe<Scalars["String"]>;
    roomLevel: Maybe<Scalars["String"]>;
    roomWidth: Maybe<Scalars["String"]>;
    width: Maybe<Scalars["String"]>;
};
/** A recommendation from the realtime recommendations service */
export type RealtimeRecomendation = {
    __typename?: "RealtimeRecomendation";
};
/** An id for the recomendation containing the type (ie zpid) and value */
export type RecId = {
    __typename?: "RecId";
    /** Type of property id (ie zpid) */
    type: Scalars["String"];
    /** Value of the property id */
    value: Scalars["String"];
};
export type Recommendation = {
    __typename?: "Recommendation";
    /** Score for recommendation result, the higher the score reflect better recommendation */
    score: Maybe<Scalars["Float"]>;
    zpid: Maybe<Scalars["Int"]>;
};
/** The suggested hero image for the recommendation */
export type RecsHeroImage = {
    __typename?: "RecsHeroImage";
    /** Default image size (p_g) url */
    defaultLink: Maybe<Scalars["String"]>;
    /** High resolution image size (p_f) url */
    highResolutionLink: Maybe<Scalars["String"]>;
    /** ID of the image */
    id: Maybe<Scalars["String"]>;
    /** Medium image size (p_c) url */
    mediumSizeLink: Maybe<Scalars["String"]>;
};
/** A core interface for recommended modules (collections, upsells, etc) */
export type RecsModule = {};
/** A tag associated with a property or request */
export type RecsTag = {
    __typename?: "RecsTag";
    /** Type/name of tag (ie home_insights) */
    type: Scalars["String"];
    /** Value of the tag (ie pool) */
    value: Scalars["String"];
};
export type Region = {
    __typename?: "Region";
    /** List of alternative names for the region which does not include the primary name */
    alternateNames: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Subdivision amenities */
    amenities: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** State and county level Federal Information Processing System (FIPS) Codes */
    fips: Maybe<Scalars["Int"]>;
    /** 1-year forecast of median price */
    forecast: Maybe<Scalars["Float"]>;
    /** The full geometric representation of the region in the form of a WKT */
    geom: Maybe<Scalars["String"]>;
    /** The ID of an object */
    id: Scalars["ID"];
    /** Trulia unique ID for every region */
    locationId: Maybe<Scalars["Int"]>;
    /** The minimum bounding rectangle for the region in the form of a WKT */
    mbr: Maybe<Scalars["String"]>;
    /** Primary name of the region of interest */
    name: Maybe<Scalars["String"]>;
    parentDmaId: Maybe<Scalars["Int"]>;
    /** Rough population of the region */
    population: Maybe<Scalars["Int"]>;
    /** Zillow unique ID for every region */
    regionId: Maybe<Scalars["Int"]>;
    /** The region type, as an int, as a string? */
    regionType: Maybe<Scalars["String"]>;
    regionTypeName: Maybe<Scalars["String"]>;
    rid: Maybe<Scalars["Int"]>;
    /** Subdivision video tour URLs */
    videoTours: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** Median price of the region */
    zindex: Maybe<Scalars["Float"]>;
    /** Median price per square foot in the region */
    zindexSqFt: Maybe<Scalars["Float"]>;
};
export type RegionBody = {
    __typename?: "RegionBody";
    borough: Maybe<Scalars["String"]>;
    city: Maybe<Scalars["String"]>;
    community: Maybe<Scalars["String"]>;
    county: Maybe<Scalars["String"]>;
    metro: Maybe<Scalars["String"]>;
    neighborhood: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    subdivision: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type RegionCentroid = {
    __typename?: "RegionCentroid";
    latitude: Maybe<Scalars["Float"]>;
    longitude: Maybe<Scalars["Float"]>;
};
/** Region ids where the building is located */
export type RegionIds = {
    __typename?: "RegionIds";
    borough: Maybe<Scalars["Int"]>;
    city: Maybe<Scalars["Int"]>;
    county: Maybe<Scalars["Int"]>;
    neighborhood: Maybe<Scalars["Int"]>;
    state: Maybe<Scalars["Int"]>;
    zipcode: Maybe<Scalars["Int"]>;
};
export type RegionParentageType = {
    __typename?: "RegionParentageType";
    /** Trulia unique ID for every region */
    locationId: Maybe<Scalars["Int"]>;
    /** Primary name of the region of interest */
    name: Maybe<Scalars["String"]>;
    /** Zillow unique ID for every region */
    regionId: Maybe<Scalars["Int"]>;
    regionType: Maybe<Scalars["String"]>;
};
export type RegionSchool = {
    __typename?: "RegionSchool";
    grades: Maybe<Scalars["String"]>;
    level: Maybe<Scalars["String"]>;
    link: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    /** rating out of 10 */
    rating: Maybe<Scalars["Int"]>;
    size: Maybe<Scalars["Int"]>;
    studentsPerTeacher: Maybe<Scalars["Int"]>;
    type: Maybe<Scalars["String"]>;
};
export type RentalInstantTour = {
    __typename?: "RentalInstantTour";
    durationMinutes: Maybe<Scalars["Int"]>;
    endTime: Maybe<Scalars["String"]>;
    schedulingStatus: Maybe<Scalars["String"]>;
    startTime: Maybe<Scalars["String"]>;
    supportsCancel: Maybe<Scalars["Boolean"]>;
    tourId: Maybe<Scalars["String"]>;
    tourType: Maybe<Scalars["String"]>;
};
/** Contact, agent badge type, and reviews info for owner of the rental listing. */
export type RentalListingOwnerContactType = {
    __typename?: "RentalListingOwnerContactType";
    /** One of Agent, Community Pillar, Premier Agent, or null */
    agentBadgeType: Maybe<Scalars["String"]>;
    /** The listing agent's business name (if any) */
    businessName: Maybe<Scalars["String"]>;
    /** The listing agent's display name */
    displayName: Maybe<Scalars["String"]>;
    /** Broker local compliance with rules */
    isBrokerLocalCompliance: Maybe<Scalars["Boolean"]>;
    /** The listing agent's contact phone number */
    phoneNumber: Maybe<Scalars["String"]>;
    /** The link to download a photo for the agent */
    photoUrl: Maybe<Scalars["String"]>;
    /** Average rating left by users */
    ratingAverage: Maybe<Scalars["Float"]>;
    /** Number of reviews an agent has received */
    reviewsReceivedCount: Maybe<Scalars["Int"]>;
    /** A link to read or write agent reviews */
    reviewsUrl: Maybe<Scalars["String"]>;
};
/** The reputation data for owner of the rental listing. */
export type RentalListingOwnerReputation = {
    __typename?: "RentalListingOwnerReputation";
    /** Number of applications of the listing. */
    applicationCount: Maybe<Scalars["Int"]>;
    /** Number of contacts of the listing provider. */
    contactCount: Maybe<Scalars["Int"]>;
    /** Is listing owner id verified? */
    isLandlordIdVerified: Maybe<Scalars["Boolean"]>;
    /** Response rate the listing provider contact. */
    responseRate: Maybe<Scalars["Float"]>;
    /** Response time of the listing provider contact in milliseconds. */
    responseTimeMs: Maybe<Scalars["Int"]>;
};
/** Rental Premium Package info for a single zpid */
export type RentalPremiumPackage = {
    __typename?: "RentalPremiumPackage";
};
export type RequestTour = {
    __typename?: "RequestTour";
    title: Scalars["String"];
};
export type RequestTourProperty = {
    __typename?: "RequestTourProperty";
    address: Scalars["String"];
    bathroomCount: Maybe<Scalars["Float"]>;
    bedroomCount: Maybe<Scalars["Float"]>;
    city: Scalars["String"];
    squareFeet: Maybe<Scalars["Float"]>;
    state: Scalars["String"];
    zipcode: Scalars["String"];
};
export type RequestTourTimeSelection = {
    __typename?: "RequestTourTimeSelection";
    heading: Scalars["String"];
};
export type RescheduleTourContactAgentView = {
    __typename?: "RescheduleTourContactAgentView";
};
export type RescheduleTourRequestFormView = {
    __typename?: "RescheduleTourRequestFormView";
};
export type ResponseDetails = {
    __typename?: "ResponseDetails";
    fieldName: Scalars["String"];
    title: Maybe<Scalars["String"]>;
};
/** An image source option */
export type ResponsiveImageSource = {
    __typename?: "ResponsiveImageSource";
    /** boolean to specify if the image is a Google Static map with scale > 1 */
    isHighResolutionStaticMap: Maybe<Scalars["Boolean"]>;
    /** url of the photo at the specified width */
    url: Maybe<Scalars["String"]>;
    /** width in pixels */
    width: Maybe<Scalars["Int"]>;
};
export type ResponsiveString = {
    __typename?: "ResponsiveString";
    /** Shortened version of the text for smaller displays */
    abbreviatedValue: Maybe<Scalars["String"]>;
    /** The full text */
    fullValue: Maybe<Scalars["String"]>;
};
export type Review = {
    __typename?: "Review";
    responseMessage: Maybe<Scalars["String"]>;
    reviewId: Maybe<Scalars["String"]>;
    reviewMessage: Maybe<Scalars["String"]>;
    reviewResponseDate: Maybe<Scalars["String"]>;
    starLevel: Maybe<Scalars["Int"]>;
};
/** Building review information */
export type ReviewsInfo = {
    __typename?: "ReviewsInfo";
    averageBuildingManagerRating: Maybe<Scalars["Float"]>;
    averageBuildingRating: Maybe<Scalars["Float"]>;
    averagePropertyManagerRating: Maybe<Scalars["Float"]>;
    reviewsCount: Maybe<Scalars["Int"]>;
};
export type RichMediaType = {
    __typename?: "RichMediaType";
    displayOrder: Maybe<Scalars["Int"]>;
    label: Maybe<Scalars["String"]>;
    lotId: Maybe<Scalars["Int"]>;
    richMediaId: Maybe<Scalars["Int"]>;
    url: Maybe<Scalars["String"]>;
};
export type RoomDetails = {
    __typename?: "RoomDetails";
    /**
     * whether pets are allowed in room
     * @deprecated This field is no longer in use.
     */
    arePetsAllowed: Maybe<Scalars["Boolean"]>;
    /**
     * General description of room
     * @deprecated Use roomDescription instead.
     */
    description: Maybe<Scalars["String"]>;
    /** does room have private bath */
    hasPrivateBath: Maybe<Scalars["Boolean"]>;
    /**
     * is room furnished
     * @deprecated Use roomIsFurnished instead.
     */
    isFurnished: Maybe<Scalars["Boolean"]>;
    /**
     * is smoking allowed in room
     * @deprecated This field is no longer in use.
     */
    isSmokingAllowed: Maybe<Scalars["Boolean"]>;
    /**
     * size of living area
     * @deprecated This field is no longer in use.
     */
    livingArea: Maybe<Scalars["Int"]>;
    /**
     * living area units, i.e. square feet
     * @deprecated This field is no longer in use.
     */
    livingAreaUnits: Maybe<Scalars["String"]>;
    /**
     * shortened version of living area units, i.e. sqft
     * @deprecated This field is no longer in use.
     */
    livingAreaUnitsShort: Maybe<Scalars["String"]>;
    /**
     * description of how utilities are shared
     * @deprecated Use utilitiesShareDescription instead.
     */
    monthlyUtilitiesShareDescription: Maybe<Scalars["String"]>;
    /** area of the room */
    roomArea: Maybe<Scalars["Int"]>;
    /** units of the roomArea */
    roomAreaUnits: Maybe<Scalars["String"]>;
    /** General description of room */
    roomDescription: Maybe<Scalars["String"]>;
    /** is room furnished */
    roomIsFurnished: Maybe<Scalars["Boolean"]>;
    /**
     * square footage of room
     * @deprecated This field is no longer in use.
     */
    roomSquareFeet: Maybe<Scalars["Int"]>;
    /** type of the room */
    roomType: Maybe<Scalars["String"]>;
    /** description of how utilities are shared */
    utilitiesShareDescription: Maybe<Scalars["String"]>;
};
export type RoomForRent = {
    __typename?: "RoomForRent";
    /** Information on who posted this listing */
    postedBy: Maybe<Scalars["String"]>;
};
export type RoomRentalDetails = {
    __typename?: "RoomRentalDetails";
};
export type Roommate = {
    __typename?: "Roommate";
    /**
     * Roommate's age
     * @deprecated This field is no longer in use.
     */
    age: Maybe<Scalars["Int"]>;
    /**
     * Roommate's gender
     * @deprecated This field is no longer in use.
     */
    gender: Maybe<Scalars["String"]>;
    /**
     * Roommate's interests
     * @deprecated This field is no longer in use.
     */
    interests: Maybe<Scalars["String"]>;
    /**
     * Roommate's job
     * @deprecated This field is no longer in use.
     */
    job: Maybe<Scalars["String"]>;
};
export type RoommateDetails = {
    __typename?: "RoommateDetails";
    /**
     * Number of cats in household
     * @deprecated This field is no longer in use.
     */
    catCount: Maybe<Scalars["Int"]>;
    /** General description of current roommates in household */
    description: Maybe<Scalars["String"]>;
    /**
     * Number of dogs in household
     * @deprecated This field is no longer in use.
     */
    dogCount: Maybe<Scalars["Int"]>;
    /**
     * Total number of female roommates
     * @deprecated This field is no longer in use.
     */
    femaleCount: Maybe<Scalars["String"]>;
    /**
     * Total number of male roommates
     * @deprecated This field is no longer in use.
     */
    maleCount: Maybe<Scalars["String"]>;
    /**
     * Total number of non-binary roommates
     * @deprecated This field is no longer in use.
     */
    nonBinaryCount: Maybe<Scalars["String"]>;
    /**
     * Number of other pets in household
     * @deprecated This field is no longer in use.
     */
    otherPetsCount: Maybe<Scalars["Int"]>;
    /**
     * Description of pets in household
     * @deprecated This field is no longer in use.
     */
    petDescription: Maybe<Scalars["String"]>;
    /**
     * Total number of roommates who prefer not to identify gender
     * @deprecated This field is no longer in use.
     */
    preferNotToIdentifyCount: Maybe<Scalars["String"]>;
    /**
     * Social habits of current roommates
     * @deprecated This field is no longer in use.
     */
    socialHabits: Maybe<Scalars["String"]>;
    /** Total number of roommates */
    totalCount: Maybe<Scalars["String"]>;
    /**
     * Total number of roommates
     * @deprecated This field is no longer in use.
     */
    totalNumberOfRoommates: Maybe<Scalars["Int"]>;
    /**
     * Work schedule of current roommates
     * @deprecated This field is no longer in use.
     */
    workSchedule: Maybe<Scalars["String"]>;
};
export type RoommateGenderDetails = {
    __typename?: "RoommateGenderDetails";
    /** Number roommates of specified gender. A string is used to support cases like "4+" */
    genderCount: Maybe<Scalars["String"]>;
    /** The type of gender */
    type: Maybe<Scalars["String"]>;
};
export type RoommatePetDetails = {
    __typename?: "RoommatePetDetails";
    petCount: Maybe<Scalars["String"]>;
    /** The type of pet */
    type: Maybe<Scalars["String"]>;
};
export type RoommateRequirements = {
    __typename?: "RoommateRequirements";
    /**
     * Gender of desired roommate
     * @deprecated This field is no longer in use.
     */
    gender: Maybe<Scalars["String"]>;
    /** genders */
    genderTypes: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * genders
     * @deprecated Use genderTypes instead.
     */
    genders: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * Whether room can be rentable to only renter or renter + partner
     * @deprecated This field is no longer in use.
     */
    isLiveInPartnerAllowed: Maybe<Scalars["Boolean"]>;
    /**
     * Whether current renters prefer new roommate to be vegan
     * @deprecated This field is no longer in use.
     */
    isVegan: Maybe<Scalars["Boolean"]>;
    /**
     * Whether current renters prefer new roommate to be vegetarian
     * @deprecated This field is no longer in use.
     */
    isVegetarian: Maybe<Scalars["Boolean"]>;
    /**
     * Maximum age for desired roommate
     * @deprecated This field is no longer in use.
     */
    maxAge: Maybe<Scalars["Int"]>;
    /**
     * Minimum age for desired roommate
     * @deprecated Use minimumAge instead.
     */
    minAge: Maybe<Scalars["Int"]>;
    /** Minimum age for desired roommate */
    minimumAge: Maybe<Scalars["Int"]>;
    /**
     * Work schedule for desired roommate
     * @deprecated This field is no longer in use.
     */
    workSchedule: Maybe<Scalars["String"]>;
};
export type SalesOffice = {
    __typename?: "SalesOffice";
    addressLine1: Maybe<Scalars["String"]>;
    addressLine2: Maybe<Scalars["String"]>;
};
export type School = {
    __typename?: "School";
    /** @deprecated This data is not used, and not provided by school-search-api. */
    assigned: Maybe<Scalars["Boolean"]>;
    /** distance in miles */
    distance: Maybe<Scalars["Float"]>;
    /** Hyphenated description of grades served. */
    grades: Maybe<Scalars["String"]>;
    /** @deprecated This data is not known to be used, and not provided by school-search-api. */
    isAssigned: Maybe<Scalars["Boolean"]>;
    level: Maybe<Scalars["String"]>;
    /** URL of the relevant Great Schools page. */
    link: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
    /** @deprecated Obsolete */
    overwriteSource: Maybe<Scalars["String"]>;
    /** rating out of 10 */
    rating: Maybe<Scalars["Int"]>;
    schoolId: Maybe<Scalars["Int"]>;
    /** @deprecated This data is not known to be used, and not provided by school-search-api. */
    size: Maybe<Scalars["Int"]>;
    /** @deprecated This data is not used, and not provided by school-search-api. */
    studentsPerTeacher: Maybe<Scalars["Int"]>;
    /** @deprecated Obsolete */
    totalCount: Maybe<Scalars["Int"]>;
    /** Public, private, or charter. */
    type: Maybe<Scalars["String"]>;
};
export type SchoolAddress = {
    __typename?: "SchoolAddress";
    city: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    zip: Maybe<Scalars["String"]>;
};
export type ScreeningCriteria = {
    __typename?: "ScreeningCriteria";
    /** Additional screening criteria */
    additional: Maybe<Scalars["String"]>;
    /** Credit score screening criteria */
    creditScore: Maybe<Scalars["String"]>;
    /** Eviction history requirements */
    evictionHistory: Maybe<Scalars["String"]>;
    /** The ratio of income to rent */
    incomeToRent: Maybe<Scalars["String"]>;
    /** Maximum past debt */
    pastDebt: Maybe<Scalars["String"]>;
    /** Allow no previous rental history */
    rentalHistory: Maybe<Scalars["String"]>;
};
export type SeoTest = {
    __typename?: "SeoTest";
    slot: Maybe<Scalars["Int"]>;
    treatment: Maybe<Scalars["String"]>;
    trial: Maybe<Scalars["String"]>;
};
export type ServiceAgreement = {
    createdDate: Maybe<Scalars["DateTime"]>;
    zDocsId: Maybe<Scalars["String"]>;
};
export type ServiceAgreements = {
    __typename?: "ServiceAgreements";
};
export type ShopperSavedHome = {
    __typename?: "ShopperSavedHome";
    /**  the categories this saved home belongs to  */
    categories: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    saveDateTime: Maybe<Scalars["DateTime"]>;
};
export type ShowingTimeSlot = {
    __typename?: "ShowingTimeSlot";
    /**
     * **Definition:** The end time of the available time slot, in the property time zone
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 13:30
     */
    endTime: Maybe<Scalars["LocalTime"]>;
    /**
     * **Definition:** The start time of the available time slot, in the property time zone
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 13:00
     */
    startTime: Maybe<Scalars["LocalTime"]>;
};
export type ShowingTimeTourAvailability = {
    __typename?: "ShowingTimeTourAvailability";
};
export type ShowingTimeTourAvailabilityPerDate = {
    __typename?: "ShowingTimeTourAvailabilityPerDate";
    /**
     * **Definition:** The requested date for the availability of the interested property
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2025-12-31
     */
    requestedDate: Maybe<Scalars["LocalDate"]>;
};
/**
 * **Definition:** Sms preferences for agent notifications
 * **Datasource:** EAN-API
 *
 * **Team Slack:** #deltaforce
 */
export type SmsPreferences = {
    __typename?: "SmsPreferences";
    active: Maybe<Scalars["Boolean"]>;
    agentPhoneNumber: Maybe<Scalars["String"]>;
    dayMask: Maybe<Scalars["String"]>;
    hourMask: Maybe<Scalars["String"]>;
    smsPreferenceId: Maybe<Scalars["ID"]>;
    timeZone: Maybe<Scalars["String"]>;
};
export type SolarPotential = {
    __typename?: "SolarPotential";
    /**
     * The build factor value is based on the pitch, orientation, and size of the
     * roof planes, along with the amount of shade across the roof.
     */
    buildFactor: Maybe<Scalars["Float"]>;
    /** Based on data from NREL, this corresponds to the annual amount of solar radiation in this region. */
    climateFactor: Maybe<Scalars["Float"]>;
    /** Based on data from NREL, the higher the average cost of electricity the higher the score. */
    electricityFactor: Maybe<Scalars["Float"]>;
    /** Based on data from NREL who estimates the average cost of a solar installation in the region. */
    solarFactor: Maybe<Scalars["Float"]>;
    /** SunScore is a value out of 100 that takes into account a buildings ability to utilize and save money using solar panals. */
    sunScore: Maybe<Scalars["Float"]>;
};
/** Special offer information with end date information */
export type SpecialOffer = {
    __typename?: "SpecialOffer";
    description: Maybe<Scalars["String"]>;
    endDate: Maybe<Scalars["DateTime"]>;
};
export type SpecialOfferType = {
    __typename?: "SpecialOfferType";
    specialOfferBeginDate: Maybe<Scalars["String"]>;
    specialOfferDescription: Maybe<Scalars["String"]>;
    specialOfferEndDate: Maybe<Scalars["String"]>;
    specialOfferId: Maybe<Scalars["Int"]>;
};
export type StandingOffer = {
    __typename?: "StandingOffer";
    expGroup: Maybe<Scalars["String"]>;
    isStandingOfferEligible: Maybe<Scalars["Boolean"]>;
    market: Maybe<Scalars["String"]>;
    standingOfferPrice: Maybe<Scalars["Int"]>;
    version: Maybe<Scalars["String"]>;
};
/** A static map of the requested property in a range of sizes */
export type StaticMap = {
    __typename?: "StaticMap";
};
export type StickyHeader = {
    __typename?: "StickyHeader";
    /** The monthly cost value to display on the sticky header */
    monthlyCost: Maybe<Scalars["String"]>;
};
/** Street view images of the requested property in a range of sizes */
export type StreetView = {
    __typename?: "StreetView";
};
export type StringValue = {
    __typename?: "StringValue";
    string: Scalars["String"];
};
export type SubmitFlowCTA = {
    __typename?: "SubmitFlowCTA";
    label: Scalars["String"];
};
export type SubmitFlowCTAClickstreamMetadata = {
    __typename?: "SubmitFlowCTAClickstreamMetadata";
    onClick: Maybe<Scalars["JSON"]>;
    onError: Maybe<Scalars["JSON"]>;
    onSuccess: Maybe<Scalars["JSON"]>;
};
export type SubmitFlowComponentClickstreamMetadata = {
    __typename?: "SubmitFlowComponentClickstreamMetadata";
    onClick: Maybe<Scalars["JSON"]>;
    onEarlyExit: Maybe<Scalars["JSON"]>;
    onExit: Maybe<Scalars["JSON"]>;
    onPageView: Maybe<Scalars["JSON"]>;
    onSuccess: Maybe<Scalars["JSON"]>;
};
export type SubmitFlowImageFormat = {
    __typename?: "SubmitFlowImageFormat";
    url: Scalars["String"];
};
export type SubmitFlowPhoto = {
    __typename?: "SubmitFlowPhoto";
};
export type SubmitFlowTip = {
    __typename?: "SubmitFlowTip";
    text: Scalars["String"];
};
/** A single item in a tax history */
export type TaxRecord = {
    __typename?: "TaxRecord";
    /** The percentage change in tax paid over the previous tax year */
    taxIncreaseRate: Maybe<Scalars["Float"]>;
    /** The amount of property tax paid for the given tax year */
    taxPaid: Maybe<Scalars["Float"]>;
    /** A timestamp indicating which tax year this record references */
    time: Maybe<Scalars["DateTime"]>;
    /** The assessed tax value of the property for the given tax year */
    value: Maybe<Scalars["Float"]>;
    /** The percentage change in assessed tax value over the previous tax year */
    valueIncreaseRate: Maybe<Scalars["Float"]>;
};
/** thirty year fixed rate object */
export type ThirtyYearFixedBucket = {
    __typename?: "ThirtyYearFixedBucket";
    lastUpdated: Maybe<Scalars["DateTime"]>;
    rate: Maybe<Scalars["Float"]>;
    rateSource: Maybe<Scalars["String"]>;
};
export type Timeline = {
    __typename?: "Timeline";
    endDate: Maybe<Scalars["Time"]>;
    startDate: Maybe<Scalars["Time"]>;
};
export type TourAppointment = {
    __typename?: "TourAppointment";
    /**
     * **Definition:** Unique identifier for tour appointment
     *
     * **Source:** Appointments API
     *
     * **No Auth**
     */
    appointmentHash: Maybe<Scalars["ID"]>;
    /**
     * **Definition:** The type of booking for this tour appointment (ex. STANDARD, INSTANT_BOOK)
     *
     * **Source:** Appointments API
     *
     * **No Auth**
     */
    bookingType: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The date the appointment request was created
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     *
     * **Example:** 2023-06-22T14:20:00Z
     */
    creationDateTimeISO: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Flag to indicates that the appointment is for the whole day
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    isAllDay: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Lead id for the appointment
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    leadId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** CRM message id for the appointment
     *
     * **Source:** Leads API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment-agent.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    messageId: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The type of ShowingTime appointment (ex. "Go and Show", "Appointment Required, Confirm With Any")
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** not visible
     */
    showingAppointmentType: Maybe<Scalars["String"]>;
    /**
     * **Definition:** The ShowingTime status of the appointment (ex. "Requested", "Confirmed", ...)
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer", "authorized_buyer_agent"
     */
    showingTimeStatus: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Subsequent tour request time of expiration in epoch seconds
     *
     * **Source:** Alan Subsequent Tours Service
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    subtRequestExpirationTime: Maybe<Scalars["Int"]>;
    /**
     * **Definition:** The standalone Tour Management Page's Url
     *
     * **Source:** Touring subgraph (TSG)
     *
     * **No Auth**
     */
    tourManagementPageUrl: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Flag to indicates that the appointment was canceled by the logged in user
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** not supported
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    wasCanceledByCurrentViewer: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** Flag to indicates that the appointment was canceled via ShowingTime
     *
     * **Source:** Appointments API
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "touring/appointment.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** "authorized_buyer_agent"
     */
    wasCanceledViaShowingTime: Maybe<Scalars["Boolean"]>;
};
export type TourAppointmentConnection = {
    __typename?: "TourAppointmentConnection";
};
export type TourAppointmentSlot = {
    __typename?: "TourAppointmentSlot";
    /**
     * **Definition:** The end date of a tour slot in UTC
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2019-06-14T14:56:00Z
     */
    endDateTimeISO: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** Flag that indicates if this requested time slot is available to book in ShowingTime. This field will be null if queried under any other field besides TourAppointment.requestedTourTimes
     *
     * **Source:** showing-time-api
     *
     * **Auth:** Uses the auth of the parent field
     */
    isAvailableInShowingTime: Maybe<Scalars["Boolean"]>;
    /**
     * **Definition:** The start date of a tour slot in UTC
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example:** 2019-06-14T14:56:00Z
     */
    startDateTimeISO: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** The timezone for this appointment slot
     *
     * **Source:** Appointments API
     *
     * **Auth:** Uses the auth of the parent field
     *
     * **Example ** America/Los_Angeles
     */
    timezone: Maybe<Scalars["String"]>;
};
export type TourAppointmentTourViews = {
    __typename?: "TourAppointmentTourViews";
};
export type TourDetailsView = {
    __typename?: "TourDetailsView";
};
export type TourParticipants = {
    __typename?: "TourParticipants";
};
export type TourRequestConfirmationView = {
    __typename?: "TourRequestConfirmationView";
};
export type TourStatus = {
    __typename?: "TourStatus";
    /**
     * **Definition:** A single status for this appointment
     *
     * **Source:** Appointments API
     *
     * **Example: ** "BUYER_REQUESTED_TOUR_CANCELLATION"
     */
    status: Maybe<Scalars["String"]>;
};
export type TourView = {
    __typename?: "TourView";
};
export type TourViewABTrial = {
    __typename?: "TourViewABTrial";
    /** The key sent to the ab trial. Typically a guid or installation id */
    trialKey: Maybe<Scalars["String"]>;
    /** An array of strings in the format of ab_trial_name.treatment_name */
    trialTreatments: Maybe<Array<Scalars["String"]>>;
};
export type TourViewActionButtons = {
    __typename?: "TourViewActionButtons";
};
export type TourViewAgentInfo = {
    __typename?: "TourViewAgentInfo";
};
export type TourViewButtonSelectFormField = {
    __typename?: "TourViewButtonSelectFormField";
};
export type TourViewButtonSelectFormFieldOption = {
    __typename?: "TourViewButtonSelectFormFieldOption";
    value: Maybe<Scalars["String"]>;
};
export type TourViewCTA = {
    __typename?: "TourViewCTA";
};
export type TourViewCancelTourButton = {
    __typename?: "TourViewCancelTourButton";
};
export type TourViewCancelTourRequestForm = {
    __typename?: "TourViewCancelTourRequestForm";
};
export type TourViewCheckboxSelectFormField = {
    __typename?: "TourViewCheckboxSelectFormField";
};
export type TourViewCheckboxSelectFormFieldOption = {
    __typename?: "TourViewCheckboxSelectFormFieldOption";
    value: Maybe<Scalars["String"]>;
};
export type TourViewConfirmation = {
    __typename?: "TourViewConfirmation";
};
export type TourViewContent = {
    __typename?: "TourViewContent";
};
export type TourViewDirectionsButton = {
    __typename?: "TourViewDirectionsButton";
};
export type TourViewDivider = {
    __typename?: "TourViewDivider";
};
export type TourViewExternalNavigationAction = {
    __typename?: "TourViewExternalNavigationAction";
    url: Maybe<Scalars["String"]>;
};
export type TourViewFailedSaveFeedbackToast = {
    __typename?: "TourViewFailedSaveFeedbackToast";
    duration: Scalars["Int"];
};
export type TourViewFailedSaveNotesToast = {
    __typename?: "TourViewFailedSaveNotesToast";
    duration: Scalars["Int"];
};
export type TourViewFailedTourCancelToast = {
    __typename?: "TourViewFailedTourCancelToast";
    duration: Scalars["Int"];
};
export type TourViewFailedTourRescheduleToast = {
    __typename?: "TourViewFailedTourRescheduleToast";
    duration: Scalars["Int"];
};
export type TourViewFeedbackForm = {
    __typename?: "TourViewFeedbackForm";
};
export type TourViewFinanceUpsellContent = {
    __typename?: "TourViewFinanceUpsellContent";
};
export type TourViewFormQuestion = {
    __typename?: "TourViewFormQuestion";
    id: Maybe<Scalars["String"]>;
};
export type TourViewFormSection = {
    __typename?: "TourViewFormSection";
};
export type TourViewHeading = {
    __typename?: "TourViewHeading";
};
export type TourViewHeroImage = {
    __typename?: "TourViewHeroImage";
};
export type TourViewHomeSearchButton = {
    __typename?: "TourViewHomeSearchButton";
};
export type TourViewList = {
    __typename?: "TourViewList";
};
export type TourViewListItem = {
    __typename?: "TourViewListItem";
};
export type TourViewLoginAlert = {
    __typename?: "TourViewLoginAlert";
};
export type TourViewLoginBanner = {
    __typename?: "TourViewLoginBanner";
};
export type TourViewMessageAgentButton = {
    __typename?: "TourViewMessageAgentButton";
};
export type TourViewMetadata = {
    __typename?: "TourViewMetadata";
};
export type TourViewMetadataEvents = {
    __typename?: "TourViewMetadataEvents";
};
export type TourViewMetadataNewLaneEvents = {
    __typename?: "TourViewMetadataNewLaneEvents";
    closeEventJson: Maybe<Scalars["JSONObject"]>;
    confirmEventJson: Maybe<Scalars["JSONObject"]>;
    impressionEventJson: Maybe<Scalars["JSONObject"]>;
    interactionEventJson: Maybe<Scalars["JSONObject"]>;
    updateEventJson: Maybe<Scalars["JSONObject"]>;
};
export type TourViewModuleMetadata = {
    __typename?: "TourViewModuleMetadata";
};
export type TourViewModulePhoto = {
    __typename?: "TourViewModulePhoto";
    label: Maybe<Scalars["String"]>;
};
export type TourViewModulePhotoFormat = {
    __typename?: "TourViewModulePhotoFormat";
    url: Scalars["String"];
};
export type TourViewModuleStyle = {
    __typename?: "TourViewModuleStyle";
};
export type TourViewModuleTag = {
    __typename?: "TourViewModuleTag";
};
/**
 * tour-cms typedefs (must be kept in sync)
 * tour-cms repo: https://gitlab.zgtools.net/zillow/tour-experience-management/front-end/tour-cms
 */
export type TourViewModuleText = {
    __typename?: "TourViewModuleText";
    text: Scalars["String"];
};
export type TourViewModuleTextEmailLinkAttribute = {
    __typename?: "TourViewModuleTextEmailLinkAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
    uri: Scalars["String"];
};
export type TourViewModuleTextFontColorAttribute = {
    __typename?: "TourViewModuleTextFontColorAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
};
export type TourViewModuleTextFontFamilyAttribute = {
    __typename?: "TourViewModuleTextFontFamilyAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
};
export type TourViewModuleTextFontTypeAttribute = {
    __typename?: "TourViewModuleTextFontTypeAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
};
export type TourViewModuleTextFontWeightAttribute = {
    __typename?: "TourViewModuleTextFontWeightAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
};
export type TourViewModuleTextLinkAttribute = {
    __typename?: "TourViewModuleTextLinkAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
    url: Scalars["String"];
};
export type TourViewModuleTextPhoneLinkAttribute = {
    __typename?: "TourViewModuleTextPhoneLinkAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
    uri: Scalars["String"];
};
export type TourViewModuleTextTooltipAttribute = {
    __typename?: "TourViewModuleTextTooltipAttribute";
    tokenEndIndex: Scalars["Int"];
    tokenStartIndex: Scalars["Int"];
    tooltipText: Scalars["String"];
};
export type TourViewNavigationAction = {
    __typename?: "TourViewNavigationAction";
    appointmentHash: Maybe<Scalars["String"]>;
};
export type TourViewPrequalificationButton = {
    __typename?: "TourViewPrequalificationButton";
};
export type TourViewProgressStepper = {
    __typename?: "TourViewProgressStepper";
    activeStepIndex: Scalars["Int"];
};
export type TourViewProgressStepperStep = {
    __typename?: "TourViewProgressStepperStep";
    label: Scalars["String"];
};
export type TourViewPropertyDetailsButton = {
    __typename?: "TourViewPropertyDetailsButton";
};
export type TourViewPropertyPhoto = {
    __typename?: "TourViewPropertyPhoto";
};
export type TourViewPropertyPhotoBadge = {
    __typename?: "TourViewPropertyPhotoBadge";
};
export type TourViewPropertySummaryCard = {
    __typename?: "TourViewPropertySummaryCard";
};
export type TourViewPropertyTags = {
    __typename?: "TourViewPropertyTags";
};
export type TourViewRadioSelectFormField = {
    __typename?: "TourViewRadioSelectFormField";
};
export type TourViewRadioSelectFormFieldOption = {
    __typename?: "TourViewRadioSelectFormFieldOption";
    value: Maybe<Scalars["String"]>;
};
export type TourViewRequestedTourTimes = {
    __typename?: "TourViewRequestedTourTimes";
};
export type TourViewRescheduleTourButton = {
    __typename?: "TourViewRescheduleTourButton";
};
export type TourViewSuccessfulSaveNotesToast = {
    __typename?: "TourViewSuccessfulSaveNotesToast";
    duration: Scalars["Int"];
};
export type TourViewSuccessfulTourCancelToast = {
    __typename?: "TourViewSuccessfulTourCancelToast";
    duration: Scalars["Int"];
};
export type TourViewSuccessfulTourRequestToast = {
    __typename?: "TourViewSuccessfulTourRequestToast";
    duration: Scalars["Int"];
};
export type TourViewSuccessfulTourRescheduleToast = {
    __typename?: "TourViewSuccessfulTourRescheduleToast";
    duration: Scalars["Int"];
};
export type TourViewTextarea = {
    __typename?: "TourViewTextarea";
    maxLength: Maybe<Scalars["Int"]>;
    placeholder: Maybe<Scalars["String"]>;
};
export type TourViewTourChecklist = {
    __typename?: "TourViewTourChecklist";
};
export type TourViewTourChecklistSection = {
    __typename?: "TourViewTourChecklistSection";
};
export type TourViewTourChecklistSubsection = {
    __typename?: "TourViewTourChecklistSubsection";
};
export type TourViewTourDetails = {
    __typename?: "TourViewTourDetails";
};
export type TourViewTourListCard = {
    __typename?: "TourViewTourListCard";
};
export type TourViewTourListSection = {
    __typename?: "TourViewTourListSection";
};
export type TourViewTourNotes = {
    __typename?: "TourViewTourNotes";
};
export type TourViewTourSummaryCard = {
    __typename?: "TourViewTourSummaryCard";
};
export type TourViewTriggerSMSAction = {
    __typename?: "TourViewTriggerSMSAction";
    messageBody: Scalars["String"];
    recipientPhoneNumber: Scalars["String"];
};
export type TourViewZHLUpsell = {
    __typename?: "TourViewZHLUpsell";
};
export type TouringAgreement = {
    __typename?: "TouringAgreement";
    /**
     * **Definition:** Legal brokerage name for the agent
     *
     * **Source:** Hardcoded agent info in TSG. Note PAAgent.businessName is editable by Alan and may not be the legal brokerage for filling out contracts
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    brokerage: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** link to the editable TouringAgreement in zDocs for agent
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible only to the agent associated with the agreement
     */
    editableAgentZDocsLink: Maybe<Scalars["String"]>;
    /**
     * **Definition:** Expiration of touring agreement
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    expirationISO: Maybe<Scalars["DateTime"]>;
    /**
     * **Definition:** link to the read only TouringAgreement in zDocs for Agent
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    readOnlyAgentZDocsLink: Maybe<Scalars["String"]>;
    /**
     * **Definition:** link to the read only TouringAgreement in zDocs for Beth
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    readOnlyBuyerZDocsLink: Maybe<Scalars["String"]>;
    /**
     * **Definition:** link to the template for a TouringAgreement in zDocs
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible only to agent associated with the agreement
     */
    readOnlyZDocsTemplateLink: Maybe<Scalars["String"]>;
    /**
     * **Definition:** documentId from ZDocs
     *
     * **Source:** zDocs
     *
     * **Auth - Zillow Oauth2.0 Client Credentials:** "agency-service/agreement.read"
     *
     * **Auth - Zillow OAuth2.0 User JWT/opaque token:** Visible to both the buyer and buyer agent associated with the agreement
     */
    zDocsId: Maybe<Scalars["String"]>;
};
export type TouringLink = {
    __typename?: "TouringLink";
    /**
     * **Definition:** a link
     *
     * **Source:** the source of the parent field
     *
     * **Auth:** Uses the auth of the parent field
     */
    full: Maybe<Scalars["String"]>;
    /**
     * **Definition:** a shortened version of the link
     *
     * **Source:** the source of the parent field
     *
     * **Note:** NOT IMPLEMENTED
     *
     * **Auth:** Uses the auth of the parent field
     */
    shortened: Maybe<Scalars["String"]>;
};
export type TransitScoreResponse = {
    __typename?: "TransitScoreResponse";
    description: Maybe<Scalars["String"]>;
    help_link: Maybe<Scalars["String"]>;
    transit_score: Maybe<Scalars["Int"]>;
    ws_link: Maybe<Scalars["String"]>;
};
export type TranslatedAmenities = {
    __typename?: "TranslatedAmenities";
    categorized: Maybe<Scalars["JSON"]>;
    displayCategorized: Maybe<Scalars["Boolean"]>;
};
export type UnassistedShowing = {
    __typename?: "UnassistedShowing";
    /** Whether it is possible to subscribe to the event that this home became available */
    canSubscribeToAvailable: Maybe<Scalars["Boolean"]>;
    /**
     * The timezone ID this property is in, such as "America/Los_Angeles", defined by
     * the Unicode Common Locale Data Repository (CLDR) project
     */
    homeTimeZone: Maybe<Scalars["String"]>;
    /** The unix timestamp until which self tours are allowed on this day */
    showingEndTime: Maybe<Scalars["DateTime"]>;
    /** The ISO-8601 date-time until which self tours are allowed on this day, in the property timezone */
    showingEndTimeIso: Maybe<Scalars["String"]>;
    /** The unix timestamp from which self tours are allowed on this day */
    showingStartTime: Maybe<Scalars["DateTime"]>;
    /** The ISO-8601 date-time from which self tours are allowed on this day, in the property timezone */
    showingStartTimeIso: Maybe<Scalars["String"]>;
    /**
     * Home showing availability status. If showings set up, will be AVAILABLE if in
     * permitted time range, UNAVAILABLE if outside. Otherwise DISABLED
     */
    showingStatus: Maybe<Scalars["String"]>;
    /** The unformatted US phone number to call in case of issues with home showings. May contain country code */
    showingSupportPhoneNumber: Maybe<Scalars["String"]>;
};
/** Detail unit information */
export type Unit = {
    __typename?: "Unit";
    availability: Maybe<Scalars["String"]>;
    baths: Maybe<Scalars["Float"]>;
    daysOn: Maybe<Scalars["Int"]>;
    hdpUrl: Maybe<Scalars["String"]>;
    listingType: Maybe<Scalars["String"]>;
    price: Maybe<Scalars["String"]>;
    providerListingID: Maybe<Scalars["String"]>;
    rentalApplicationsAcceptedType: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["Int"]>;
    unit: Maybe<Scalars["String"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
/** Unit information grouped by type: For Rent, For Sale and Off Market when available */
export type UnitListGroup = {
    __typename?: "UnitListGroup";
    label: Maybe<Scalars["String"]>;
    onMarket: Maybe<Scalars["Boolean"]>;
    unitCount: Maybe<Scalars["String"]>;
};
export type UnitOverview = {
    __typename?: "UnitOverview";
    bedCount: Maybe<Scalars["Int"]>;
    maxBaths: Maybe<Scalars["Float"]>;
    maxSqft: Maybe<Scalars["Int"]>;
    minBaths: Maybe<Scalars["Float"]>;
    minSqft: Maybe<Scalars["Int"]>;
};
/** Unit information grouped by number of bedroom */
export type UnitTableBedroomGroupType = {
    __typename?: "UnitTableBedroomGroupType";
    bedCount: Maybe<Scalars["Int"]>;
    priceRange: Maybe<Scalars["String"]>;
};
/** Detail unit information for WOW BDP */
export type UnitV2 = {
    __typename?: "UnitV2";
    availableFrom: Maybe<Scalars["String"]>;
    availableFromDateStr: Maybe<Scalars["String"]>;
    baths: Maybe<Scalars["Float"]>;
    beds: Maybe<Scalars["Int"]>;
    daysOn: Maybe<Scalars["Int"]>;
    /** Unit has approved third party virtual tour */
    hasApprovedThirdPartyVirtualTour: Maybe<Scalars["Boolean"]>;
    hdpUrl: Maybe<Scalars["String"]>;
    homeStatus: Maybe<Scalars["String"]>;
    housingConnector: Maybe<Scalars["Boolean"]>;
    housingConnectorExclusive: Maybe<Scalars["Boolean"]>;
    isRoomForRent: Maybe<Scalars["Boolean"]>;
    isShowcaseListing: Maybe<Scalars["Boolean"]>;
    /** Is this property owned by Zillow */
    isZillowOwned: Maybe<Scalars["Boolean"]>;
    lastSoldAt: Maybe<Scalars["String"]>;
    listingType: Maybe<Scalars["String"]>;
    maloneId: Maybe<Scalars["String"]>;
    maxPrice: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
    price: Maybe<Scalars["Int"]>;
    propertyType: Maybe<Scalars["String"]>;
    sqft: Maybe<Scalars["Int"]>;
    /** The display label used to group units */
    tabGroupLabel: Maybe<Scalars["String"]>;
    unitNumber: Maybe<Scalars["String"]>;
    /**
     * ZPID of closest match unit in the building. Used for attributing building
     * level contacts to a specific property to make sure they are tracked
     */
    zpid: Maybe<Scalars["ID"]>;
};
/** Summary fields for the units of the building */
export type UnitsSummary = {
    __typename?: "UnitsSummary";
    availableUnitCount: Maybe<Scalars["Int"]>;
    /** A list of all the possible bed counts for active rental units in the building */
    bedOptions: Maybe<Array<Maybe<Scalars["Int"]>>>;
    maxPrice: Maybe<Scalars["Int"]>;
    maxSqft: Maybe<Scalars["Int"]>;
    minPrice: Maybe<Scalars["Int"]>;
    minSqft: Maybe<Scalars["Int"]>;
    unitCount: Maybe<Scalars["Int"]>;
};
/** Updates tab internal route */
export type UpdatesRoute = {
    __typename?: "UpdatesRoute";
};
export type UrlObjectType = {
    __typename?: "UrlObjectType";
    /** url path for the requested field */
    path: Maybe<Scalars["String"]>;
    /** text description of the url */
    text: Maybe<Scalars["String"]>;
};
export type User = {
    __typename?: "User";
    /** Account creation timestamp */
    createDate: Scalars["DateTime"];
    /** Name meant for public display */
    displayName: Maybe<Scalars["String"]>;
    /** Email of the user */
    email: Maybe<Scalars["String"]>;
    /** Encoded zillow user ID of the user */
    encodedZuid: Scalars["String"];
    /** First name of the user */
    firstName: Maybe<Scalars["String"]>;
    hasOptOutOfAdvertising: Scalars["Boolean"];
    /** The user has a password set for their account */
    hasPassword: Scalars["Boolean"];
    /** The user has admin permissions */
    isAdmin: Scalars["Boolean"];
    isEmailVerified: Scalars["Boolean"];
    isEmployee: Scalars["Boolean"];
    isZillowGroupEmployee: Scalars["Boolean"];
    /** The user has signed the ZMA consent */
    isZmaConsentSigned: Maybe<Scalars["Boolean"]>;
    /** Last Name of the user */
    lastName: Maybe<Scalars["String"]>;
    logon: Maybe<Scalars["String"]>;
    /** Name of the user */
    name: Maybe<Scalars["String"]>;
    permissions: Array<Maybe<Scalars["Int"]>>;
    profiles: Array<Maybe<Scalars["Int"]>>;
    roles: Array<Maybe<Scalars["Int"]>>;
    /** User-created, human-readable identifier for the user's account */
    screenName: Maybe<Scalars["String"]>;
    status: Scalars["Int"];
    type: Scalars["Int"];
    /** ZMA consent signed timestamp */
    zmaConsentSignedDate: Maybe<Scalars["DateTime"]>;
    zuid: Scalars["Int"];
};
export type UserNote = {
    __typename?: "UserNote";
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    createdDateTimeISO: Maybe<Scalars["DateTime"]>;
    /**  user note identifier  */
    noteId: Maybe<Scalars["String"]>;
    /**  The note text added by the user  */
    noteText: Scalars["String"];
    /**  type of user note */
    noteType: Scalars["String"];
    /**  property identifier  */
    propertyId: Scalars["ID"];
    /**  The subject line or title added by the user  */
    subjectLine: Maybe<Scalars["String"]>;
    /**  An ISO-8601 encoded UTC date time string. Example value: 2019-07-03T20:47:55Z  */
    updatedDateTimeISO: Maybe<Scalars["DateTime"]>;
};
export type UserPersonalizedShoppingData = {
    __typename?: "UserPersonalizedShoppingData";
};
export type Valuation = {
    __typename?: "Valuation";
    /** @deprecated Harmonization paused */
    groupId: Maybe<Scalars["String"]>;
    high: Maybe<Scalars["Int"]>;
    highPercent: Maybe<Scalars["Int"]>;
    low: Maybe<Scalars["Int"]>;
    lowPercent: Maybe<Scalars["Int"]>;
    /** @deprecated Harmonization paused */
    valuationId: Maybe<Scalars["String"]>;
    valuationType: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["Int"]>;
};
/** Details about a video */
export type Video = {
    __typename?: "Video";
    /** The create date and time of the Video. Unix epoch timestamp. */
    createdAt: Maybe<Scalars["DateTime"]>;
    postingClient: Maybe<Scalars["String"]>;
    sourceVideoHeight: Maybe<Scalars["Int"]>;
    sourceVideoWidth: Maybe<Scalars["Int"]>;
    videoDurationSeconds: Maybe<Scalars["Int"]>;
    videoIdEncoded: Maybe<Scalars["String"]>;
};
/** Details about a video source */
export type VideoSource = {
    __typename?: "VideoSource";
    /** The preset/codec used to transcode the video. */
    presetName: Maybe<Scalars["String"]>;
    /** source URL */
    src: Maybe<Scalars["String"]>;
    /** Media type of the video source. Required by browsers in order to play video. */
    type: Maybe<Scalars["String"]>;
};
export type VideoUrl = {
    __typename?: "VideoUrl";
    label: Maybe<Scalars["String"]>;
    url: Maybe<Scalars["String"]>;
};
export type WalkScoreResponse = {
    __typename?: "WalkScoreResponse";
    description: Maybe<Scalars["String"]>;
    more_info_link: Maybe<Scalars["String"]>;
    walkscore: Maybe<Scalars["Int"]>;
    ws_link: Maybe<Scalars["String"]>;
};
export type ZHLBorrower = {
    __typename?: "ZHLBorrower";
    assets: Maybe<Array<Maybe<Scalars["ID"]>>>;
    attributes: Maybe<ZHLUserAttributes>;
    /** The borrower pair. */
    borrowerPair: Array<Maybe<Scalars["ID"]>>;
    /**
     * For primary borrower on a loan, returns the whole borrower group.
     * For a borrower in a pair, returns the pair.
     * For a single borrower, returns the single borrowers and the borrower itself.
     */
    coborrowers: Maybe<Array<Array<Maybe<Scalars["ID"]>>>>;
    employments: Maybe<Array<Maybe<Scalars["ID"]>>>;
    id: Scalars["ID"];
    loanId: Scalars["ID"];
    otherIncomes: Maybe<Array<Maybe<Scalars["ID"]>>>;
    zuid: Maybe<Scalars["ID"]>;
};
export type ZHLCreditConsent = {
    __typename?: "ZHLCreditConsent";
};
export type ZHLDashboardActivationToken = {
    __typename?: "ZHLDashboardActivationToken";
    expirationUtc: Scalars["String"];
    token: Scalars["String"];
};
export enum ZHLDashboardActivationTokenGenerationStatus {
    GENERATED = "GENERATED",
    USER_PREVIOUSLY_ACTIVATED = "USER_PREVIOUSLY_ACTIVATED"
}
export type ZHLDashboardErrorExtension = {
    __typename?: "ZHLDashboardErrorExtension";
    errorCode: Maybe<Scalars["Int"]>;
    errorMsg: Maybe<Scalars["String"]>;
    errorType: Maybe<Scalars["String"]>;
    statusText: Maybe<Scalars["String"]>;
    typename: Maybe<Scalars["String"]>;
};
export type ZHLDashboardGenerateActivationTokenResult = {
    __typename?: "ZHLDashboardGenerateActivationTokenResult";
    activationToken: Maybe<ZHLDashboardActivationToken>;
    activationUrl: Maybe<Scalars["String"]>;
    tokenGenerationStatus: ZHLDashboardActivationTokenGenerationStatus;
};
export type ZHLDashboardUserActivationResult = {
    __typename?: "ZHLDashboardUserActivationResult";
    dashboardUrl: Maybe<Scalars["String"]>;
    status: ZHLDashboardUserActivationStatus;
};
export enum ZHLDashboardUserActivationStatus {
    ACTIVATED = "ACTIVATED",
    FAILED = "FAILED"
}
/** Document in a loan. Backed by zDocs to provide viewing & signing experience. */
export type ZHLDocument = {
    __typename?: "ZHLDocument";
    _id: Scalars["ID"];
    createdBy: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["String"]>;
    documentId: Scalars["ID"];
    /** @deprecated(reason: "Use documentId instead") while "_id" is a unique identifier for caching purpose only, will change "id" to equal "_id" in the future */
    id: Scalars["ID"];
    name: Maybe<Scalars["String"]>;
    sortKey: Maybe<Scalars["ID"]>;
    uploadURL: Maybe<Scalars["String"]>;
    viewingURL: Maybe<Scalars["String"]>;
};
export type ZHLDocumentMetadata = {
    __typename?: "ZHLDocumentMetadata";
    documentURL: Maybe<Scalars["String"]>;
    downloadURL: Maybe<Scalars["String"]>;
};
export type ZHLDocumentPreApprovalMetaData = {
    __typename?: "ZHLDocumentPreApprovalMetaData";
    expiryDate: Maybe<Scalars["Date"]>;
    issueDate: Scalars["Date"];
    loanAmount: Scalars["String"];
};
export type ZHLLFSMetaData = {
    __typename?: "ZHLLFSMetaData";
    id: Maybe<Scalars["ID"]>;
};
export type ZHLLeadSummary = {
    __typename?: "ZHLLeadSummary";
    id: Scalars["ID"];
    leadState: Maybe<Scalars["String"]>;
    propertyValue: Maybe<Scalars["Float"]>;
};
export type ZHLLoan = {
    __typename?: "ZHLLoan";
    attributes: Maybe<ZHLLoanAttributes>;
    borrowers: Maybe<Array<ZHLBorrower>>;
    ctaURL: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    lead: Maybe<ZHLLeadSummary>;
    loanNumber: Maybe<Scalars["String"]>;
    loanOfficer: Maybe<ZHLLoanOfficer>;
    loanProcessor: Maybe<ZHLLoanProcessor>;
    /** This returns mock data.  Will be implemented soon. */
    offerAccepted: Maybe<Scalars["Boolean"]>;
    /** This returns current pre-approval letter. */
    preApprovalLetterURL: Maybe<ZHLDocumentMetadata>;
    salesforceLoanStage: Maybe<Scalars["String"]>;
    /** This is the loan status as defined from LFS. */
    status: Maybe<Scalars["String"]>;
    tridTriggeredUTC: Maybe<Scalars["String"]>;
};
export type ZHLLoanAttributes = {
    __typename?: "ZHLLoanAttributes";
    downPayment: Maybe<Scalars["Float"]>;
    leadId: Maybe<Scalars["ID"]>;
    purchaseLocation: Maybe<ZHLLocation>;
    targetLoanAmount: Maybe<Scalars["Float"]>;
    valuation: Maybe<Scalars["Float"]>;
};
export type ZHLLoanOfficer = {
    __typename?: "ZHLLoanOfficer";
    branchNMLSID: Maybe<Scalars["Int"]>;
    email: Maybe<Scalars["String"]>;
    /** Workday Employee ID */
    employeeID: Maybe<Scalars["ID"]>;
    fullName: Maybe<Scalars["String"]>;
    name: Maybe<ZHLName>;
    nmlsID: Maybe<Scalars["Int"]>;
    officePhone: Maybe<Scalars["String"]>;
    profilePictureURL: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    zgEmail: Maybe<Scalars["String"]>;
    zhlEmail: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export type ZHLLoanProcessor = {
    __typename?: "ZHLLoanProcessor";
    email: Maybe<Scalars["String"]>;
    name: Maybe<ZHLName>;
    officePhone: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export type ZHLLocation = {
    __typename?: "ZHLLocation";
    city: Maybe<Scalars["String"]>;
    countyFIPS: Maybe<Scalars["String"]>;
    state: Maybe<Scalars["String"]>;
    street: Maybe<Scalars["String"]>;
    zipcode: Maybe<Scalars["String"]>;
};
export type ZHLMACExperience = {
    __typename?: "ZHLMACExperience";
    dashboardURL: Maybe<Scalars["String"]>;
};
export type ZHLName = {
    __typename?: "ZHLName";
    first: Maybe<Scalars["String"]>;
    last: Maybe<Scalars["String"]>;
    middle: Maybe<Scalars["String"]>;
    suffix: Maybe<Scalars["String"]>;
};
export type ZHLParticipant = {
    __typename?: "ZHLParticipant";
    id: Maybe<Scalars["ID"]>;
    participantType: Maybe<Scalars["String"]>;
};
export type ZHLPersonalizedNextStep = {
    __typename?: "ZHLPersonalizedNextStep";
    status: ZHLPersonalizedNextStepStatus;
    title: Scalars["String"];
};
export enum ZHLPersonalizedNextStepState {
    DIGITAL_PREAPPROVAL_NEW_APPLICATION = "DIGITAL_PREAPPROVAL_NEW_APPLICATION",
    DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS = "DIGITAL_PREAPPROVAL_VERIFIED_OUTSTANDING_TASKS",
    DIGITAL_PREAPPROVAL_VERIFIED_PREAPPROVAL = "DIGITAL_PREAPPROVAL_VERIFIED_PREAPPROVAL",
    NEW_APPLICATION = "NEW_APPLICATION",
    OUTSTANDING_TASKS = "OUTSTANDING_TASKS",
    VERIFIED_PREAPPROVAL = "VERIFIED_PREAPPROVAL",
    WAITING_TO_CLOSE = "WAITING_TO_CLOSE"
}
export enum ZHLPersonalizedNextStepStatus {
    COMPLETED = "COMPLETED",
    CURRENT = "CURRENT",
    NOT_STARTED = "NOT_STARTED"
}
export type ZHLPersonalizedNextSteps = {
    __typename?: "ZHLPersonalizedNextSteps";
    currentState: ZHLPersonalizedNextStepState;
    loanApplicationExperienceURL: Maybe<Scalars["String"]>;
    loanId: Scalars["ID"];
    steps: Array<ZHLPersonalizedNextStep>;
};
export type ZHLPreApprovalDigitalExperience = {
    __typename?: "ZHLPreApprovalDigitalExperience";
    ctaURL: Maybe<Scalars["String"]>;
    ctaURLWithHost: Maybe<Scalars["String"]>;
    isEnabled: Scalars["Boolean"];
};
export type ZHLPreapprovalLetter = {
    __typename?: "ZHLPreapprovalLetter";
    _id: Scalars["ID"];
    createdBy: Scalars["String"];
    createdDate: Scalars["Date"];
    documentId: Scalars["ID"];
    downloadURL: Scalars["String"];
    viewingURL: Scalars["String"];
};
export type ZHLRateQuote = {
    __typename?: "ZHLRateQuote";
    id: Scalars["ID"];
};
export type ZHLScenario = {
    __typename?: "ZHLScenario";
    id: Scalars["ID"];
};
export type ZHLScenarioAttributes = {
    __typename?: "ZHLScenarioAttributes";
};
export type ZHLTask = {
    __typename?: "ZHLTask";
    externalDescription: Maybe<Scalars["String"]>;
    id: Scalars["ID"];
    internalDescription: Maybe<Scalars["String"]>;
    /** @deprecated No current use case or returned data */
    stepMessage: Maybe<Scalars["String"]>;
    taskCompletedDate: Maybe<Scalars["String"]>;
    taskCreatedDate: Maybe<Scalars["String"]>;
    taskDueDate: Maybe<Scalars["String"]>;
    taskName: Maybe<Scalars["String"]>;
    taskReRequestedDate: Maybe<Scalars["String"]>;
    taskUpdatedDate: Maybe<Scalars["String"]>;
    taskUpdatedDateByZHLEmployee: Maybe<Scalars["String"]>;
    title: Maybe<Scalars["String"]>;
};
export type ZHLTaskComment = {
    __typename?: "ZHLTaskComment";
    content: Maybe<Scalars["String"]>;
    createdBy: Maybe<Scalars["String"]>;
    createdDate: Maybe<Scalars["String"]>;
    id: Maybe<Scalars["ID"]>;
};
export type ZHLTaskParticipant = {
    __typename?: "ZHLTaskParticipant";
    borrower: Maybe<ZHLBorrower>;
    /** Borrower's UUID in Loan File Service */
    borrowerId: Maybe<Scalars["ID"]>;
    zuid: Maybe<Scalars["ID"]>;
};
export type ZHLUserAttributes = {
    __typename?: "ZHLUserAttributes";
    birthDate: Maybe<Scalars["String"]>;
    cellPhone: Maybe<Scalars["String"]>;
    email: Maybe<Scalars["String"]>;
    names: Maybe<Array<ZHLName>>;
    taxpayerID: Maybe<Scalars["String"]>;
};
/**
 * Type used to see if participants have a conversation together.
 * Requires the JWT Auth Header and passed in participantId to determine all the participants.
 * Resolved only via ZG-Graph federated calls to resolve the entity.
 */
export type ZIMConversationParticipantSummary = {
    __typename?: "ZIMConversationParticipantSummary";
    allParticipantIds: Array<Scalars["String"]>;
    participantId: Scalars["String"];
};
export type ZMAModel = {
    __typename?: "ZMAModel";
    approveDate: Maybe<Scalars["DateTime"]>;
    zmaValue: Maybe<Scalars["Float"]>;
    zmaValueHigh: Maybe<Scalars["Float"]>;
    zmaValueLow: Maybe<Scalars["Float"]>;
};
/** The listing programs for a given property. Please reach out to ZOAP team (#zo-advisor-platform) for more information. */
export type ZOListingPrograms = {
    __typename?: "ZOListingPrograms";
    amount: Maybe<Scalars["String"]>;
    type: Maybe<Scalars["String"]>;
};
export type ZOUpsellLink = {
    __typename?: "ZOUpsellLink";
    url: Maybe<Scalars["String"]>;
};
export type ZOUpsellLinkParameter = {
    __typename?: "ZOUpsellLinkParameter";
    name: Maybe<Scalars["String"]>;
    value: Maybe<Scalars["String"]>;
};
export type ZOUpsellLinks = {
    __typename?: "ZOUpsellLinks";
};
export type ZOUpsellURLs = {
    __typename?: "ZOUpsellURLs";
    /** The landing page to open for clicking ZO upsell link */
    landingPage: Maybe<Scalars["String"]>;
    /** The page for requesting an offer for a property */
    requestAnOfferPage: Maybe<Scalars["String"]>;
};
export type ZestimateDeepDiveHedonicCompsModel = {
    __typename?: "ZestimateDeepDiveHedonicCompsModel";
    estimate: Maybe<Scalars["Int"]>;
};
export type ZestimateDeepDiveListRatioModel = {
    __typename?: "ZestimateDeepDiveListRatioModel";
    estimate: Maybe<Scalars["Int"]>;
    listRatio: Maybe<Scalars["Float"]>;
};
export type ZestimateDeepDiveOffMarketModel = {
    __typename?: "ZestimateDeepDiveOffMarketModel";
    estimate: Maybe<Scalars["Int"]>;
};
export type ZestimateDeepDivePriorSaleModel = {
    __typename?: "ZestimateDeepDivePriorSaleModel";
    estimate: Maybe<Scalars["Int"]>;
    soldDate: Maybe<Scalars["DateTime"]>;
    soldPrice: Maybe<Scalars["Int"]>;
    wrsRatio: Maybe<Scalars["Float"]>;
};
export type ZestimateDeepDiveTaxRatioModel = {
    __typename?: "ZestimateDeepDiveTaxRatioModel";
    estimate: Maybe<Scalars["Int"]>;
    regionId: Maybe<Scalars["ID"]>;
    taxAssessmentYear: Maybe<Scalars["Int"]>;
    taxRatio: Maybe<Scalars["Float"]>;
    taxValue: Maybe<Scalars["Int"]>;
    /** @deprecated Use property.taxAssessedYear, as it is the same data */
    taxYear: Maybe<Scalars["Int"]>;
};
export type ZillowOfferMarketType = {
    __typename?: "ZillowOfferMarketType";
    code: Maybe<Scalars["String"]>;
    legacyName: Maybe<Scalars["String"]>;
    marketId: Maybe<Scalars["String"]>;
    name: Maybe<Scalars["String"]>;
};
/** Market AB treatments tied to guid */
export type ZoGuidBasedMarketABTestsType = {
    __typename?: "ZoGuidBasedMarketABTestsType";
    abTest: Maybe<Scalars["String"]>;
};
export type autoPublishPastSalesSetting = {
    __typename?: "autoPublishPastSalesSetting";
    shouldAutoPublish: Scalars["Boolean"];
    timeUpdatedUTC: Scalars["String"];
};
export type buildingInsights = {
    __typename?: "buildingInsights";
    phrases: Maybe<Array<Maybe<Scalars["String"]>>>;
    treatmentId: Maybe<Scalars["String"]>;
};
export type covers = {
    __typename?: "covers";
    /** Is gender identity */
    genderIdentity: Maybe<Scalars["Boolean"]>;
    /** Is housing choice voucher */
    housingChoiceVoucher: Maybe<Scalars["Boolean"]>;
    /** Is sexual orientation */
    sexualOrientation: Maybe<Scalars["Boolean"]>;
    /** Is source of income */
    sourceOfIncome: Maybe<Scalars["Boolean"]>;
};
export type downPaymentAssistance = {
    __typename?: "downPaymentAssistance";
    /** The maximum dollar amount of assistance provided by any of the available programs */
    maxAssistance: Maybe<Scalars["Int"]>;
    /** The number of available programs */
    resultCount: Maybe<Scalars["Int"]>;
};
/** Home insights for home features */
export type homeInsights = {
    __typename?: "homeInsights";
    palsId: Maybe<Scalars["String"]>;
};
/** Interactive media experience */
export type imx = {
    __typename?: "imx";
    hasLocalizedPhotos: Maybe<Scalars["Boolean"]>;
    isLmsTour: Maybe<Scalars["Boolean"]>;
    revisionId: Maybe<Scalars["String"]>;
    viewerUrl: Maybe<Scalars["String"]>;
};
/** Insight phrases for home highlights */
export type insights = {
    __typename?: "insights";
    modelId: Maybe<Scalars["String"]>;
    phrases: Maybe<Array<Maybe<Scalars["String"]>>>;
    treatmentId: Maybe<Scalars["String"]>;
    updatedTime: Maybe<Scalars["DateTime"]>;
};
export type levelType = {
    __typename?: "levelType";
    /** The geographical level for this protection (eg state, county, or city) */
    level: Maybe<Scalars["String"]>;
    /** lgbtmap.org state page URL */
    statePageUrl: Maybe<Scalars["String"]>;
};
export type listingAgent = {
    __typename?: "listingAgent";
    associatedAgentType: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoField1: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoField2: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoField3: Maybe<Scalars["String"]>;
    memberFullName: Maybe<Scalars["String"]>;
    memberStateLicense: Maybe<Scalars["String"]>;
};
export type listingMetadata = {
    __typename?: "listingMetadata";
    BuildingDataA: Maybe<Scalars["Boolean"]>;
    BuildingDataB: Maybe<Scalars["Boolean"]>;
    BuildingDataC: Maybe<Scalars["Boolean"]>;
    BuildingDataD: Maybe<Scalars["Boolean"]>;
    BuildingDataE: Maybe<Scalars["Boolean"]>;
    BuildingDataF: Maybe<Scalars["Boolean"]>;
    BuildingDataG: Maybe<Scalars["String"]>;
    BuildingDataH: Maybe<Scalars["String"]>;
    BuildingDataI: Maybe<Scalars["String"]>;
    BuildingDataJ: Maybe<Scalars["String"]>;
    BuildingDataK: Maybe<Scalars["String"]>;
    BuildingDataL: Maybe<Scalars["String"]>;
    BuildingDataM: Maybe<Scalars["String"]>;
    BuildingDataN: Maybe<Scalars["String"]>;
    BuildingDataO: Maybe<Scalars["String"]>;
    BuildingDataP: Maybe<Scalars["String"]>;
    BuildingDataQ: Maybe<Scalars["String"]>;
    BuildingDataR: Maybe<Scalars["Boolean"]>;
    BuildingDataS: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutA: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAA: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutAB: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutB: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutC: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutD: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutE: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutF: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutG: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutH: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutI: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutJ: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutK: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutL: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutM: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutN: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutO: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutP: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutQ: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutR: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutS: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutT: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutU: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutV: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutW: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutX: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutY: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the non-obfuscated version instead */
    FlexibleLayoutZ: Maybe<Scalars["Boolean"]>;
    /** @deprecated Use the camel-cased version instead */
    HidePriceAdjustmentFlexField: Maybe<Scalars["Boolean"]>;
    attributeAgentAttributionContact: Maybe<Scalars["Boolean"]>;
    attributeListingAttributionContact: Maybe<Scalars["Boolean"]>;
    attributeOfficeAttributionContact: Maybe<Scalars["Boolean"]>;
    canCommingleComparables: Maybe<Scalars["Boolean"]>;
    canShowAutomatedValuationDisplay: Maybe<Scalars["Boolean"]>;
    canShowComparables: Maybe<Scalars["Boolean"]>;
    canShowCroppedPhotos: Maybe<Scalars["Boolean"]>;
    canShowNonIDXMedia: Maybe<Scalars["Boolean"]>;
    canShowOnMap: Maybe<Scalars["Boolean"]>;
    canShowPrequalifiedLinkInChip: Maybe<Scalars["Boolean"]>;
    canShowPriceHistory: Maybe<Scalars["Boolean"]>;
    canShowPropertyContingency: Maybe<Scalars["Boolean"]>;
    canShowPropertyPetsAllowed: Maybe<Scalars["Boolean"]>;
    canShowTaxHistory: Maybe<Scalars["Boolean"]>;
    canShowUserGeneratedContent: Maybe<Scalars["Boolean"]>;
    canShowZillowLogoInHeader: Maybe<Scalars["Boolean"]>;
    comminglingCategory: Maybe<Scalars["Boolean"]>;
    comminglingCategoryIsRulesApplicable: Maybe<Scalars["Boolean"]>;
    hidePriceAdjustmentFlexField: Maybe<Scalars["Boolean"]>;
    isAdsRestricted: Maybe<Scalars["Boolean"]>;
    isSuperTrafficOptimized: Maybe<Scalars["Boolean"]>;
    mustAttributeOfficeNameBeforeAgentName: Maybe<Scalars["Boolean"]>;
    mustAttributeTeamNameBeforeAgentName: Maybe<Scalars["Boolean"]>;
    mustDisplayAttributionAboveLocalFacts: Maybe<Scalars["Boolean"]>;
    mustDisplayAttributionListAgentEmail: Maybe<Scalars["Boolean"]>;
    mustDisplayAttributionListAgentPhone: Maybe<Scalars["Boolean"]>;
    mustDisplayAttributionListAgentPhoneExtension: Maybe<Scalars["Boolean"]>;
    mustDisplayAttributionListingOfficePhone: Maybe<Scalars["Boolean"]>;
    mustDisplayAuctionStatusAsSold: Maybe<Scalars["Boolean"]>;
    mustDisplayDisclaimerBelowAttribution: Maybe<Scalars["Boolean"]>;
    mustDisplayFeedLogoInContactBox: Maybe<Scalars["Boolean"]>;
    mustHighlightAgentName: Maybe<Scalars["Boolean"]>;
    mustHighlightListOfficeName: Maybe<Scalars["Boolean"]>;
    mustHighlightMarketingType: Maybe<Scalars["Boolean"]>;
    mustHighlightMlsId: Maybe<Scalars["Boolean"]>;
    mustHighlightMlsStatus: Maybe<Scalars["Boolean"]>;
    mustMakeListingAgentContactable: Maybe<Scalars["Boolean"]>;
    mustPreferMlsPhotos: Maybe<Scalars["Boolean"]>;
    passwordRequiredForZestimateMarketAnalysis: Maybe<Scalars["Boolean"]>;
};
export type listingOffice = {
    __typename?: "listingOffice";
    associatedOfficeType: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoField1: Maybe<Scalars["String"]>;
    /** @deprecated Use non-obfuscated information instead */
    infoField2: Maybe<Scalars["String"]>;
    officeName: Maybe<Scalars["String"]>;
};
export type localProtections = {
    __typename?: "localProtections";
    /**
     * LGBT community at the <state|county|city> level
     * @deprecated Removed in v2 of the API
     */
    level: Maybe<Scalars["String"]>;
    /** List of legal protections included in response */
    protectionTypes: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * lgbtmap.org state page URL
     * @deprecated Removed in v2 of the API
     */
    statePageUrl: Maybe<Scalars["String"]>;
};
export type pals = {
    __typename?: "pals";
    name: Maybe<Scalars["String"]>;
    palsId: Maybe<Scalars["String"]>;
};
/** Posting Contact fields subset. */
export type postingContact = {
    __typename?: "postingContact";
    brokerName: Maybe<Scalars["String"]>;
    brokerageName: Maybe<Scalars["String"]>;
    /** Name of the listing provider contact. */
    name: Maybe<Scalars["String"]>;
};
export type propertyTourOptions = {
    __typename?: "propertyTourOptions";
    /** indicates whether or not ShowingTime is being called to determine availability */
    isFinal: Maybe<Scalars["Boolean"]>;
    /** string representation of the tour type, e.g. "STANDARD", "INSTANT", "INSTANT_BOOK", "NONE" */
    tourType: Maybe<Scalars["String"]>;
};
export type protectionLevels = {
    __typename?: "protectionLevels";
};
export type protections = {
    __typename?: "protections";
    /** Description of a protection */
    description: Maybe<Scalars["String"]>;
    /** Type of a protection */
    type: Maybe<Scalars["String"]>;
};
export type recommendedPropertyOrBuilding = {
    __typename?: "recommendedPropertyOrBuilding";
};
export type richMedia = {
    __typename?: "richMedia";
    palsIds: Maybe<Array<Maybe<Scalars["String"]>>>;
};
export type richMediaFloorPlan = {
    __typename?: "richMediaFloorPlan";
    floorMapGuid: Maybe<Scalars["String"]>;
    heroImageUrl: Maybe<Scalars["String"]>;
    viewerUrl: Maybe<Scalars["String"]>;
};
export type richMediaVideos = {
    __typename?: "richMediaVideos";
    hlsUrl: Maybe<Scalars["String"]>;
    mp4Url: Maybe<Scalars["String"]>;
    palsIds: Maybe<Scalars["String"]>;
};
export type richMediaVirtualTour = {
    __typename?: "richMediaVirtualTour";
    isLmsTour: Maybe<Scalars["Boolean"]>;
    revisionId: Maybe<Scalars["String"]>;
    viewerUrl: Maybe<Scalars["String"]>;
    vrModelGuid: Maybe<Scalars["String"]>;
};
export type selfTour = {
    __typename?: "selfTour";
    /** True if self-tour is enabled for property. */
    hasSelfTour: Maybe<Scalars["Boolean"]>;
    /** Third party URL used to direct users to in order to book self tours. */
    tourBookingUrl: Maybe<Scalars["String"]>;
    /** ID string of third party tour provider. */
    vendorId: Maybe<Scalars["String"]>;
    /** Third party URL where visitor terms are displayed for property tour. */
    visitorTermsUrl: Maybe<Scalars["String"]>;
};
export type sellingSoonModel = {
    __typename?: "sellingSoonModel";
    modelId: Maybe<Scalars["String"]>;
    percentile: Maybe<Scalars["Float"]>;
    treatmentId: Maybe<Scalars["String"]>;
};
export type thirdPartyVirtualTour = {
    __typename?: "thirdPartyVirtualTour";
    /** Whether the virtual tour provider is approved AND we know how to parse it */
    approved: Maybe<Scalars["Boolean"]>;
    /** Url to be linked to when embedding is not supported yet */
    externalUrl: Maybe<Scalars["String"]>;
    /** Label used to match third party tours to specific locations in a building, can be null */
    label: Maybe<Scalars["String"]>;
    /** Url to be embedded in the light box, can be null */
    lightboxUrl: Maybe<Scalars["String"]>;
    /** Friendly name for the provider */
    providerName: Maybe<Scalars["String"]>;
    /** Url to a static image to be used as a placeholder in the media stream, can be null */
    staticUrl: Maybe<Scalars["String"]>;
};
/** Types defined for PropertyTours in GDP (must be kept in sync) */
export type tourEligibility = {
    __typename?: "tourEligibility";
    /** boolean indicating if this property is eligible for a PA property tour */
    isPropertyTourEligible: Maybe<Scalars["Boolean"]>;
    /**
     * string representation of the tour type, e.g. "STANDARD", "INSTANT", "INSTANT_BOOK", "NONE"
     * @deprecated Use property.tourEligibility.propertyTourOptions.tourType.
     */
    propertyTourType: Maybe<Scalars["String"]>;
};
export type trackingTags = {
    __typename?: "trackingTags";
    hrsRequestId: Maybe<Scalars["String"]>;
};
export type vrModel = {
    __typename?: "vrModel";
    cdnHost: Maybe<Scalars["String"]>;
    posterUrl: Maybe<Scalars["String"]>;
    revisionId: Maybe<Scalars["String"]>;
    vrModelGuid: Maybe<Scalars["String"]>;
};
export type zestimateDeepDiveData = {
    __typename?: "zestimateDeepDiveData";
    /** @deprecated Use properly schema-typed siblings instead */
    zestimateDeepDiveResponseObject: Maybe<Scalars["String"]>;
};
export type zoAvailability = {
    __typename?: "zoAvailability";
    /** Whether the property is available for an upsell */
    available: Maybe<Scalars["Boolean"]>;
    /** The lead which this zpid qualifies for, which determines which upsell to display */
    leadType: Maybe<Scalars["String"]>;
};
export type zoStatics = {
    __typename?: "zoStatics";
    /** Versions of the value indexed by reno spec level */
    atSpecLevel: Maybe<Array<Maybe<Scalars["String"]>>>;
    /** The default value for a given key */
    default: Maybe<Scalars["String"]>;
};
export type zoUpsellDisplayFlags = {
    __typename?: "zoUpsellDisplayFlags";
    /** Whether to display Zillow Offers For Sale Upsell */
    showForSaleUpsell: Maybe<Scalars["Boolean"]>;
    /** Whether to display Zillow Offers Off Market Upsell */
    showOffMarketUpsell: Maybe<Scalars["Boolean"]>;
    /** Whether to display Zillow Offers Owner View Upsell */
    showOwnerViewUpsell: Maybe<Scalars["Boolean"]>;
};
export type zoUpsellDisplayInfo = {
    __typename?: "zoUpsellDisplayInfo";
    /** Whether to display an upsell */
    display: Maybe<Scalars["Boolean"]>;
    /** An object containing attributes used for displaying upsell serialized as JSON */
    displayAttributes: Maybe<Scalars["JSON"]>;
    /** A value to tell why upsell is displaying */
    displayCategory: Maybe<Scalars["String"]>;
    /** A list of all eligible lead types with OASIS Priority */
    eligibleLeadTypes: Maybe<Array<Maybe<Scalars["String"]>>>;
    /**
     * A boolean indicate whether the home passes ZO full criteria check.ZO full
     * criteria means for data of bedrooms, yearBuilt and LivingSquareFeet of the ZO
     * property, source should be reliable.
     */
    isEligibleZOFullCriteria: Maybe<Scalars["Boolean"]>;
    /**
     * A temporary boolean value that indicate whether the ZO_SO_QUESTIONNAIRE Market trial is enabled/On
     * @deprecated SO questionnaire experiment is done, it will always be on.
     */
    isSOQuestionnaireTrialOn: Maybe<Scalars["Boolean"]>;
    /** ID for the placement indicating where the upsell is displayed on the surface */
    placementId: Maybe<Scalars["String"]>;
    /** The reason why an upsell is turned on or off */
    reason: Maybe<Scalars["String"]>;
    /** ID for the surface on which the upsell is displayed */
    surfaceId: Maybe<Scalars["String"]>;
    /** The treatment for which an upsell should be using */
    treatment: Maybe<Scalars["String"]>;
};
export type ZHLDashboardErrorExtensionFragment = {
    __typename?: "ZHLDashboardErrorExtension";
    errorCode: number | null;
    errorType: string | null;
    statusText: string | null;
    errorMsg: string | null;
};
export type ActivateBlendLoanMutationVariables = Exact<{
    loanId: Scalars["ID"];
}>;
export type ActivateBlendLoanMutation = {
    __typename?: "Mutation";
    activateBlendLoan: {
        __typename?: "ActivateBlendLoanOutput";
        success: boolean | null;
        blend_activation_url: string | null;
    } | null;
};
export type ActivateZHLDashboardUserMutationVariables = Exact<{
    zuid: Scalars["String"];
    activationToken: Scalars["String"];
}>;
export type ActivateZHLDashboardUserMutation = {
    __typename?: "Mutation";
    activateZHLDashboardUser: {
        __typename?: "ZHLDashboardUserActivationResult";
        dashboardUrl: string | null;
        status: ZHLDashboardUserActivationStatus;
    };
};
export type GenerateZHLDashboardUserActivationTokenForLeadMutationVariables = Exact<{
    salesforceLeadId: Scalars["String"];
    borrowerEmail: Scalars["String"];
}>;
export type GenerateZHLDashboardUserActivationTokenForLeadMutation = {
    __typename?: "Mutation";
    generateZHLDashboardUserActivationTokenForLead: {
        __typename?: "ZHLDashboardGenerateActivationTokenResult";
        tokenGenerationStatus: ZHLDashboardActivationTokenGenerationStatus;
        activationUrl: string | null;
        activationToken: {
            __typename?: "ZHLDashboardActivationToken";
            token: string;
        } | null;
    };
};
export type GetEntryBounceModuleDataQueryVariables = Exact<{
    refId: Scalars["String"];
    refType: BridgeParticipantReferenceType;
}>;
export type GetEntryBounceModuleDataQuery = {
    __typename?: "Query";
    zhlMACExperience: {
        __typename?: "ZHLMACExperience";
        dashboardURL: string | null;
    } | null;
    bridgeContainer: {
        __typename?: "BridgeContainer";
        moves: Array<{
            __typename?: "BridgeMove";
            finance: Array<{
                __typename?: "BridgeFinance";
                zhlLoan: {
                    __typename?: "ZHLLoan";
                    id: string;
                    lead: {
                        __typename?: "ZHLLeadSummary";
                        id: string;
                    } | null;
                } | null;
            }>;
        }>;
    } | null;
};
export type GetHeroGraphicModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetHeroGraphicModuleDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
        };
    };
};
export type GetHomeLoansDashboardPageDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetHomeLoansDashboardPageDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
        };
    };
    zhlLoan: {
        __typename?: "ZHLLoan";
        id: string;
        lead: {
            __typename?: "ZHLLeadSummary";
            id: string;
        } | null;
    };
};
export type GetNavbarURLQueryVariables = Exact<{
    [key: string]: never;
}>;
export type GetNavbarURLQuery = {
    __typename?: "Query";
    zhlMACExperience: {
        __typename?: "ZHLMACExperience";
        dashboardURL: string | null;
    } | null;
};
export type GetPersonalizedNextStepsQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetPersonalizedNextStepsQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename?: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
    };
};
export type GetResourceCardModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetResourceCardModuleDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename?: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
    };
    zhlLoan: {
        __typename?: "ZHLLoan";
        id: string;
        lead: {
            __typename?: "ZHLLeadSummary";
            id: string;
        } | null;
        preApprovalLetterURL: {
            __typename?: "ZHLDocumentMetadata";
            downloadURL: string | null;
            documentURL: string | null;
        } | null;
    };
};
export type LoanOfficerFragment = {
    __typename?: "ZHLLoanOfficer";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    nmlsID: number | null;
    branchNMLSID: number | null;
    name: {
        __typename?: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type LoanProcessorFragment = {
    __typename?: "ZHLLoanProcessor";
    email: string | null;
    officePhone: string | null;
    title: string | null;
    name: {
        __typename?: "ZHLName";
        first: string | null;
        last: string | null;
    } | null;
};
export type GetTeamInformationCardModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetTeamInformationCardModuleDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename?: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
    };
    zhlLoan: {
        __typename?: "ZHLLoan";
        id: string;
        lead: {
            __typename?: "ZHLLeadSummary";
            id: string;
        } | null;
        loanOfficer: {
            __typename?: "ZHLLoanOfficer";
            email: string | null;
            officePhone: string | null;
            title: string | null;
            nmlsID: number | null;
            branchNMLSID: number | null;
            name: {
                __typename?: "ZHLName";
                first: string | null;
                last: string | null;
            } | null;
        } | null;
        loanProcessor: {
            __typename?: "ZHLLoanProcessor";
            email: string | null;
            officePhone: string | null;
            title: string | null;
            name: {
                __typename?: "ZHLName";
                first: string | null;
                last: string | null;
            } | null;
        } | null;
    };
};
export type GetUpsellModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetUpsellModuleDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            loanApplicationExperienceURL: string | null;
            loanId: string;
            steps: Array<{
                __typename?: "ZHLPersonalizedNextStep";
                title: string;
                status: ZHLPersonalizedNextStepStatus;
            }>;
        };
    };
    zhlLoan: {
        __typename?: "ZHLLoan";
        id: string;
        lead: {
            __typename?: "ZHLLeadSummary";
            id: string;
        } | null;
        attributes: {
            __typename?: "ZHLLoanAttributes";
            valuation: number | null;
            purchaseLocation: {
                __typename?: "ZHLLocation";
                street: string | null;
            } | null;
        } | null;
        preApprovalLetterURL: {
            __typename?: "ZHLDocumentMetadata";
            downloadURL: string | null;
            documentURL: string | null;
        } | null;
    };
};
export type GetViewSavedInformationModuleDataQueryVariables = Exact<{
    id: Scalars["ID"];
}>;
export type GetViewSavedInformationModuleDataQuery = {
    __typename?: "Query";
    homeLoansDashboard: {
        __typename?: "HomeLoansDashboard";
        personalizedNextSteps: {
            __typename?: "ZHLPersonalizedNextSteps";
            currentState: ZHLPersonalizedNextStepState;
            loanId: string;
            loanApplicationExperienceURL: string | null;
        };
    };
    zhlLoan: {
        __typename?: "ZHLLoan";
        id: string;
        lead: {
            __typename?: "ZHLLeadSummary";
            id: string;
        } | null;
    };
};
export type GetWelcomeBannerModuleDataQueryVariables = Exact<{
    loanID: Scalars["ID"];
}>;
export type GetWelcomeBannerModuleDataQuery = {
    __typename?: "Query";
    currentZHLBorrower: {
        __typename?: "ZHLBorrower";
        id: string;
        attributes: {
            __typename?: "ZHLUserAttributes";
            email: string | null;
            names: Array<{
                __typename?: "ZHLName";
                first: string | null;
                last: string | null;
            }> | null;
        } | null;
    } | null;
};
export const ZHLDashboardErrorExtensionFragmentDoc = gql `
    fragment ZHLDashboardErrorExtension on ZHLDashboardErrorExtension {
        errorCode
        errorType
        statusText
        errorMsg
    }
`;
export const LoanOfficerFragmentDoc = gql `
    fragment LoanOfficer on ZHLLoanOfficer {
        name {
            first
            last
        }
        email
        officePhone
        title
        nmlsID
        branchNMLSID
    }
`;
export const LoanProcessorFragmentDoc = gql `
    fragment LoanProcessor on ZHLLoanProcessor {
        name {
            first
            last
        }
        email
        officePhone
        title
    }
`;
export const ActivateBlendLoanDocument = gql `
    mutation ActivateBlendLoan($loanId: ID!) {
        activateBlendLoan(loanId: $loanId) {
            success
            blend_activation_url
        }
    }
`;
export type ActivateBlendLoanMutationFn = Apollo.MutationFunction<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>;
/**
 * __useActivateBlendLoanMutation__
 *
 * To run a mutation, you first call `useActivateBlendLoanMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateBlendLoanMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateBlendLoanMutation, { data, loading, error }] = useActivateBlendLoanMutation({
 *   variables: {
 *      loanId: // value for 'loanId'
 *   },
 * });
 */
export function useActivateBlendLoanMutation(baseOptions?: Apollo.MutationHookOptions<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>(ActivateBlendLoanDocument, options);
}
export type ActivateBlendLoanMutationHookResult = ReturnType<typeof useActivateBlendLoanMutation>;
export type ActivateBlendLoanMutationOptions = Apollo.BaseMutationOptions<ActivateBlendLoanMutation, ActivateBlendLoanMutationVariables>;
export const ActivateZHLDashboardUserDocument = gql `
    mutation ActivateZHLDashboardUser($zuid: String!, $activationToken: String!) {
        activateZHLDashboardUser(zuid: $zuid, activationToken: $activationToken) {
            dashboardUrl
            status
        }
    }
`;
export type ActivateZHLDashboardUserMutationFn = Apollo.MutationFunction<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>;
/**
 * __useActivateZHLDashboardUserMutation__
 *
 * To run a mutation, you first call `useActivateZHLDashboardUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useActivateZHLDashboardUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [activateZhlDashboardUserMutation, { data, loading, error }] = useActivateZHLDashboardUserMutation({
 *   variables: {
 *      zuid: // value for 'zuid'
 *      activationToken: // value for 'activationToken'
 *   },
 * });
 */
export function useActivateZHLDashboardUserMutation(baseOptions?: Apollo.MutationHookOptions<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>(ActivateZHLDashboardUserDocument, options);
}
export type ActivateZHLDashboardUserMutationHookResult = ReturnType<typeof useActivateZHLDashboardUserMutation>;
export type ActivateZHLDashboardUserMutationOptions = Apollo.BaseMutationOptions<ActivateZHLDashboardUserMutation, ActivateZHLDashboardUserMutationVariables>;
export const GenerateZHLDashboardUserActivationTokenForLeadDocument = gql `
    mutation GenerateZHLDashboardUserActivationTokenForLead($salesforceLeadId: String!, $borrowerEmail: String!) {
        generateZHLDashboardUserActivationTokenForLead(
            salesforceLeadId: $salesforceLeadId
            borrowerEmail: $borrowerEmail
        ) {
            tokenGenerationStatus
            activationUrl
            activationToken {
                token
            }
        }
    }
`;
export type GenerateZHLDashboardUserActivationTokenForLeadMutationFn = Apollo.MutationFunction<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>;
/**
 * __useGenerateZHLDashboardUserActivationTokenForLeadMutation__
 *
 * To run a mutation, you first call `useGenerateZHLDashboardUserActivationTokenForLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateZHLDashboardUserActivationTokenForLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateZhlDashboardUserActivationTokenForLeadMutation, { data, loading, error }] = useGenerateZHLDashboardUserActivationTokenForLeadMutation({
 *   variables: {
 *      salesforceLeadId: // value for 'salesforceLeadId'
 *      borrowerEmail: // value for 'borrowerEmail'
 *   },
 * });
 */
export function useGenerateZHLDashboardUserActivationTokenForLeadMutation(baseOptions?: Apollo.MutationHookOptions<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>(GenerateZHLDashboardUserActivationTokenForLeadDocument, options);
}
export type GenerateZHLDashboardUserActivationTokenForLeadMutationHookResult = ReturnType<typeof useGenerateZHLDashboardUserActivationTokenForLeadMutation>;
export type GenerateZHLDashboardUserActivationTokenForLeadMutationOptions = Apollo.BaseMutationOptions<GenerateZHLDashboardUserActivationTokenForLeadMutation, GenerateZHLDashboardUserActivationTokenForLeadMutationVariables>;
export const GetEntryBounceModuleDataDocument = gql `
    query GetEntryBounceModuleData($refId: String!, $refType: BridgeParticipantReferenceType!) {
        zhlMACExperience {
            dashboardURL
        }
        bridgeContainer(refId: $refId, refType: $refType) {
            moves {
                finance {
                    zhlLoan {
                        id
                        lead {
                            id
                        }
                    }
                }
            }
        }
    }
`;
/**
 * __useGetEntryBounceModuleDataQuery__
 *
 * To run a query within a React component, call `useGetEntryBounceModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEntryBounceModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEntryBounceModuleDataQuery({
 *   variables: {
 *      refId: // value for 'refId'
 *      refType: // value for 'refType'
 *   },
 * });
 */
export function useGetEntryBounceModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>(GetEntryBounceModuleDataDocument, options);
}
export function useGetEntryBounceModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>(GetEntryBounceModuleDataDocument, options);
}
export type GetEntryBounceModuleDataQueryHookResult = ReturnType<typeof useGetEntryBounceModuleDataQuery>;
export type GetEntryBounceModuleDataLazyQueryHookResult = ReturnType<typeof useGetEntryBounceModuleDataLazyQuery>;
export type GetEntryBounceModuleDataQueryResult = Apollo.QueryResult<GetEntryBounceModuleDataQuery, GetEntryBounceModuleDataQueryVariables>;
export const GetHeroGraphicModuleDataDocument = gql `
    query GetHeroGraphicModuleData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
            }
        }
    }
`;
/**
 * __useGetHeroGraphicModuleDataQuery__
 *
 * To run a query within a React component, call `useGetHeroGraphicModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHeroGraphicModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHeroGraphicModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHeroGraphicModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>(GetHeroGraphicModuleDataDocument, options);
}
export function useGetHeroGraphicModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>(GetHeroGraphicModuleDataDocument, options);
}
export type GetHeroGraphicModuleDataQueryHookResult = ReturnType<typeof useGetHeroGraphicModuleDataQuery>;
export type GetHeroGraphicModuleDataLazyQueryHookResult = ReturnType<typeof useGetHeroGraphicModuleDataLazyQuery>;
export type GetHeroGraphicModuleDataQueryResult = Apollo.QueryResult<GetHeroGraphicModuleDataQuery, GetHeroGraphicModuleDataQueryVariables>;
export const GetHomeLoansDashboardPageDataDocument = gql `
    query GetHomeLoansDashboardPageData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
        }
    }
`;
/**
 * __useGetHomeLoansDashboardPageDataQuery__
 *
 * To run a query within a React component, call `useGetHomeLoansDashboardPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeLoansDashboardPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeLoansDashboardPageDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHomeLoansDashboardPageDataQuery(baseOptions: Apollo.QueryHookOptions<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>(GetHomeLoansDashboardPageDataDocument, options);
}
export function useGetHomeLoansDashboardPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>(GetHomeLoansDashboardPageDataDocument, options);
}
export type GetHomeLoansDashboardPageDataQueryHookResult = ReturnType<typeof useGetHomeLoansDashboardPageDataQuery>;
export type GetHomeLoansDashboardPageDataLazyQueryHookResult = ReturnType<typeof useGetHomeLoansDashboardPageDataLazyQuery>;
export type GetHomeLoansDashboardPageDataQueryResult = Apollo.QueryResult<GetHomeLoansDashboardPageDataQuery, GetHomeLoansDashboardPageDataQueryVariables>;
export const GetNavbarURLDocument = gql `
    query GetNavbarURL {
        zhlMACExperience {
            dashboardURL
        }
    }
`;
/**
 * __useGetNavbarURLQuery__
 *
 * To run a query within a React component, call `useGetNavbarURLQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNavbarURLQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNavbarURLQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNavbarURLQuery(baseOptions?: Apollo.QueryHookOptions<GetNavbarURLQuery, GetNavbarURLQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetNavbarURLQuery, GetNavbarURLQueryVariables>(GetNavbarURLDocument, options);
}
export function useGetNavbarURLLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNavbarURLQuery, GetNavbarURLQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetNavbarURLQuery, GetNavbarURLQueryVariables>(GetNavbarURLDocument, options);
}
export type GetNavbarURLQueryHookResult = ReturnType<typeof useGetNavbarURLQuery>;
export type GetNavbarURLLazyQueryHookResult = ReturnType<typeof useGetNavbarURLLazyQuery>;
export type GetNavbarURLQueryResult = Apollo.QueryResult<GetNavbarURLQuery, GetNavbarURLQueryVariables>;
export const GetPersonalizedNextStepsDocument = gql `
    query GetPersonalizedNextSteps($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
        }
    }
`;
/**
 * __useGetPersonalizedNextStepsQuery__
 *
 * To run a query within a React component, call `useGetPersonalizedNextStepsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPersonalizedNextStepsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPersonalizedNextStepsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPersonalizedNextStepsQuery(baseOptions: Apollo.QueryHookOptions<GetPersonalizedNextStepsQuery, GetPersonalizedNextStepsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetPersonalizedNextStepsQuery, GetPersonalizedNextStepsQueryVariables>(GetPersonalizedNextStepsDocument, options);
}
export function useGetPersonalizedNextStepsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPersonalizedNextStepsQuery, GetPersonalizedNextStepsQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetPersonalizedNextStepsQuery, GetPersonalizedNextStepsQueryVariables>(GetPersonalizedNextStepsDocument, options);
}
export type GetPersonalizedNextStepsQueryHookResult = ReturnType<typeof useGetPersonalizedNextStepsQuery>;
export type GetPersonalizedNextStepsLazyQueryHookResult = ReturnType<typeof useGetPersonalizedNextStepsLazyQuery>;
export type GetPersonalizedNextStepsQueryResult = Apollo.QueryResult<GetPersonalizedNextStepsQuery, GetPersonalizedNextStepsQueryVariables>;
export const GetResourceCardModuleDataDocument = gql `
    query GetResourceCardModuleData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
            preApprovalLetterURL {
                downloadURL
                documentURL
            }
        }
    }
`;
/**
 * __useGetResourceCardModuleDataQuery__
 *
 * To run a query within a React component, call `useGetResourceCardModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetResourceCardModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetResourceCardModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetResourceCardModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>(GetResourceCardModuleDataDocument, options);
}
export function useGetResourceCardModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>(GetResourceCardModuleDataDocument, options);
}
export type GetResourceCardModuleDataQueryHookResult = ReturnType<typeof useGetResourceCardModuleDataQuery>;
export type GetResourceCardModuleDataLazyQueryHookResult = ReturnType<typeof useGetResourceCardModuleDataLazyQuery>;
export type GetResourceCardModuleDataQueryResult = Apollo.QueryResult<GetResourceCardModuleDataQuery, GetResourceCardModuleDataQueryVariables>;
export const GetTeamInformationCardModuleDataDocument = gql `
    query GetTeamInformationCardModuleData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
            loanOfficer {
                ...LoanOfficer
            }
            loanProcessor {
                ...LoanProcessor
            }
        }
    }
    ${LoanOfficerFragmentDoc}
    ${LoanProcessorFragmentDoc}
`;
/**
 * __useGetTeamInformationCardModuleDataQuery__
 *
 * To run a query within a React component, call `useGetTeamInformationCardModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamInformationCardModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamInformationCardModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTeamInformationCardModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetTeamInformationCardModuleDataQuery, GetTeamInformationCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetTeamInformationCardModuleDataQuery, GetTeamInformationCardModuleDataQueryVariables>(GetTeamInformationCardModuleDataDocument, options);
}
export function useGetTeamInformationCardModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamInformationCardModuleDataQuery, GetTeamInformationCardModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetTeamInformationCardModuleDataQuery, GetTeamInformationCardModuleDataQueryVariables>(GetTeamInformationCardModuleDataDocument, options);
}
export type GetTeamInformationCardModuleDataQueryHookResult = ReturnType<typeof useGetTeamInformationCardModuleDataQuery>;
export type GetTeamInformationCardModuleDataLazyQueryHookResult = ReturnType<typeof useGetTeamInformationCardModuleDataLazyQuery>;
export type GetTeamInformationCardModuleDataQueryResult = Apollo.QueryResult<GetTeamInformationCardModuleDataQuery, GetTeamInformationCardModuleDataQueryVariables>;
export const GetUpsellModuleDataDocument = gql `
    query GetUpsellModuleData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
                loanApplicationExperienceURL
                loanId
                steps {
                    title
                    status
                }
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
            attributes {
                valuation
                purchaseLocation {
                    street
                }
            }
            preApprovalLetterURL {
                downloadURL
                documentURL
            }
        }
    }
`;
/**
 * __useGetUpsellModuleDataQuery__
 *
 * To run a query within a React component, call `useGetUpsellModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpsellModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpsellModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUpsellModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>(GetUpsellModuleDataDocument, options);
}
export function useGetUpsellModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>(GetUpsellModuleDataDocument, options);
}
export type GetUpsellModuleDataQueryHookResult = ReturnType<typeof useGetUpsellModuleDataQuery>;
export type GetUpsellModuleDataLazyQueryHookResult = ReturnType<typeof useGetUpsellModuleDataLazyQuery>;
export type GetUpsellModuleDataQueryResult = Apollo.QueryResult<GetUpsellModuleDataQuery, GetUpsellModuleDataQueryVariables>;
export const GetViewSavedInformationModuleDataDocument = gql `
    query GetViewSavedInformationModuleData($id: ID!) {
        homeLoansDashboard {
            personalizedNextSteps(zhlLoanId: $id, version: V2) {
                currentState
                loanId
                loanApplicationExperienceURL
            }
        }
        zhlLoan(zhlLoanId: $id) {
            id
            lead {
                id
            }
        }
    }
`;
/**
 * __useGetViewSavedInformationModuleDataQuery__
 *
 * To run a query within a React component, call `useGetViewSavedInformationModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetViewSavedInformationModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetViewSavedInformationModuleDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetViewSavedInformationModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>(GetViewSavedInformationModuleDataDocument, options);
}
export function useGetViewSavedInformationModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>(GetViewSavedInformationModuleDataDocument, options);
}
export type GetViewSavedInformationModuleDataQueryHookResult = ReturnType<typeof useGetViewSavedInformationModuleDataQuery>;
export type GetViewSavedInformationModuleDataLazyQueryHookResult = ReturnType<typeof useGetViewSavedInformationModuleDataLazyQuery>;
export type GetViewSavedInformationModuleDataQueryResult = Apollo.QueryResult<GetViewSavedInformationModuleDataQuery, GetViewSavedInformationModuleDataQueryVariables>;
export const GetWelcomeBannerModuleDataDocument = gql `
    query GetWelcomeBannerModuleData($loanID: ID!) {
        currentZHLBorrower(zhlLoanId: $loanID) {
            id
            attributes {
                names {
                    first
                    last
                }
                email
            }
        }
    }
`;
/**
 * __useGetWelcomeBannerModuleDataQuery__
 *
 * To run a query within a React component, call `useGetWelcomeBannerModuleDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWelcomeBannerModuleDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWelcomeBannerModuleDataQuery({
 *   variables: {
 *      loanID: // value for 'loanID'
 *   },
 * });
 */
export function useGetWelcomeBannerModuleDataQuery(baseOptions: Apollo.QueryHookOptions<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useQuery<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>(GetWelcomeBannerModuleDataDocument, options);
}
export function useGetWelcomeBannerModuleDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useLazyQuery<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>(GetWelcomeBannerModuleDataDocument, options);
}
export type GetWelcomeBannerModuleDataQueryHookResult = ReturnType<typeof useGetWelcomeBannerModuleDataQuery>;
export type GetWelcomeBannerModuleDataLazyQueryHookResult = ReturnType<typeof useGetWelcomeBannerModuleDataLazyQuery>;
export type GetWelcomeBannerModuleDataQueryResult = Apollo.QueryResult<GetWelcomeBannerModuleDataQuery, GetWelcomeBannerModuleDataQueryVariables>;
